!(function () {
  var e = {
    711: function (e) {
      e.exports = (function (e) {
        function t(r) {
          if (n[r]) return n[r].exports;
          var i = (n[r] = { exports: {}, id: r, loaded: !1 });
          return (
            e[r].call(i.exports, i, i.exports, t), (i.loaded = !0), i.exports
          );
        }
        var n = {};
        return (t.m = e), (t.c = n), (t.p = "dist/"), t(0);
      })([
        function (e, t, n) {
          "use strict";
          function r(e) {
            return e && e.__esModule ? e : { default: e };
          }
          var i =
            Object.assign ||
            function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var r in n)
                  Object.prototype.hasOwnProperty.call(n, r) &&
                    (e[r] = n[r]);
              }
              return e;
            },
            s = (r(n(1)), n(6)),
            o = r(s),
            a = r(n(7)),
            l = r(n(8)),
            c = r(n(9)),
            u = r(n(10)),
            d = r(n(11)),
            p = r(n(14)),
            h = [],
            f = !1,
            m = {
              offset: 120,
              delay: 0,
              easing: "ease",
              duration: 400,
              disable: !1,
              once: !1,
              startEvent: "DOMContentLoaded",
              throttleDelay: 99,
              debounceDelay: 50,
              disableMutationObserver: !1,
            },
            v = function () {
              if (
                (arguments.length > 0 &&
                  void 0 !== arguments[0] &&
                  arguments[0] &&
                  (f = !0),
                  f)
              )
                return (
                  (h = (0, d.default)(h, m)), (0, u.default)(h, m.once), h
                );
            },
            g = function () {
              (h = (0, p.default)()), v();
            },
            y = function () {
              h.forEach(function (e, t) {
                e.node.removeAttribute("data-aos"),
                  e.node.removeAttribute("data-aos-easing"),
                  e.node.removeAttribute("data-aos-duration"),
                  e.node.removeAttribute("data-aos-delay");
              });
            },
            b = function (e) {
              return (
                !0 === e ||
                ("mobile" === e && c.default.mobile()) ||
                ("phone" === e && c.default.phone()) ||
                ("tablet" === e && c.default.tablet()) ||
                ("function" == typeof e && !0 === e())
              );
            },
            w = function (e) {
              (m = i(m, e)), (h = (0, p.default)());
              var t = document.all && !window.atob;
              return b(m.disable) || t
                ? y()
                : (m.disableMutationObserver ||
                  l.default.isSupported() ||
                  (console.info(
                    '\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '
                  ),
                    (m.disableMutationObserver = !0)),
                  document
                    .querySelector("body")
                    .setAttribute("data-aos-easing", m.easing),
                  document
                    .querySelector("body")
                    .setAttribute("data-aos-duration", m.duration),
                  document
                    .querySelector("body")
                    .setAttribute("data-aos-delay", m.delay),
                  "DOMContentLoaded" === m.startEvent &&
                    ["complete", "interactive"].indexOf(document.readyState) >
                    -1
                    ? v(!0)
                    : "load" === m.startEvent
                      ? window.addEventListener(m.startEvent, function () {
                        v(!0);
                      })
                      : document.addEventListener(m.startEvent, function () {
                        v(!0);
                      }),
                  window.addEventListener(
                    "resize",
                    (0, a.default)(v, m.debounceDelay, !0)
                  ),
                  window.addEventListener(
                    "orientationchange",
                    (0, a.default)(v, m.debounceDelay, !0)
                  ),
                  window.addEventListener(
                    "scroll",
                    (0, o.default)(function () {
                      (0, u.default)(h, m.once);
                    }, m.throttleDelay)
                  ),
                  m.disableMutationObserver ||
                  l.default.ready("[data-aos]", g),
                  h);
            };
          e.exports = { init: w, refresh: v, refreshHard: g };
        },
        function (e, t) { },
        ,
        ,
        ,
        ,
        function (e, t) {
          (function (t) {
            "use strict";
            function n(e, t, n) {
              function r(t) {
                var n = m,
                  r = v;
                return (m = v = void 0), (S = t), (y = e.apply(r, n));
              }
              function s(e) {
                return (S = e), (b = setTimeout(u, t)), C ? r(e) : y;
              }
              function o(e) {
                var n = t - (e - w);
                return k ? x(n, g - (e - S)) : n;
              }
              function l(e) {
                var n = e - w;
                return void 0 === w || n >= t || n < 0 || (k && e - S >= g);
              }
              function u() {
                var e = T();
                return l(e) ? d(e) : void (b = setTimeout(u, o(e)));
              }
              function d(e) {
                return (b = void 0), O && m ? r(e) : ((m = v = void 0), y);
              }
              function p() {
                void 0 !== b && clearTimeout(b),
                  (S = 0),
                  (m = w = v = b = void 0);
              }
              function h() {
                return void 0 === b ? y : d(T());
              }
              function f() {
                var e = T(),
                  n = l(e);
                if (((m = arguments), (v = this), (w = e), n)) {
                  if (void 0 === b) return s(w);
                  if (k) return (b = setTimeout(u, t)), r(w);
                }
                return void 0 === b && (b = setTimeout(u, t)), y;
              }
              var m,
                v,
                g,
                y,
                b,
                w,
                S = 0,
                C = !1,
                k = !1,
                O = !0;
              if ("function" != typeof e) throw new TypeError(c);
              return (
                (t = a(t) || 0),
                i(n) &&
                ((C = !!n.leading),
                  (g = (k = "maxWait" in n) ? E(a(n.maxWait) || 0, t) : g),
                  (O = "trailing" in n ? !!n.trailing : O)),
                (f.cancel = p),
                (f.flush = h),
                f
              );
            }
            function r(e, t, r) {
              var s = !0,
                o = !0;
              if ("function" != typeof e) throw new TypeError(c);
              return (
                i(r) &&
                ((s = "leading" in r ? !!r.leading : s),
                  (o = "trailing" in r ? !!r.trailing : o)),
                n(e, t, { leading: s, maxWait: t, trailing: o })
              );
            }
            function i(e) {
              var t = void 0 === e ? "undefined" : l(e);
              return !!e && ("object" == t || "function" == t);
            }
            function s(e) {
              return !!e && "object" == (void 0 === e ? "undefined" : l(e));
            }
            function o(e) {
              return (
                "symbol" == (void 0 === e ? "undefined" : l(e)) ||
                (s(e) && w.call(e) == d)
              );
            }
            function a(e) {
              if ("number" == typeof e) return e;
              if (o(e)) return u;
              if (i(e)) {
                var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                e = i(t) ? t + "" : t;
              }
              if ("string" != typeof e) return 0 === e ? e : +e;
              e = e.replace(p, "");
              var n = f.test(e);
              return n || m.test(e)
                ? v(e.slice(2), n ? 2 : 8)
                : h.test(e)
                  ? u
                  : +e;
            }
            var l =
              "function" == typeof Symbol &&
                "symbol" == typeof Symbol.iterator
                ? function (e) {
                  return typeof e;
                }
                : function (e) {
                  return e &&
                    "function" == typeof Symbol &&
                    e.constructor === Symbol &&
                    e !== Symbol.prototype
                    ? "symbol"
                    : typeof e;
                },
              c = "Expected a function",
              u = NaN,
              d = "[object Symbol]",
              p = /^\s+|\s+$/g,
              h = /^[-+]0x[0-9a-f]+$/i,
              f = /^0b[01]+$/i,
              m = /^0o[0-7]+$/i,
              v = parseInt,
              g =
                "object" == (void 0 === t ? "undefined" : l(t)) &&
                t &&
                t.Object === Object &&
                t,
              y =
                "object" ==
                ("undefined" == typeof self ? "undefined" : l(self)) &&
                self &&
                self.Object === Object &&
                self,
              b = g || y || Function("return this")(),
              w = Object.prototype.toString,
              E = Math.max,
              x = Math.min,
              T = function () {
                return b.Date.now();
              };
            e.exports = r;
          }).call(
            t,
            (function () {
              return this;
            })()
          );
        },
        function (e, t) {
          (function (t) {
            "use strict";
            function n(e, t, n) {
              function i(t) {
                var n = m,
                  r = v;
                return (m = v = void 0), (S = t), (y = e.apply(r, n));
              }
              function s(e) {
                return (S = e), (b = setTimeout(u, t)), C ? i(e) : y;
              }
              function a(e) {
                var n = t - (e - T);
                return k ? E(n, g - (e - S)) : n;
              }
              function c(e) {
                var n = e - T;
                return void 0 === T || n >= t || n < 0 || (k && e - S >= g);
              }
              function u() {
                var e = x();
                return c(e) ? d(e) : void (b = setTimeout(u, a(e)));
              }
              function d(e) {
                return (b = void 0), O && m ? i(e) : ((m = v = void 0), y);
              }
              function p() {
                void 0 !== b && clearTimeout(b),
                  (S = 0),
                  (m = T = v = b = void 0);
              }
              function h() {
                return void 0 === b ? y : d(x());
              }
              function f() {
                var e = x(),
                  n = c(e);
                if (((m = arguments), (v = this), (T = e), n)) {
                  if (void 0 === b) return s(T);
                  if (k) return (b = setTimeout(u, t)), i(T);
                }
                return void 0 === b && (b = setTimeout(u, t)), y;
              }
              var m,
                v,
                g,
                y,
                b,
                T,
                S = 0,
                C = !1,
                k = !1,
                O = !0;
              if ("function" != typeof e) throw new TypeError(l);
              return (
                (t = o(t) || 0),
                r(n) &&
                ((C = !!n.leading),
                  (g = (k = "maxWait" in n) ? w(o(n.maxWait) || 0, t) : g),
                  (O = "trailing" in n ? !!n.trailing : O)),
                (f.cancel = p),
                (f.flush = h),
                f
              );
            }
            function r(e) {
              var t = void 0 === e ? "undefined" : a(e);
              return !!e && ("object" == t || "function" == t);
            }
            function i(e) {
              return !!e && "object" == (void 0 === e ? "undefined" : a(e));
            }
            function s(e) {
              return (
                "symbol" == (void 0 === e ? "undefined" : a(e)) ||
                (i(e) && b.call(e) == u)
              );
            }
            function o(e) {
              if ("number" == typeof e) return e;
              if (s(e)) return c;
              if (r(e)) {
                var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                e = r(t) ? t + "" : t;
              }
              if ("string" != typeof e) return 0 === e ? e : +e;
              e = e.replace(d, "");
              var n = h.test(e);
              return n || f.test(e)
                ? m(e.slice(2), n ? 2 : 8)
                : p.test(e)
                  ? c
                  : +e;
            }
            var a =
              "function" == typeof Symbol &&
                "symbol" == typeof Symbol.iterator
                ? function (e) {
                  return typeof e;
                }
                : function (e) {
                  return e &&
                    "function" == typeof Symbol &&
                    e.constructor === Symbol &&
                    e !== Symbol.prototype
                    ? "symbol"
                    : typeof e;
                },
              l = "Expected a function",
              c = NaN,
              u = "[object Symbol]",
              d = /^\s+|\s+$/g,
              p = /^[-+]0x[0-9a-f]+$/i,
              h = /^0b[01]+$/i,
              f = /^0o[0-7]+$/i,
              m = parseInt,
              v =
                "object" == (void 0 === t ? "undefined" : a(t)) &&
                t &&
                t.Object === Object &&
                t,
              g =
                "object" ==
                ("undefined" == typeof self ? "undefined" : a(self)) &&
                self &&
                self.Object === Object &&
                self,
              y = v || g || Function("return this")(),
              b = Object.prototype.toString,
              w = Math.max,
              E = Math.min,
              x = function () {
                return y.Date.now();
              };
            e.exports = n;
          }).call(
            t,
            (function () {
              return this;
            })()
          );
        },
        function (e, t) {
          "use strict";
          function n(e) {
            var t = void 0,
              r = void 0;
            for (t = 0; t < e.length; t += 1) {
              if ((r = e[t]).dataset && r.dataset.aos) return !0;
              if (r.children && n(r.children)) return !0;
            }
            return !1;
          }
          function r() {
            return (
              window.MutationObserver ||
              window.WebKitMutationObserver ||
              window.MozMutationObserver
            );
          }
          function i() {
            return !!r();
          }
          function s(e, t) {
            var n = window.document,
              i = new (r())(o);
            (a = t),
              i.observe(n.documentElement, {
                childList: !0,
                subtree: !0,
                removedNodes: !0,
              });
          }
          function o(e) {
            e &&
              e.forEach(function (e) {
                var t = Array.prototype.slice.call(e.addedNodes),
                  r = Array.prototype.slice.call(e.removedNodes);
                if (n(t.concat(r))) return a();
              });
          }
          Object.defineProperty(t, "__esModule", { value: !0 });
          var a = function () { };
          t.default = { isSupported: i, ready: s };
        },
        function (e, t) {
          "use strict";
          function n(e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          }
          function r() {
            return (
              navigator.userAgent || navigator.vendor || window.opera || ""
            );
          }
          Object.defineProperty(t, "__esModule", { value: !0 });
          var i = (function () {
            function e(e, t) {
              for (var n = 0; n < t.length; n++) {
                var r = t[n];
                (r.enumerable = r.enumerable || !1),
                  (r.configurable = !0),
                  "value" in r && (r.writable = !0),
                  Object.defineProperty(e, r.key, r);
              }
            }
            return function (t, n, r) {
              return n && e(t.prototype, n), r && e(t, r), t;
            };
          })(),
            s =
              /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
            o =
              /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
            a =
              /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,
            l =
              /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
            c = (function () {
              function e() {
                n(this, e);
              }
              return (
                i(e, [
                  {
                    key: "phone",
                    value: function () {
                      var e = r();
                      return !(!s.test(e) && !o.test(e.substr(0, 4)));
                    },
                  },
                  {
                    key: "mobile",
                    value: function () {
                      var e = r();
                      return !(!a.test(e) && !l.test(e.substr(0, 4)));
                    },
                  },
                  {
                    key: "tablet",
                    value: function () {
                      return this.mobile() && !this.phone();
                    },
                  },
                ]),
                e
              );
            })();
          t.default = new c();
        },
        function (e, t) {
          "use strict";
          Object.defineProperty(t, "__esModule", { value: !0 });
          var n = function (e, t, n) {
            var r = e.node.getAttribute("data-aos-once");
            t > e.position
              ? e.node.classList.add("aos-animate")
              : void 0 !== r &&
              ("false" === r || (!n && "true" !== r)) &&
              e.node.classList.remove("aos-animate");
          },
            r = function (e, t) {
              var r = window.pageYOffset,
                i = window.innerHeight;
              e.forEach(function (e, s) {
                n(e, i + r, t);
              });
            };
          t.default = r;
        },
        function (e, t, n) {
          "use strict";
          function r(e) {
            return e && e.__esModule ? e : { default: e };
          }
          Object.defineProperty(t, "__esModule", { value: !0 });
          var i = r(n(12)),
            s = function (e, t) {
              return (
                e.forEach(function (e, n) {
                  e.node.classList.add("aos-init"),
                    (e.position = (0, i.default)(e.node, t.offset));
                }),
                e
              );
            };
          t.default = s;
        },
        function (e, t, n) {
          "use strict";
          function r(e) {
            return e && e.__esModule ? e : { default: e };
          }
          Object.defineProperty(t, "__esModule", { value: !0 });
          var i = r(n(13)),
            s = function (e, t) {
              var n = 0,
                r = 0,
                s = window.innerHeight,
                o = {
                  offset: e.getAttribute("data-aos-offset"),
                  anchor: e.getAttribute("data-aos-anchor"),
                  anchorPlacement: e.getAttribute(
                    "data-aos-anchor-placement"
                  ),
                };
              switch (
              (o.offset && !isNaN(o.offset) && (r = parseInt(o.offset)),
                o.anchor &&
                document.querySelectorAll(o.anchor) &&
                (e = document.querySelectorAll(o.anchor)[0]),
                (n = (0, i.default)(e).top),
                o.anchorPlacement)
              ) {
                case "top-bottom":
                  break;
                case "center-bottom":
                  n += e.offsetHeight / 2;
                  break;
                case "bottom-bottom":
                  n += e.offsetHeight;
                  break;
                case "top-center":
                  n += s / 2;
                  break;
                case "bottom-center":
                  n += s / 2 + e.offsetHeight;
                  break;
                case "center-center":
                  n += s / 2 + e.offsetHeight / 2;
                  break;
                case "top-top":
                  n += s;
                  break;
                case "bottom-top":
                  n += e.offsetHeight + s;
                  break;
                case "center-top":
                  n += e.offsetHeight / 2 + s;
              }
              return (
                o.anchorPlacement || o.offset || isNaN(t) || (r = t), n + r
              );
            };
          t.default = s;
        },
        function (e, t) {
          "use strict";
          Object.defineProperty(t, "__esModule", { value: !0 });
          var n = function (e) {
            for (
              var t = 0, n = 0;
              e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);

            )
              (t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0)),
                (n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0)),
                (e = e.offsetParent);
            return { top: n, left: t };
          };
          t.default = n;
        },
        function (e, t) {
          "use strict";
          Object.defineProperty(t, "__esModule", { value: !0 });
          var n = function (e) {
            return (
              (e = e || document.querySelectorAll("[data-aos]")),
              Array.prototype.map.call(e, function (e) {
                return { node: e };
              })
            );
          };
          t.default = n;
        },
      ]);
    },
    669: function (e, t, n) {
      e.exports = n(609);
    },
    448: function (e, t, n) {
      "use strict";
      var r = n(867),
        i = n(26),
        s = n(372),
        o = n(327),
        a = n(97),
        l = n(109),
        c = n(985),
        u = n(874),
        d = n(648),
        p = n(644),
        h = n(205);
      e.exports = function (e) {
        return new Promise(function (t, n) {
          var f,
            m = e.data,
            v = e.headers,
            g = e.responseType;
          function y() {
            e.cancelToken && e.cancelToken.unsubscribe(f),
              e.signal && e.signal.removeEventListener("abort", f);
          }
          r.isFormData(m) &&
            r.isStandardBrowserEnv() &&
            delete v["Content-Type"];
          var b = new XMLHttpRequest();
          if (e.auth) {
            var w = e.auth.username || "",
              E = e.auth.password
                ? unescape(encodeURIComponent(e.auth.password))
                : "";
            v.Authorization = "Basic " + btoa(w + ":" + E);
          }
          var x = a(e.baseURL, e.url);
          function T() {
            if (b) {
              var r =
                "getAllResponseHeaders" in b
                  ? l(b.getAllResponseHeaders())
                  : null,
                s = {
                  data:
                    g && "text" !== g && "json" !== g
                      ? b.response
                      : b.responseText,
                  status: b.status,
                  statusText: b.statusText,
                  headers: r,
                  config: e,
                  request: b,
                };
              i(
                function (e) {
                  t(e), y();
                },
                function (e) {
                  n(e), y();
                },
                s
              ),
                (b = null);
            }
          }
          if (
            (b.open(
              e.method.toUpperCase(),
              o(x, e.params, e.paramsSerializer),
              !0
            ),
              (b.timeout = e.timeout),
              "onloadend" in b
                ? (b.onloadend = T)
                : (b.onreadystatechange = function () {
                  b &&
                    4 === b.readyState &&
                    (0 !== b.status ||
                      (b.responseURL &&
                        0 === b.responseURL.indexOf("file:"))) &&
                    setTimeout(T);
                }),
              (b.onabort = function () {
                b &&
                  (n(new d("Request aborted", d.ECONNABORTED, e, b)),
                    (b = null));
              }),
              (b.onerror = function () {
                n(new d("Network Error", d.ERR_NETWORK, e, b, b)), (b = null);
              }),
              (b.ontimeout = function () {
                var t = e.timeout
                  ? "timeout of " + e.timeout + "ms exceeded"
                  : "timeout exceeded",
                  r = e.transitional || u;
                e.timeoutErrorMessage && (t = e.timeoutErrorMessage),
                  n(
                    new d(
                      t,
                      r.clarifyTimeoutError ? d.ETIMEDOUT : d.ECONNABORTED,
                      e,
                      b
                    )
                  ),
                  (b = null);
              }),
              r.isStandardBrowserEnv())
          ) {
            var S =
              (e.withCredentials || c(x)) && e.xsrfCookieName
                ? s.read(e.xsrfCookieName)
                : void 0;
            S && (v[e.xsrfHeaderName] = S);
          }
          "setRequestHeader" in b &&
            r.forEach(v, function (e, t) {
              void 0 === m && "content-type" === t.toLowerCase()
                ? delete v[t]
                : b.setRequestHeader(t, e);
            }),
            r.isUndefined(e.withCredentials) ||
            (b.withCredentials = !!e.withCredentials),
            g && "json" !== g && (b.responseType = e.responseType),
            "function" == typeof e.onDownloadProgress &&
            b.addEventListener("progress", e.onDownloadProgress),
            "function" == typeof e.onUploadProgress &&
            b.upload &&
            b.upload.addEventListener("progress", e.onUploadProgress),
            (e.cancelToken || e.signal) &&
            ((f = function (e) {
              b &&
                (n(!e || (e && e.type) ? new p() : e),
                  b.abort(),
                  (b = null));
            }),
              e.cancelToken && e.cancelToken.subscribe(f),
              e.signal &&
              (e.signal.aborted
                ? f()
                : e.signal.addEventListener("abort", f))),
            m || (m = null);
          var C = h(x);
          C && -1 === ["http", "https", "file"].indexOf(C)
            ? n(
              new d("Unsupported protocol " + C + ":", d.ERR_BAD_REQUEST, e)
            )
            : b.send(m);
        });
      };
    },
    609: function (e, t, n) {
      "use strict";
      var r = n(867),
        i = n(849),
        s = n(321),
        o = n(185);
      var a = (function e(t) {
        var n = new s(t),
          a = i(s.prototype.request, n);
        return (
          r.extend(a, s.prototype, n),
          r.extend(a, n),
          (a.create = function (n) {
            return e(o(t, n));
          }),
          a
        );
      })(n(546));
      (a.Axios = s),
        (a.CanceledError = n(644)),
        (a.CancelToken = n(972)),
        (a.isCancel = n(502)),
        (a.VERSION = n(288).version),
        (a.toFormData = n(675)),
        (a.AxiosError = n(648)),
        (a.Cancel = a.CanceledError),
        (a.all = function (e) {
          return Promise.all(e);
        }),
        (a.spread = n(713)),
        (a.isAxiosError = n(268)),
        (e.exports = a),
        (e.exports.default = a);
    },
    972: function (e, t, n) {
      "use strict";
      var r = n(644);
      function i(e) {
        if ("function" != typeof e)
          throw new TypeError("executor must be a function.");
        var t;
        this.promise = new Promise(function (e) {
          t = e;
        });
        var n = this;
        this.promise.then(function (e) {
          if (n._listeners) {
            var t,
              r = n._listeners.length;
            for (t = 0; t < r; t++) n._listeners[t](e);
            n._listeners = null;
          }
        }),
          (this.promise.then = function (e) {
            var t,
              r = new Promise(function (e) {
                n.subscribe(e), (t = e);
              }).then(e);
            return (
              (r.cancel = function () {
                n.unsubscribe(t);
              }),
              r
            );
          }),
          e(function (e) {
            n.reason || ((n.reason = new r(e)), t(n.reason));
          });
      }
      (i.prototype.throwIfRequested = function () {
        if (this.reason) throw this.reason;
      }),
        (i.prototype.subscribe = function (e) {
          this.reason
            ? e(this.reason)
            : this._listeners
              ? this._listeners.push(e)
              : (this._listeners = [e]);
        }),
        (i.prototype.unsubscribe = function (e) {
          if (this._listeners) {
            var t = this._listeners.indexOf(e);
            -1 !== t && this._listeners.splice(t, 1);
          }
        }),
        (i.source = function () {
          var e;
          return {
            token: new i(function (t) {
              e = t;
            }),
            cancel: e,
          };
        }),
        (e.exports = i);
    },
    644: function (e, t, n) {
      "use strict";
      var r = n(648);
      function i(e) {
        r.call(this, null == e ? "canceled" : e, r.ERR_CANCELED),
          (this.name = "CanceledError");
      }
      n(867).inherits(i, r, { __CANCEL__: !0 }), (e.exports = i);
    },
    502: function (e) {
      "use strict";
      e.exports = function (e) {
        return !(!e || !e.__CANCEL__);
      };
    },
    321: function (e, t, n) {
      "use strict";
      var r = n(867),
        i = n(327),
        s = n(782),
        o = n(572),
        a = n(185),
        l = n(97),
        c = n(875),
        u = c.validators;
      function d(e) {
        (this.defaults = e),
          (this.interceptors = { request: new s(), response: new s() });
      }
      (d.prototype.request = function (e, t) {
        "string" == typeof e ? ((t = t || {}).url = e) : (t = e || {}),
          (t = a(this.defaults, t)).method
            ? (t.method = t.method.toLowerCase())
            : this.defaults.method
              ? (t.method = this.defaults.method.toLowerCase())
              : (t.method = "get");
        var n = t.transitional;
        void 0 !== n &&
          c.assertOptions(
            n,
            {
              silentJSONParsing: u.transitional(u.boolean),
              forcedJSONParsing: u.transitional(u.boolean),
              clarifyTimeoutError: u.transitional(u.boolean),
            },
            !1
          );
        var r = [],
          i = !0;
        this.interceptors.request.forEach(function (e) {
          ("function" == typeof e.runWhen && !1 === e.runWhen(t)) ||
            ((i = i && e.synchronous), r.unshift(e.fulfilled, e.rejected));
        });
        var s,
          l = [];
        if (
          (this.interceptors.response.forEach(function (e) {
            l.push(e.fulfilled, e.rejected);
          }),
            !i)
        ) {
          var d = [o, void 0];
          for (
            Array.prototype.unshift.apply(d, r),
            d = d.concat(l),
            s = Promise.resolve(t);
            d.length;

          )
            s = s.then(d.shift(), d.shift());
          return s;
        }
        for (var p = t; r.length;) {
          var h = r.shift(),
            f = r.shift();
          try {
            p = h(p);
          } catch (e) {
            f(e);
            break;
          }
        }
        try {
          s = o(p);
        } catch (e) {
          return Promise.reject(e);
        }
        for (; l.length;) s = s.then(l.shift(), l.shift());
        return s;
      }),
        (d.prototype.getUri = function (e) {
          e = a(this.defaults, e);
          var t = l(e.baseURL, e.url);
          return i(t, e.params, e.paramsSerializer);
        }),
        r.forEach(["delete", "get", "head", "options"], function (e) {
          d.prototype[e] = function (t, n) {
            return this.request(
              a(n || {}, { method: e, url: t, data: (n || {}).data })
            );
          };
        }),
        r.forEach(["post", "put", "patch"], function (e) {
          function t(t) {
            return function (n, r, i) {
              return this.request(
                a(i || {}, {
                  method: e,
                  headers: t ? { "Content-Type": "multipart/form-data" } : {},
                  url: n,
                  data: r,
                })
              );
            };
          }
          (d.prototype[e] = t()), (d.prototype[e + "Form"] = t(!0));
        }),
        (e.exports = d);
    },
    648: function (e, t, n) {
      "use strict";
      var r = n(867);
      function i(e, t, n, r, i) {
        Error.call(this),
          (this.message = e),
          (this.name = "AxiosError"),
          t && (this.code = t),
          n && (this.config = n),
          r && (this.request = r),
          i && (this.response = i);
      }
      r.inherits(i, Error, {
        toJSON: function () {
          return {
            message: this.message,
            name: this.name,
            description: this.description,
            number: this.number,
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            config: this.config,
            code: this.code,
            status:
              this.response && this.response.status
                ? this.response.status
                : null,
          };
        },
      });
      var s = i.prototype,
        o = {};
      [
        "ERR_BAD_OPTION_VALUE",
        "ERR_BAD_OPTION",
        "ECONNABORTED",
        "ETIMEDOUT",
        "ERR_NETWORK",
        "ERR_FR_TOO_MANY_REDIRECTS",
        "ERR_DEPRECATED",
        "ERR_BAD_RESPONSE",
        "ERR_BAD_REQUEST",
        "ERR_CANCELED",
      ].forEach(function (e) {
        o[e] = { value: e };
      }),
        Object.defineProperties(i, o),
        Object.defineProperty(s, "isAxiosError", { value: !0 }),
        (i.from = function (e, t, n, o, a, l) {
          var c = Object.create(s);
          return (
            r.toFlatObject(e, c, function (e) {
              return e !== Error.prototype;
            }),
            i.call(c, e.message, t, n, o, a),
            (c.name = e.name),
            l && Object.assign(c, l),
            c
          );
        }),
        (e.exports = i);
    },
    782: function (e, t, n) {
      "use strict";
      var r = n(867);
      function i() {
        this.handlers = [];
      }
      (i.prototype.use = function (e, t, n) {
        return (
          this.handlers.push({
            fulfilled: e,
            rejected: t,
            synchronous: !!n && n.synchronous,
            runWhen: n ? n.runWhen : null,
          }),
          this.handlers.length - 1
        );
      }),
        (i.prototype.eject = function (e) {
          this.handlers[e] && (this.handlers[e] = null);
        }),
        (i.prototype.forEach = function (e) {
          r.forEach(this.handlers, function (t) {
            null !== t && e(t);
          });
        }),
        (e.exports = i);
    },
    97: function (e, t, n) {
      "use strict";
      var r = n(793),
        i = n(303);
      e.exports = function (e, t) {
        return e && !r(t) ? i(e, t) : t;
      };
    },
    572: function (e, t, n) {
      "use strict";
      var r = n(867),
        i = n(527),
        s = n(502),
        o = n(546),
        a = n(644);
      function l(e) {
        if (
          (e.cancelToken && e.cancelToken.throwIfRequested(),
            e.signal && e.signal.aborted)
        )
          throw new a();
      }
      e.exports = function (e) {
        return (
          l(e),
          (e.headers = e.headers || {}),
          (e.data = i.call(e, e.data, e.headers, e.transformRequest)),
          (e.headers = r.merge(
            e.headers.common || {},
            e.headers[e.method] || {},
            e.headers
          )),
          r.forEach(
            ["delete", "get", "head", "post", "put", "patch", "common"],
            function (t) {
              delete e.headers[t];
            }
          ),
          (e.adapter || o.adapter)(e).then(
            function (t) {
              return (
                l(e),
                (t.data = i.call(e, t.data, t.headers, e.transformResponse)),
                t
              );
            },
            function (t) {
              return (
                s(t) ||
                (l(e),
                  t &&
                  t.response &&
                  (t.response.data = i.call(
                    e,
                    t.response.data,
                    t.response.headers,
                    e.transformResponse
                  ))),
                Promise.reject(t)
              );
            }
          )
        );
      };
    },
    185: function (e, t, n) {
      "use strict";
      var r = n(867);
      e.exports = function (e, t) {
        t = t || {};
        var n = {};
        function i(e, t) {
          return r.isPlainObject(e) && r.isPlainObject(t)
            ? r.merge(e, t)
            : r.isPlainObject(t)
              ? r.merge({}, t)
              : r.isArray(t)
                ? t.slice()
                : t;
        }
        function s(n) {
          return r.isUndefined(t[n])
            ? r.isUndefined(e[n])
              ? void 0
              : i(void 0, e[n])
            : i(e[n], t[n]);
        }
        function o(e) {
          if (!r.isUndefined(t[e])) return i(void 0, t[e]);
        }
        function a(n) {
          return r.isUndefined(t[n])
            ? r.isUndefined(e[n])
              ? void 0
              : i(void 0, e[n])
            : i(void 0, t[n]);
        }
        function l(n) {
          return n in t ? i(e[n], t[n]) : n in e ? i(void 0, e[n]) : void 0;
        }
        var c = {
          url: o,
          method: o,
          data: o,
          baseURL: a,
          transformRequest: a,
          transformResponse: a,
          paramsSerializer: a,
          timeout: a,
          timeoutMessage: a,
          withCredentials: a,
          adapter: a,
          responseType: a,
          xsrfCookieName: a,
          xsrfHeaderName: a,
          onUploadProgress: a,
          onDownloadProgress: a,
          decompress: a,
          maxContentLength: a,
          maxBodyLength: a,
          beforeRedirect: a,
          transport: a,
          httpAgent: a,
          httpsAgent: a,
          cancelToken: a,
          socketPath: a,
          responseEncoding: a,
          validateStatus: l,
        };
        return (
          r.forEach(Object.keys(e).concat(Object.keys(t)), function (e) {
            var t = c[e] || s,
              i = t(e);
            (r.isUndefined(i) && t !== l) || (n[e] = i);
          }),
          n
        );
      };
    },
    26: function (e, t, n) {
      "use strict";
      var r = n(648);
      e.exports = function (e, t, n) {
        var i = n.config.validateStatus;
        n.status && i && !i(n.status)
          ? t(
            new r(
              "Request failed with status code " + n.status,
              [r.ERR_BAD_REQUEST, r.ERR_BAD_RESPONSE][
              Math.floor(n.status / 100) - 4
              ],
              n.config,
              n.request,
              n
            )
          )
          : e(n);
      };
    },
    527: function (e, t, n) {
      "use strict";
      var r = n(867),
        i = n(546);
      e.exports = function (e, t, n) {
        var s = this || i;
        return (
          r.forEach(n, function (n) {
            e = n.call(s, e, t);
          }),
          e
        );
      };
    },
    546: function (e, t, n) {
      "use strict";
      var r = n(867),
        i = n(16),
        s = n(648),
        o = n(874),
        a = n(675),
        l = { "Content-Type": "application/x-www-form-urlencoded" };
      function c(e, t) {
        !r.isUndefined(e) &&
          r.isUndefined(e["Content-Type"]) &&
          (e["Content-Type"] = t);
      }
      var u,
        d = {
          transitional: o,
          adapter:
            (("undefined" != typeof XMLHttpRequest ||
              ("undefined" != typeof process &&
                "[object process]" ===
                Object.prototype.toString.call(process))) &&
              (u = n(448)),
              u),
          transformRequest: [
            function (e, t) {
              if (
                (i(t, "Accept"),
                  i(t, "Content-Type"),
                  r.isFormData(e) ||
                  r.isArrayBuffer(e) ||
                  r.isBuffer(e) ||
                  r.isStream(e) ||
                  r.isFile(e) ||
                  r.isBlob(e))
              )
                return e;
              if (r.isArrayBufferView(e)) return e.buffer;
              if (r.isURLSearchParams(e))
                return (
                  c(t, "application/x-www-form-urlencoded;charset=utf-8"),
                  e.toString()
                );
              var n,
                s = r.isObject(e),
                o = t && t["Content-Type"];
              if (
                (n = r.isFileList(e)) ||
                (s && "multipart/form-data" === o)
              ) {
                var l = this.env && this.env.FormData;
                return a(n ? { "files[]": e } : e, l && new l());
              }
              return s || "application/json" === o
                ? (c(t, "application/json"),
                  (function (e, t, n) {
                    if (r.isString(e))
                      try {
                        return (t || JSON.parse)(e), r.trim(e);
                      } catch (e) {
                        if ("SyntaxError" !== e.name) throw e;
                      }
                    return (n || JSON.stringify)(e);
                  })(e))
                : e;
            },
          ],
          transformResponse: [
            function (e) {
              var t = this.transitional || d.transitional,
                n = t && t.silentJSONParsing,
                i = t && t.forcedJSONParsing,
                o = !n && "json" === this.responseType;
              if (o || (i && r.isString(e) && e.length))
                try {
                  return JSON.parse(e);
                } catch (e) {
                  if (o) {
                    if ("SyntaxError" === e.name)
                      throw s.from(
                        e,
                        s.ERR_BAD_RESPONSE,
                        this,
                        null,
                        this.response
                      );
                    throw e;
                  }
                }
              return e;
            },
          ],
          timeout: 0,
          xsrfCookieName: "XSRF-TOKEN",
          xsrfHeaderName: "X-XSRF-TOKEN",
          maxContentLength: -1,
          maxBodyLength: -1,
          env: { FormData: n(623) },
          validateStatus: function (e) {
            return e >= 200 && e < 300;
          },
          headers: {
            common: { Accept: "application/json, text/plain, */*" },
          },
        };
      r.forEach(["delete", "get", "head"], function (e) {
        d.headers[e] = {};
      }),
        r.forEach(["post", "put", "patch"], function (e) {
          d.headers[e] = r.merge(l);
        }),
        (e.exports = d);
    },
    874: function (e) {
      "use strict";
      e.exports = {
        silentJSONParsing: !0,
        forcedJSONParsing: !0,
        clarifyTimeoutError: !1,
      };
    },
    288: function (e) {
      e.exports = { version: "0.27.2" };
    },
    849: function (e) {
      "use strict";
      e.exports = function (e, t) {
        return function () {
          for (var n = new Array(arguments.length), r = 0; r < n.length; r++)
            n[r] = arguments[r];
          return e.apply(t, n);
        };
      };
    },
    327: function (e, t, n) {
      "use strict";
      var r = n(867);
      function i(e) {
        return encodeURIComponent(e)
          .replace(/%3A/gi, ":")
          .replace(/%24/g, "$")
          .replace(/%2C/gi, ",")
          .replace(/%20/g, "+")
          .replace(/%5B/gi, "[")
          .replace(/%5D/gi, "]");
      }
      e.exports = function (e, t, n) {
        if (!t) return e;
        var s;
        if (n) s = n(t);
        else if (r.isURLSearchParams(t)) s = t.toString();
        else {
          var o = [];
          r.forEach(t, function (e, t) {
            null != e &&
              (r.isArray(e) ? (t += "[]") : (e = [e]),
                r.forEach(e, function (e) {
                  r.isDate(e)
                    ? (e = e.toISOString())
                    : r.isObject(e) && (e = JSON.stringify(e)),
                    o.push(i(t) + "=" + i(e));
                }));
          }),
            (s = o.join("&"));
        }
        if (s) {
          var a = e.indexOf("#");
          -1 !== a && (e = e.slice(0, a)),
            (e += (-1 === e.indexOf("?") ? "?" : "&") + s);
        }
        return e;
      };
    },
    303: function (e) {
      "use strict";
      e.exports = function (e, t) {
        return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
      };
    },
    372: function (e, t, n) {
      "use strict";
      var r = n(867);
      e.exports = r.isStandardBrowserEnv()
        ? {
          write: function (e, t, n, i, s, o) {
            var a = [];
            a.push(e + "=" + encodeURIComponent(t)),
              r.isNumber(n) &&
              a.push("expires=" + new Date(n).toGMTString()),
              r.isString(i) && a.push("path=" + i),
              r.isString(s) && a.push("domain=" + s),
              !0 === o && a.push("secure"),
              (document.cookie = a.join("; "));
          },
          read: function (e) {
            var t = document.cookie.match(
              new RegExp("(^|;\\s*)(" + e + ")=([^;]*)")
            );
            return t ? decodeURIComponent(t[3]) : null;
          },
          remove: function (e) {
            this.write(e, "", Date.now() - 864e5);
          },
        }
        : {
          write: function () { },
          read: function () {
            return null;
          },
          remove: function () { },
        };
    },
    793: function (e) {
      "use strict";
      e.exports = function (e) {
        return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
      };
    },
    268: function (e, t, n) {
      "use strict";
      var r = n(867);
      e.exports = function (e) {
        return r.isObject(e) && !0 === e.isAxiosError;
      };
    },
    985: function (e, t, n) {
      "use strict";
      var r = n(867);
      e.exports = r.isStandardBrowserEnv()
        ? (function () {
          var e,
            t = /(msie|trident)/i.test(navigator.userAgent),
            n = document.createElement("a");
          function i(e) {
            var r = e;
            return (
              t && (n.setAttribute("href", r), (r = n.href)),
              n.setAttribute("href", r),
              {
                href: n.href,
                protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
                host: n.host,
                search: n.search ? n.search.replace(/^\?/, "") : "",
                hash: n.hash ? n.hash.replace(/^#/, "") : "",
                hostname: n.hostname,
                port: n.port,
                pathname:
                  "/" === n.pathname.charAt(0)
                    ? n.pathname
                    : "/" + n.pathname,
              }
            );
          }
          return (
            (e = i(window.location.href)),
            function (t) {
              var n = r.isString(t) ? i(t) : t;
              return n.protocol === e.protocol && n.host === e.host;
            }
          );
        })()
        : function () {
          return !0;
        };
    },
    16: function (e, t, n) {
      "use strict";
      var r = n(867);
      e.exports = function (e, t) {
        r.forEach(e, function (n, r) {
          r !== t &&
            r.toUpperCase() === t.toUpperCase() &&
            ((e[t] = n), delete e[r]);
        });
      };
    },
    623: function (e) {
      e.exports = null;
    },
    109: function (e, t, n) {
      "use strict";
      var r = n(867),
        i = [
          "age",
          "authorization",
          "content-length",
          "content-type",
          "etag",
          "expires",
          "from",
          "host",
          "if-modified-since",
          "if-unmodified-since",
          "last-modified",
          "location",
          "max-forwards",
          "proxy-authorization",
          "referer",
          "retry-after",
          "user-agent",
        ];
      e.exports = function (e) {
        var t,
          n,
          s,
          o = {};
        return e
          ? (r.forEach(e.split("\n"), function (e) {
            if (
              ((s = e.indexOf(":")),
                (t = r.trim(e.substr(0, s)).toLowerCase()),
                (n = r.trim(e.substr(s + 1))),
                t)
            ) {
              if (o[t] && i.indexOf(t) >= 0) return;
              o[t] =
                "set-cookie" === t
                  ? (o[t] ? o[t] : []).concat([n])
                  : o[t]
                    ? o[t] + ", " + n
                    : n;
            }
          }),
            o)
          : o;
      };
    },
    205: function (e) {
      "use strict";
      e.exports = function (e) {
        var t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
        return (t && t[1]) || "";
      };
    },
    713: function (e) {
      "use strict";
      e.exports = function (e) {
        return function (t) {
          return e.apply(null, t);
        };
      };
    },
    675: function (e, t, n) {
      "use strict";
      var r = n(867);
      e.exports = function (e, t) {
        t = t || new FormData();
        var n = [];
        function i(e) {
          return null === e
            ? ""
            : r.isDate(e)
              ? e.toISOString()
              : r.isArrayBuffer(e) || r.isTypedArray(e)
                ? "function" == typeof Blob
                  ? new Blob([e])
                  : Buffer.from(e)
                : e;
        }
        return (
          (function e(s, o) {
            if (r.isPlainObject(s) || r.isArray(s)) {
              if (-1 !== n.indexOf(s))
                throw Error("Circular reference detected in " + o);
              n.push(s),
                r.forEach(s, function (n, s) {
                  if (!r.isUndefined(n)) {
                    var a,
                      l = o ? o + "." + s : s;
                    if (n && !o && "object" == typeof n)
                      if (r.endsWith(s, "{}")) n = JSON.stringify(n);
                      else if (r.endsWith(s, "[]") && (a = r.toArray(n)))
                        return void a.forEach(function (e) {
                          !r.isUndefined(e) && t.append(l, i(e));
                        });
                    e(n, l);
                  }
                }),
                n.pop();
            } else t.append(o, i(s));
          })(e),
          t
        );
      };
    },
    875: function (e, t, n) {
      "use strict";
      var r = n(288).version,
        i = n(648),
        s = {};
      ["object", "boolean", "number", "function", "string", "symbol"].forEach(
        function (e, t) {
          s[e] = function (n) {
            return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
          };
        }
      );
      var o = {};
      (s.transitional = function (e, t, n) {
        function s(e, t) {
          return (
            "[Axios v" +
            r +
            "] Transitional option '" +
            e +
            "'" +
            t +
            (n ? ". " + n : "")
          );
        }
        return function (n, r, a) {
          if (!1 === e)
            throw new i(
              s(r, " has been removed" + (t ? " in " + t : "")),
              i.ERR_DEPRECATED
            );
          return (
            t &&
            !o[r] &&
            ((o[r] = !0),
              console.warn(
                s(
                  r,
                  " has been deprecated since v" +
                  t +
                  " and will be removed in the near future"
                )
              )),
            !e || e(n, r, a)
          );
        };
      }),
        (e.exports = {
          assertOptions: function (e, t, n) {
            if ("object" != typeof e)
              throw new i(
                "options must be an object",
                i.ERR_BAD_OPTION_VALUE
              );
            for (var r = Object.keys(e), s = r.length; s-- > 0;) {
              var o = r[s],
                a = t[o];
              if (a) {
                var l = e[o],
                  c = void 0 === l || a(l, o, e);
                if (!0 !== c)
                  throw new i(
                    "option " + o + " must be " + c,
                    i.ERR_BAD_OPTION_VALUE
                  );
              } else if (!0 !== n)
                throw new i("Unknown option " + o, i.ERR_BAD_OPTION);
            }
          },
          validators: s,
        });
    },
    867: function (e, t, n) {
      "use strict";
      var r,
        i = n(849),
        s = Object.prototype.toString,
        o =
          ((r = Object.create(null)),
            function (e) {
              var t = s.call(e);
              return r[t] || (r[t] = t.slice(8, -1).toLowerCase());
            });
      function a(e) {
        return (
          (e = e.toLowerCase()),
          function (t) {
            return o(t) === e;
          }
        );
      }
      function l(e) {
        return Array.isArray(e);
      }
      function c(e) {
        return void 0 === e;
      }
      var u = a("ArrayBuffer");
      function d(e) {
        return null !== e && "object" == typeof e;
      }
      function p(e) {
        if ("object" !== o(e)) return !1;
        var t = Object.getPrototypeOf(e);
        return null === t || t === Object.prototype;
      }
      var h = a("Date"),
        f = a("File"),
        m = a("Blob"),
        v = a("FileList");
      function g(e) {
        return "[object Function]" === s.call(e);
      }
      var y = a("URLSearchParams");
      function b(e, t) {
        if (null != e)
          if (("object" != typeof e && (e = [e]), l(e)))
            for (var n = 0, r = e.length; n < r; n++)
              t.call(null, e[n], n, e);
          else
            for (var i in e)
              Object.prototype.hasOwnProperty.call(e, i) &&
                t.call(null, e[i], i, e);
      }
      var w,
        E =
          ((w =
            "undefined" != typeof Uint8Array &&
            Object.getPrototypeOf(Uint8Array)),
            function (e) {
              return w && e instanceof w;
            });
      e.exports = {
        isArray: l,
        isArrayBuffer: u,
        isBuffer: function (e) {
          return (
            null !== e &&
            !c(e) &&
            null !== e.constructor &&
            !c(e.constructor) &&
            "function" == typeof e.constructor.isBuffer &&
            e.constructor.isBuffer(e)
          );
        },
        isFormData: function (e) {
          var t = "[object FormData]";
          return (
            e &&
            (("function" == typeof FormData && e instanceof FormData) ||
              s.call(e) === t ||
              (g(e.toString) && e.toString() === t))
          );
        },
        isArrayBufferView: function (e) {
          return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView
            ? ArrayBuffer.isView(e)
            : e && e.buffer && u(e.buffer);
        },
        isString: function (e) {
          return "string" == typeof e;
        },
        isNumber: function (e) {
          return "number" == typeof e;
        },
        isObject: d,
        isPlainObject: p,
        isUndefined: c,
        isDate: h,
        isFile: f,
        isBlob: m,
        isFunction: g,
        isStream: function (e) {
          return d(e) && g(e.pipe);
        },
        isURLSearchParams: y,
        isStandardBrowserEnv: function () {
          return (
            ("undefined" == typeof navigator ||
              ("ReactNative" !== navigator.product &&
                "NativeScript" !== navigator.product &&
                "NS" !== navigator.product)) &&
            "undefined" != typeof window &&
            "undefined" != typeof document
          );
        },
        forEach: b,
        merge: function e() {
          var t = {};
          function n(n, r) {
            p(t[r]) && p(n)
              ? (t[r] = e(t[r], n))
              : p(n)
                ? (t[r] = e({}, n))
                : l(n)
                  ? (t[r] = n.slice())
                  : (t[r] = n);
          }
          for (var r = 0, i = arguments.length; r < i; r++)
            b(arguments[r], n);
          return t;
        },
        extend: function (e, t, n) {
          return (
            b(t, function (t, r) {
              e[r] = n && "function" == typeof t ? i(t, n) : t;
            }),
            e
          );
        },
        trim: function (e) {
          return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
        },
        stripBOM: function (e) {
          return 65279 === e.charCodeAt(0) && (e = e.slice(1)), e;
        },
        inherits: function (e, t, n, r) {
          (e.prototype = Object.create(t.prototype, r)),
            (e.prototype.constructor = e),
            n && Object.assign(e.prototype, n);
        },
        toFlatObject: function (e, t, n) {
          var r,
            i,
            s,
            o = {};
          t = t || {};
          do {
            for (i = (r = Object.getOwnPropertyNames(e)).length; i-- > 0;)
              o[(s = r[i])] || ((t[s] = e[s]), (o[s] = !0));
            e = Object.getPrototypeOf(e);
          } while (e && (!n || n(e, t)) && e !== Object.prototype);
          return t;
        },
        kindOf: o,
        kindOfTest: a,
        endsWith: function (e, t, n) {
          (e = String(e)),
            (void 0 === n || n > e.length) && (n = e.length),
            (n -= t.length);
          var r = e.indexOf(t, n);
          return -1 !== r && r === n;
        },
        toArray: function (e) {
          if (!e) return null;
          var t = e.length;
          if (c(t)) return null;
          for (var n = new Array(t); t-- > 0;) n[t] = e[t];
          return n;
        },
        isTypedArray: E,
        isFileList: v,
      };
    },
    840: function (e, t, n) {
      var r;
      !(function (i, s, o, a) {
        "use strict";
        var l,
          c = ["", "webkit", "Moz", "MS", "ms", "o"],
          u = s.createElement("div"),
          d = "function",
          p = Math.round,
          h = Math.abs,
          f = Date.now;
        function m(e, t, n) {
          return setTimeout(x(e, n), t);
        }
        function v(e, t, n) {
          return !!Array.isArray(e) && (g(e, n[t], n), !0);
        }
        function g(e, t, n) {
          var r;
          if (e)
            if (e.forEach) e.forEach(t, n);
            else if (e.length !== a)
              for (r = 0; r < e.length;) t.call(n, e[r], r, e), r++;
            else for (r in e) e.hasOwnProperty(r) && t.call(n, e[r], r, e);
        }
        function y(e, t, n) {
          var r = "DEPRECATED METHOD: " + t + "\n" + n + " AT \n";
          return function () {
            var t = new Error("get-stack-trace"),
              n =
                t && t.stack
                  ? t.stack
                    .replace(/^[^\(]+?[\n$]/gm, "")
                    .replace(/^\s+at\s+/gm, "")
                    .replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@")
                  : "Unknown Stack Trace",
              s = i.console && (i.console.warn || i.console.log);
            return s && s.call(i.console, r, n), e.apply(this, arguments);
          };
        }
        l =
          "function" != typeof Object.assign
            ? function (e) {
              if (e === a || null === e)
                throw new TypeError(
                  "Cannot convert undefined or null to object"
                );
              for (var t = Object(e), n = 1; n < arguments.length; n++) {
                var r = arguments[n];
                if (r !== a && null !== r)
                  for (var i in r) r.hasOwnProperty(i) && (t[i] = r[i]);
              }
              return t;
            }
            : Object.assign;
        var b = y(
          function (e, t, n) {
            for (var r = Object.keys(t), i = 0; i < r.length;)
              (!n || (n && e[r[i]] === a)) && (e[r[i]] = t[r[i]]), i++;
            return e;
          },
          "extend",
          "Use `assign`."
        ),
          w = y(
            function (e, t) {
              return b(e, t, !0);
            },
            "merge",
            "Use `assign`."
          );
        function E(e, t, n) {
          var r,
            i = t.prototype;
          ((r = e.prototype = Object.create(i)).constructor = e),
            (r._super = i),
            n && l(r, n);
        }
        function x(e, t) {
          return function () {
            return e.apply(t, arguments);
          };
        }
        function T(e, t) {
          return typeof e == d ? e.apply((t && t[0]) || a, t) : e;
        }
        function S(e, t) {
          return e === a ? t : e;
        }
        function C(e, t, n) {
          g(L(t), function (t) {
            e.addEventListener(t, n, !1);
          });
        }
        function k(e, t, n) {
          g(L(t), function (t) {
            e.removeEventListener(t, n, !1);
          });
        }
        function O(e, t) {
          for (; e;) {
            if (e == t) return !0;
            e = e.parentNode;
          }
          return !1;
        }
        function P(e, t) {
          return e.indexOf(t) > -1;
        }
        function L(e) {
          return e.trim().split(/\s+/g);
        }
        function $(e, t, n) {
          if (e.indexOf && !n) return e.indexOf(t);
          for (var r = 0; r < e.length;) {
            if ((n && e[r][n] == t) || (!n && e[r] === t)) return r;
            r++;
          }
          return -1;
        }
        function M(e) {
          return Array.prototype.slice.call(e, 0);
        }
        function A(e, t, n) {
          for (var r = [], i = [], s = 0; s < e.length;) {
            var o = t ? e[s][t] : e[s];
            $(i, o) < 0 && r.push(e[s]), (i[s] = o), s++;
          }
          return (
            n &&
            (r = t
              ? r.sort(function (e, n) {
                return e[t] > n[t];
              })
              : r.sort()),
            r
          );
        }
        function I(e, t) {
          for (
            var n, r, i = t[0].toUpperCase() + t.slice(1), s = 0;
            s < c.length;

          ) {
            if ((r = (n = c[s]) ? n + i : t) in e) return r;
            s++;
          }
          return a;
        }
        var j = 1;
        function _(e) {
          var t = e.ownerDocument || e;
          return t.defaultView || t.parentWindow || i;
        }
        var N = "ontouchstart" in i,
          R = I(i, "PointerEvent") !== a,
          D =
            N &&
            /mobile|tablet|ip(ad|hone|od)|android/i.test(navigator.userAgent),
          z = "touch",
          q = "mouse",
          B = 25,
          F = 1,
          H = 2,
          W = 4,
          Y = 8,
          G = 1,
          X = 2,
          U = 4,
          V = 8,
          K = 16,
          J = X | U,
          Q = V | K,
          Z = J | Q,
          ee = ["x", "y"],
          te = ["clientX", "clientY"];
        function ne(e, t) {
          var n = this;
          (this.manager = e),
            (this.callback = t),
            (this.element = e.element),
            (this.target = e.options.inputTarget),
            (this.domHandler = function (t) {
              T(e.options.enable, [e]) && n.handler(t);
            }),
            this.init();
        }
        function re(e, t, n) {
          var r = n.pointers.length,
            i = n.changedPointers.length,
            s = t & F && r - i == 0,
            o = t & (W | Y) && r - i == 0;
          (n.isFirst = !!s),
            (n.isFinal = !!o),
            s && (e.session = {}),
            (n.eventType = t),
            (function (e, t) {
              var n = e.session,
                r = t.pointers,
                i = r.length;
              n.firstInput || (n.firstInput = ie(t));
              i > 1 && !n.firstMultiple
                ? (n.firstMultiple = ie(t))
                : 1 === i && (n.firstMultiple = !1);
              var s = n.firstInput,
                o = n.firstMultiple,
                l = o ? o.center : s.center,
                c = (t.center = se(r));
              (t.timeStamp = f()),
                (t.deltaTime = t.timeStamp - s.timeStamp),
                (t.angle = ce(l, c)),
                (t.distance = le(l, c)),
                (function (e, t) {
                  var n = t.center,
                    r = e.offsetDelta || {},
                    i = e.prevDelta || {},
                    s = e.prevInput || {};
                  (t.eventType !== F && s.eventType !== W) ||
                    ((i = e.prevDelta =
                      { x: s.deltaX || 0, y: s.deltaY || 0 }),
                      (r = e.offsetDelta = { x: n.x, y: n.y }));
                  (t.deltaX = i.x + (n.x - r.x)),
                    (t.deltaY = i.y + (n.y - r.y));
                })(n, t),
                (t.offsetDirection = ae(t.deltaX, t.deltaY));
              var u = oe(t.deltaTime, t.deltaX, t.deltaY);
              (t.overallVelocityX = u.x),
                (t.overallVelocityY = u.y),
                (t.overallVelocity = h(u.x) > h(u.y) ? u.x : u.y),
                (t.scale = o
                  ? ((d = o.pointers),
                    (p = r),
                    le(p[0], p[1], te) / le(d[0], d[1], te))
                  : 1),
                (t.rotation = o
                  ? (function (e, t) {
                    return ce(t[1], t[0], te) + ce(e[1], e[0], te);
                  })(o.pointers, r)
                  : 0),
                (t.maxPointers = n.prevInput
                  ? t.pointers.length > n.prevInput.maxPointers
                    ? t.pointers.length
                    : n.prevInput.maxPointers
                  : t.pointers.length),
                (function (e, t) {
                  var n,
                    r,
                    i,
                    s,
                    o = e.lastInterval || t,
                    l = t.timeStamp - o.timeStamp;
                  if (t.eventType != Y && (l > B || o.velocity === a)) {
                    var c = t.deltaX - o.deltaX,
                      u = t.deltaY - o.deltaY,
                      d = oe(l, c, u);
                    (r = d.x),
                      (i = d.y),
                      (n = h(d.x) > h(d.y) ? d.x : d.y),
                      (s = ae(c, u)),
                      (e.lastInterval = t);
                  } else
                    (n = o.velocity),
                      (r = o.velocityX),
                      (i = o.velocityY),
                      (s = o.direction);
                  (t.velocity = n),
                    (t.velocityX = r),
                    (t.velocityY = i),
                    (t.direction = s);
                })(n, t);
              var d, p;
              var m = e.element;
              O(t.srcEvent.target, m) && (m = t.srcEvent.target);
              t.target = m;
            })(e, n),
            e.emit("hammer.input", n),
            e.recognize(n),
            (e.session.prevInput = n);
        }
        function ie(e) {
          for (var t = [], n = 0; n < e.pointers.length;)
            (t[n] = {
              clientX: p(e.pointers[n].clientX),
              clientY: p(e.pointers[n].clientY),
            }),
              n++;
          return {
            timeStamp: f(),
            pointers: t,
            center: se(t),
            deltaX: e.deltaX,
            deltaY: e.deltaY,
          };
        }
        function se(e) {
          var t = e.length;
          if (1 === t) return { x: p(e[0].clientX), y: p(e[0].clientY) };
          for (var n = 0, r = 0, i = 0; i < t;)
            (n += e[i].clientX), (r += e[i].clientY), i++;
          return { x: p(n / t), y: p(r / t) };
        }
        function oe(e, t, n) {
          return { x: t / e || 0, y: n / e || 0 };
        }
        function ae(e, t) {
          return e === t ? G : h(e) >= h(t) ? (e < 0 ? X : U) : t < 0 ? V : K;
        }
        function le(e, t, n) {
          n || (n = ee);
          var r = t[n[0]] - e[n[0]],
            i = t[n[1]] - e[n[1]];
          return Math.sqrt(r * r + i * i);
        }
        function ce(e, t, n) {
          n || (n = ee);
          var r = t[n[0]] - e[n[0]],
            i = t[n[1]] - e[n[1]];
          return (180 * Math.atan2(i, r)) / Math.PI;
        }
        ne.prototype = {
          handler: function () { },
          init: function () {
            this.evEl && C(this.element, this.evEl, this.domHandler),
              this.evTarget && C(this.target, this.evTarget, this.domHandler),
              this.evWin && C(_(this.element), this.evWin, this.domHandler);
          },
          destroy: function () {
            this.evEl && k(this.element, this.evEl, this.domHandler),
              this.evTarget && k(this.target, this.evTarget, this.domHandler),
              this.evWin && k(_(this.element), this.evWin, this.domHandler);
          },
        };
        var ue = { mousedown: F, mousemove: H, mouseup: W },
          de = "mousedown",
          pe = "mousemove mouseup";
        function he() {
          (this.evEl = de),
            (this.evWin = pe),
            (this.pressed = !1),
            ne.apply(this, arguments);
        }
        E(he, ne, {
          handler: function (e) {
            var t = ue[e.type];
            t & F && 0 === e.button && (this.pressed = !0),
              t & H && 1 !== e.which && (t = W),
              this.pressed &&
              (t & W && (this.pressed = !1),
                this.callback(this.manager, t, {
                  pointers: [e],
                  changedPointers: [e],
                  pointerType: q,
                  srcEvent: e,
                }));
          },
        });
        var fe = {
          pointerdown: F,
          pointermove: H,
          pointerup: W,
          pointercancel: Y,
          pointerout: Y,
        },
          me = { 2: z, 3: "pen", 4: q, 5: "kinect" },
          ve = "pointerdown",
          ge = "pointermove pointerup pointercancel";
        function ye() {
          (this.evEl = ve),
            (this.evWin = ge),
            ne.apply(this, arguments),
            (this.store = this.manager.session.pointerEvents = []);
        }
        i.MSPointerEvent &&
          !i.PointerEvent &&
          ((ve = "MSPointerDown"),
            (ge = "MSPointerMove MSPointerUp MSPointerCancel")),
          E(ye, ne, {
            handler: function (e) {
              var t = this.store,
                n = !1,
                r = e.type.toLowerCase().replace("ms", ""),
                i = fe[r],
                s = me[e.pointerType] || e.pointerType,
                o = s == z,
                a = $(t, e.pointerId, "pointerId");
              i & F && (0 === e.button || o)
                ? a < 0 && (t.push(e), (a = t.length - 1))
                : i & (W | Y) && (n = !0),
                a < 0 ||
                ((t[a] = e),
                  this.callback(this.manager, i, {
                    pointers: t,
                    changedPointers: [e],
                    pointerType: s,
                    srcEvent: e,
                  }),
                  n && t.splice(a, 1));
            },
          });
        var be = { touchstart: F, touchmove: H, touchend: W, touchcancel: Y };
        function we() {
          (this.evTarget = "touchstart"),
            (this.evWin = "touchstart touchmove touchend touchcancel"),
            (this.started = !1),
            ne.apply(this, arguments);
        }
        function Ee(e, t) {
          var n = M(e.touches),
            r = M(e.changedTouches);
          return (
            t & (W | Y) && (n = A(n.concat(r), "identifier", !0)), [n, r]
          );
        }
        E(we, ne, {
          handler: function (e) {
            var t = be[e.type];
            if ((t === F && (this.started = !0), this.started)) {
              var n = Ee.call(this, e, t);
              t & (W | Y) &&
                n[0].length - n[1].length == 0 &&
                (this.started = !1),
                this.callback(this.manager, t, {
                  pointers: n[0],
                  changedPointers: n[1],
                  pointerType: z,
                  srcEvent: e,
                });
            }
          },
        });
        var xe = { touchstart: F, touchmove: H, touchend: W, touchcancel: Y },
          Te = "touchstart touchmove touchend touchcancel";
        function Se() {
          (this.evTarget = Te),
            (this.targetIds = {}),
            ne.apply(this, arguments);
        }
        function Ce(e, t) {
          var n = M(e.touches),
            r = this.targetIds;
          if (t & (F | H) && 1 === n.length)
            return (r[n[0].identifier] = !0), [n, n];
          var i,
            s,
            o = M(e.changedTouches),
            a = [],
            l = this.target;
          if (
            ((s = n.filter(function (e) {
              return O(e.target, l);
            })),
              t === F)
          )
            for (i = 0; i < s.length;) (r[s[i].identifier] = !0), i++;
          for (i = 0; i < o.length;)
            r[o[i].identifier] && a.push(o[i]),
              t & (W | Y) && delete r[o[i].identifier],
              i++;
          return a.length ? [A(s.concat(a), "identifier", !0), a] : void 0;
        }
        E(Se, ne, {
          handler: function (e) {
            var t = xe[e.type],
              n = Ce.call(this, e, t);
            n &&
              this.callback(this.manager, t, {
                pointers: n[0],
                changedPointers: n[1],
                pointerType: z,
                srcEvent: e,
              });
          },
        });
        var ke = 2500;
        function Oe() {
          ne.apply(this, arguments);
          var e = x(this.handler, this);
          (this.touch = new Se(this.manager, e)),
            (this.mouse = new he(this.manager, e)),
            (this.primaryTouch = null),
            (this.lastTouches = []);
        }
        function Pe(e, t) {
          e & F
            ? ((this.primaryTouch = t.changedPointers[0].identifier),
              Le.call(this, t))
            : e & (W | Y) && Le.call(this, t);
        }
        function Le(e) {
          var t = e.changedPointers[0];
          if (t.identifier === this.primaryTouch) {
            var n = { x: t.clientX, y: t.clientY };
            this.lastTouches.push(n);
            var r = this.lastTouches;
            setTimeout(function () {
              var e = r.indexOf(n);
              e > -1 && r.splice(e, 1);
            }, ke);
          }
        }
        function $e(e) {
          for (
            var t = e.srcEvent.clientX, n = e.srcEvent.clientY, r = 0;
            r < this.lastTouches.length;
            r++
          ) {
            var i = this.lastTouches[r],
              s = Math.abs(t - i.x),
              o = Math.abs(n - i.y);
            if (s <= 25 && o <= 25) return !0;
          }
          return !1;
        }
        E(Oe, ne, {
          handler: function (e, t, n) {
            var r = n.pointerType == z,
              i = n.pointerType == q;
            if (
              !(
                i &&
                n.sourceCapabilities &&
                n.sourceCapabilities.firesTouchEvents
              )
            ) {
              if (r) Pe.call(this, t, n);
              else if (i && $e.call(this, n)) return;
              this.callback(e, t, n);
            }
          },
          destroy: function () {
            this.touch.destroy(), this.mouse.destroy();
          },
        });
        var Me = I(u.style, "touchAction"),
          Ae = Me !== a,
          Ie = "compute",
          je = "auto",
          _e = "manipulation",
          Ne = "none",
          Re = "pan-x",
          De = "pan-y",
          ze = (function () {
            if (!Ae) return !1;
            var e = {},
              t = i.CSS && i.CSS.supports;
            return (
              [
                "auto",
                "manipulation",
                "pan-y",
                "pan-x",
                "pan-x pan-y",
                "none",
              ].forEach(function (n) {
                e[n] = !t || i.CSS.supports("touch-action", n);
              }),
              e
            );
          })();
        function qe(e, t) {
          (this.manager = e), this.set(t);
        }
        qe.prototype = {
          set: function (e) {
            e == Ie && (e = this.compute()),
              Ae &&
              this.manager.element.style &&
              ze[e] &&
              (this.manager.element.style[Me] = e),
              (this.actions = e.toLowerCase().trim());
          },
          update: function () {
            this.set(this.manager.options.touchAction);
          },
          compute: function () {
            var e = [];
            return (
              g(this.manager.recognizers, function (t) {
                T(t.options.enable, [t]) &&
                  (e = e.concat(t.getTouchAction()));
              }),
              (function (e) {
                if (P(e, Ne)) return Ne;
                var t = P(e, Re),
                  n = P(e, De);
                if (t && n) return Ne;
                if (t || n) return t ? Re : De;
                if (P(e, _e)) return _e;
                return je;
              })(e.join(" "))
            );
          },
          preventDefaults: function (e) {
            var t = e.srcEvent,
              n = e.offsetDirection;
            if (this.manager.session.prevented) t.preventDefault();
            else {
              var r = this.actions,
                i = P(r, Ne) && !ze[Ne],
                s = P(r, De) && !ze[De],
                o = P(r, Re) && !ze[Re];
              if (i) {
                var a = 1 === e.pointers.length,
                  l = e.distance < 2,
                  c = e.deltaTime < 250;
                if (a && l && c) return;
              }
              if (!o || !s)
                return i || (s && n & J) || (o && n & Q)
                  ? this.preventSrc(t)
                  : void 0;
            }
          },
          preventSrc: function (e) {
            (this.manager.session.prevented = !0), e.preventDefault();
          },
        };
        var Be = 1,
          Fe = 2,
          He = 4,
          We = 8,
          Ye = We,
          Ge = 16,
          Xe = 32;
        function Ue(e) {
          (this.options = l({}, this.defaults, e || {})),
            (this.id = j++),
            (this.manager = null),
            (this.options.enable = S(this.options.enable, !0)),
            (this.state = Be),
            (this.simultaneous = {}),
            (this.requireFail = []);
        }
        function Ve(e) {
          return e & Ge
            ? "cancel"
            : e & We
              ? "end"
              : e & He
                ? "move"
                : e & Fe
                  ? "start"
                  : "";
        }
        function Ke(e) {
          return e == K
            ? "down"
            : e == V
              ? "up"
              : e == X
                ? "left"
                : e == U
                  ? "right"
                  : "";
        }
        function Je(e, t) {
          var n = t.manager;
          return n ? n.get(e) : e;
        }
        function Qe() {
          Ue.apply(this, arguments);
        }
        function Ze() {
          Qe.apply(this, arguments), (this.pX = null), (this.pY = null);
        }
        function et() {
          Qe.apply(this, arguments);
        }
        function tt() {
          Ue.apply(this, arguments),
            (this._timer = null),
            (this._input = null);
        }
        function nt() {
          Qe.apply(this, arguments);
        }
        function rt() {
          Qe.apply(this, arguments);
        }
        function it() {
          Ue.apply(this, arguments),
            (this.pTime = !1),
            (this.pCenter = !1),
            (this._timer = null),
            (this._input = null),
            (this.count = 0);
        }
        function st(e, t) {
          return (
            ((t = t || {}).recognizers = S(
              t.recognizers,
              st.defaults.preset
            )),
            new ot(e, t)
          );
        }
        (Ue.prototype = {
          defaults: {},
          set: function (e) {
            return (
              l(this.options, e),
              this.manager && this.manager.touchAction.update(),
              this
            );
          },
          recognizeWith: function (e) {
            if (v(e, "recognizeWith", this)) return this;
            var t = this.simultaneous;
            return (
              t[(e = Je(e, this)).id] ||
              ((t[e.id] = e), e.recognizeWith(this)),
              this
            );
          },
          dropRecognizeWith: function (e) {
            return (
              v(e, "dropRecognizeWith", this) ||
              ((e = Je(e, this)), delete this.simultaneous[e.id]),
              this
            );
          },
          requireFailure: function (e) {
            if (v(e, "requireFailure", this)) return this;
            var t = this.requireFail;
            return (
              -1 === $(t, (e = Je(e, this))) &&
              (t.push(e), e.requireFailure(this)),
              this
            );
          },
          dropRequireFailure: function (e) {
            if (v(e, "dropRequireFailure", this)) return this;
            e = Je(e, this);
            var t = $(this.requireFail, e);
            return t > -1 && this.requireFail.splice(t, 1), this;
          },
          hasRequireFailures: function () {
            return this.requireFail.length > 0;
          },
          canRecognizeWith: function (e) {
            return !!this.simultaneous[e.id];
          },
          emit: function (e) {
            var t = this,
              n = this.state;
            function r(n) {
              t.manager.emit(n, e);
            }
            n < We && r(t.options.event + Ve(n)),
              r(t.options.event),
              e.additionalEvent && r(e.additionalEvent),
              n >= We && r(t.options.event + Ve(n));
          },
          tryEmit: function (e) {
            if (this.canEmit()) return this.emit(e);
            this.state = Xe;
          },
          canEmit: function () {
            for (var e = 0; e < this.requireFail.length;) {
              if (!(this.requireFail[e].state & (Xe | Be))) return !1;
              e++;
            }
            return !0;
          },
          recognize: function (e) {
            var t = l({}, e);
            if (!T(this.options.enable, [this, t]))
              return this.reset(), void (this.state = Xe);
            this.state & (Ye | Ge | Xe) && (this.state = Be),
              (this.state = this.process(t)),
              this.state & (Fe | He | We | Ge) && this.tryEmit(t);
          },
          process: function (e) { },
          getTouchAction: function () { },
          reset: function () { },
        }),
          E(Qe, Ue, {
            defaults: { pointers: 1 },
            attrTest: function (e) {
              var t = this.options.pointers;
              return 0 === t || e.pointers.length === t;
            },
            process: function (e) {
              var t = this.state,
                n = e.eventType,
                r = t & (Fe | He),
                i = this.attrTest(e);
              return r && (n & Y || !i)
                ? t | Ge
                : r || i
                  ? n & W
                    ? t | We
                    : t & Fe
                      ? t | He
                      : Fe
                  : Xe;
            },
          }),
          E(Ze, Qe, {
            defaults: {
              event: "pan",
              threshold: 10,
              pointers: 1,
              direction: Z,
            },
            getTouchAction: function () {
              var e = this.options.direction,
                t = [];
              return e & J && t.push(De), e & Q && t.push(Re), t;
            },
            directionTest: function (e) {
              var t = this.options,
                n = !0,
                r = e.distance,
                i = e.direction,
                s = e.deltaX,
                o = e.deltaY;
              return (
                i & t.direction ||
                (t.direction & J
                  ? ((i = 0 === s ? G : s < 0 ? X : U),
                    (n = s != this.pX),
                    (r = Math.abs(e.deltaX)))
                  : ((i = 0 === o ? G : o < 0 ? V : K),
                    (n = o != this.pY),
                    (r = Math.abs(e.deltaY)))),
                (e.direction = i),
                n && r > t.threshold && i & t.direction
              );
            },
            attrTest: function (e) {
              return (
                Qe.prototype.attrTest.call(this, e) &&
                (this.state & Fe ||
                  (!(this.state & Fe) && this.directionTest(e)))
              );
            },
            emit: function (e) {
              (this.pX = e.deltaX), (this.pY = e.deltaY);
              var t = Ke(e.direction);
              t && (e.additionalEvent = this.options.event + t),
                this._super.emit.call(this, e);
            },
          }),
          E(et, Qe, {
            defaults: { event: "pinch", threshold: 0, pointers: 2 },
            getTouchAction: function () {
              return [Ne];
            },
            attrTest: function (e) {
              return (
                this._super.attrTest.call(this, e) &&
                (Math.abs(e.scale - 1) > this.options.threshold ||
                  this.state & Fe)
              );
            },
            emit: function (e) {
              if (1 !== e.scale) {
                var t = e.scale < 1 ? "in" : "out";
                e.additionalEvent = this.options.event + t;
              }
              this._super.emit.call(this, e);
            },
          }),
          E(tt, Ue, {
            defaults: {
              event: "press",
              pointers: 1,
              time: 251,
              threshold: 9,
            },
            getTouchAction: function () {
              return [je];
            },
            process: function (e) {
              var t = this.options,
                n = e.pointers.length === t.pointers,
                r = e.distance < t.threshold,
                i = e.deltaTime > t.time;
              if (
                ((this._input = e), !r || !n || (e.eventType & (W | Y) && !i))
              )
                this.reset();
              else if (e.eventType & F)
                this.reset(),
                  (this._timer = m(
                    function () {
                      (this.state = Ye), this.tryEmit();
                    },
                    t.time,
                    this
                  ));
              else if (e.eventType & W) return Ye;
              return Xe;
            },
            reset: function () {
              clearTimeout(this._timer);
            },
            emit: function (e) {
              this.state === Ye &&
                (e && e.eventType & W
                  ? this.manager.emit(this.options.event + "up", e)
                  : ((this._input.timeStamp = f()),
                    this.manager.emit(this.options.event, this._input)));
            },
          }),
          E(nt, Qe, {
            defaults: { event: "rotate", threshold: 0, pointers: 2 },
            getTouchAction: function () {
              return [Ne];
            },
            attrTest: function (e) {
              return (
                this._super.attrTest.call(this, e) &&
                (Math.abs(e.rotation) > this.options.threshold ||
                  this.state & Fe)
              );
            },
          }),
          E(rt, Qe, {
            defaults: {
              event: "swipe",
              threshold: 10,
              velocity: 0.3,
              direction: J | Q,
              pointers: 1,
            },
            getTouchAction: function () {
              return Ze.prototype.getTouchAction.call(this);
            },
            attrTest: function (e) {
              var t,
                n = this.options.direction;
              return (
                n & (J | Q)
                  ? (t = e.overallVelocity)
                  : n & J
                    ? (t = e.overallVelocityX)
                    : n & Q && (t = e.overallVelocityY),
                this._super.attrTest.call(this, e) &&
                n & e.offsetDirection &&
                e.distance > this.options.threshold &&
                e.maxPointers == this.options.pointers &&
                h(t) > this.options.velocity &&
                e.eventType & W
              );
            },
            emit: function (e) {
              var t = Ke(e.offsetDirection);
              t && this.manager.emit(this.options.event + t, e),
                this.manager.emit(this.options.event, e);
            },
          }),
          E(it, Ue, {
            defaults: {
              event: "tap",
              pointers: 1,
              taps: 1,
              interval: 300,
              time: 250,
              threshold: 9,
              posThreshold: 10,
            },
            getTouchAction: function () {
              return [_e];
            },
            process: function (e) {
              var t = this.options,
                n = e.pointers.length === t.pointers,
                r = e.distance < t.threshold,
                i = e.deltaTime < t.time;
              if ((this.reset(), e.eventType & F && 0 === this.count))
                return this.failTimeout();
              if (r && i && n) {
                if (e.eventType != W) return this.failTimeout();
                var s = !this.pTime || e.timeStamp - this.pTime < t.interval,
                  o =
                    !this.pCenter ||
                    le(this.pCenter, e.center) < t.posThreshold;
                if (
                  ((this.pTime = e.timeStamp),
                    (this.pCenter = e.center),
                    o && s ? (this.count += 1) : (this.count = 1),
                    (this._input = e),
                    0 === this.count % t.taps)
                )
                  return this.hasRequireFailures()
                    ? ((this._timer = m(
                      function () {
                        (this.state = Ye), this.tryEmit();
                      },
                      t.interval,
                      this
                    )),
                      Fe)
                    : Ye;
              }
              return Xe;
            },
            failTimeout: function () {
              return (
                (this._timer = m(
                  function () {
                    this.state = Xe;
                  },
                  this.options.interval,
                  this
                )),
                Xe
              );
            },
            reset: function () {
              clearTimeout(this._timer);
            },
            emit: function () {
              this.state == Ye &&
                ((this._input.tapCount = this.count),
                  this.manager.emit(this.options.event, this._input));
            },
          }),
          (st.VERSION = "2.0.7"),
          (st.defaults = {
            domEvents: !1,
            touchAction: Ie,
            enable: !0,
            inputTarget: null,
            inputClass: null,
            preset: [
              [nt, { enable: !1 }],
              [et, { enable: !1 }, ["rotate"]],
              [rt, { direction: J }],
              [Ze, { direction: J }, ["swipe"]],
              [it],
              [it, { event: "doubletap", taps: 2 }, ["tap"]],
              [tt],
            ],
            cssProps: {
              userSelect: "none",
              touchSelect: "none",
              touchCallout: "none",
              contentZooming: "none",
              userDrag: "none",
              tapHighlightColor: "rgba(0,0,0,0)",
            },
          });
        function ot(e, t) {
          var n;
          (this.options = l({}, st.defaults, t || {})),
            (this.options.inputTarget = this.options.inputTarget || e),
            (this.handlers = {}),
            (this.session = {}),
            (this.recognizers = []),
            (this.oldCssProps = {}),
            (this.element = e),
            (this.input = new ((n = this).options.inputClass ||
              (R ? ye : D ? Se : N ? Oe : he))(n, re)),
            (this.touchAction = new qe(this, this.options.touchAction)),
            at(this, !0),
            g(
              this.options.recognizers,
              function (e) {
                var t = this.add(new e[0](e[1]));
                e[2] && t.recognizeWith(e[2]), e[3] && t.requireFailure(e[3]);
              },
              this
            );
        }
        function at(e, t) {
          var n,
            r = e.element;
          r.style &&
            (g(e.options.cssProps, function (i, s) {
              (n = I(r.style, s)),
                t
                  ? ((e.oldCssProps[n] = r.style[n]), (r.style[n] = i))
                  : (r.style[n] = e.oldCssProps[n] || "");
            }),
              t || (e.oldCssProps = {}));
        }
        (ot.prototype = {
          set: function (e) {
            return (
              l(this.options, e),
              e.touchAction && this.touchAction.update(),
              e.inputTarget &&
              (this.input.destroy(),
                (this.input.target = e.inputTarget),
                this.input.init()),
              this
            );
          },
          stop: function (e) {
            this.session.stopped = e ? 2 : 1;
          },
          recognize: function (e) {
            var t = this.session;
            if (!t.stopped) {
              var n;
              this.touchAction.preventDefaults(e);
              var r = this.recognizers,
                i = t.curRecognizer;
              (!i || (i && i.state & Ye)) && (i = t.curRecognizer = null);
              for (var s = 0; s < r.length;)
                (n = r[s]),
                  2 === t.stopped || (i && n != i && !n.canRecognizeWith(i))
                    ? n.reset()
                    : n.recognize(e),
                  !i && n.state & (Fe | He | We) && (i = t.curRecognizer = n),
                  s++;
            }
          },
          get: function (e) {
            if (e instanceof Ue) return e;
            for (var t = this.recognizers, n = 0; n < t.length; n++)
              if (t[n].options.event == e) return t[n];
            return null;
          },
          add: function (e) {
            if (v(e, "add", this)) return this;
            var t = this.get(e.options.event);
            return (
              t && this.remove(t),
              this.recognizers.push(e),
              (e.manager = this),
              this.touchAction.update(),
              e
            );
          },
          remove: function (e) {
            if (v(e, "remove", this)) return this;
            if ((e = this.get(e))) {
              var t = this.recognizers,
                n = $(t, e);
              -1 !== n && (t.splice(n, 1), this.touchAction.update());
            }
            return this;
          },
          on: function (e, t) {
            if (e !== a && t !== a) {
              var n = this.handlers;
              return (
                g(L(e), function (e) {
                  (n[e] = n[e] || []), n[e].push(t);
                }),
                this
              );
            }
          },
          off: function (e, t) {
            if (e !== a) {
              var n = this.handlers;
              return (
                g(L(e), function (e) {
                  t ? n[e] && n[e].splice($(n[e], t), 1) : delete n[e];
                }),
                this
              );
            }
          },
          emit: function (e, t) {
            this.options.domEvents &&
              (function (e, t) {
                var n = s.createEvent("Event");
                n.initEvent(e, !0, !0),
                  (n.gesture = t),
                  t.target.dispatchEvent(n);
              })(e, t);
            var n = this.handlers[e] && this.handlers[e].slice();
            if (n && n.length) {
              (t.type = e),
                (t.preventDefault = function () {
                  t.srcEvent.preventDefault();
                });
              for (var r = 0; r < n.length;) n[r](t), r++;
            }
          },
          destroy: function () {
            this.element && at(this, !1),
              (this.handlers = {}),
              (this.session = {}),
              this.input.destroy(),
              (this.element = null);
          },
        }),
          l(st, {
            INPUT_START: F,
            INPUT_MOVE: H,
            INPUT_END: W,
            INPUT_CANCEL: Y,
            STATE_POSSIBLE: Be,
            STATE_BEGAN: Fe,
            STATE_CHANGED: He,
            STATE_ENDED: We,
            STATE_RECOGNIZED: Ye,
            STATE_CANCELLED: Ge,
            STATE_FAILED: Xe,
            DIRECTION_NONE: G,
            DIRECTION_LEFT: X,
            DIRECTION_RIGHT: U,
            DIRECTION_UP: V,
            DIRECTION_DOWN: K,
            DIRECTION_HORIZONTAL: J,
            DIRECTION_VERTICAL: Q,
            DIRECTION_ALL: Z,
            Manager: ot,
            Input: ne,
            TouchAction: qe,
            TouchInput: Se,
            MouseInput: he,
            PointerEventInput: ye,
            TouchMouseInput: Oe,
            SingleTouchInput: we,
            Recognizer: Ue,
            AttrRecognizer: Qe,
            Tap: it,
            Pan: Ze,
            Swipe: rt,
            Pinch: et,
            Rotate: nt,
            Press: tt,
            on: C,
            off: k,
            each: g,
            merge: w,
            extend: b,
            assign: l,
            inherit: E,
            bindFn: x,
            prefixed: I,
          }),
          ((void 0 !== i
            ? i
            : "undefined" != typeof self
              ? self
              : {}
          ).Hammer = st),
          (r = function () {
            return st;
          }.call(t, n, t, e)) === a || (e.exports = r);
      })(window, document);
    },
    551: function (e, t, n) {
      var r, i;
      (e = n.nmd(e)),
        function () {
          var s,
            o,
            a,
            l,
            c,
            u = function (e, t) {
              return function () {
                return e.apply(t, arguments);
              };
            },
            d = [].slice,
            p = {}.hasOwnProperty,
            h = function (e, t) {
              for (var n in t) p.call(t, n) && (e[n] = t[n]);
              function r() {
                this.constructor = e;
              }
              return (
                (r.prototype = t.prototype),
                (e.prototype = new r()),
                (e.__super__ = t.prototype),
                e
              );
            },
            f =
              [].indexOf ||
              function (e) {
                for (var t = 0, n = this.length; t < n; t++)
                  if (t in this && this[t] === e) return t;
                return -1;
              };
          (s = {
            options: [
              "prefix",
              "templateDelimiters",
              "rootInterface",
              "preloadData",
              "handler",
              "executeFunctions",
            ],
            extensions: ["binders", "formatters", "components", "adapters"],
            public: {
              binders: {},
              components: {},
              formatters: {},
              adapters: {},
              prefix: "rv",
              templateDelimiters: ["{", "}"],
              rootInterface: ".",
              preloadData: !0,
              executeFunctions: !1,
              iterationAlias: function (e) {
                return "%" + e + "%";
              },
              handler: function (e, t, n) {
                return this.call(e, t, n.view.models);
              },
              configure: function (e) {
                var t, n, r, i;
                for (r in (null == e && (e = {}), e))
                  if (
                    ((i = e[r]),
                      "binders" === r ||
                      "components" === r ||
                      "formatters" === r ||
                      "adapters" === r)
                  )
                    for (n in i) (t = i[n]), (s[r][n] = t);
                  else s.public[r] = i;
              },
              bind: function (e, t, n) {
                var r;
                return (
                  null == t && (t = {}),
                  null == n && (n = {}),
                  (r = new s.View(e, t, n)).bind(),
                  r
                );
              },
              init: function (e, t, n) {
                var r, i, o;
                if (
                  (null == n && (n = {}),
                    null == t && (t = document.createElement("div")),
                    (i = (e = s.public.components[e]).template.call(
                      this,
                      t
                    )) instanceof HTMLElement)
                ) {
                  for (; t.firstChild;) t.removeChild(t.firstChild);
                  t.appendChild(i);
                } else t.innerHTML = i;
                return (
                  (r = e.initialize.call(this, t, n)),
                  (o = new s.View(t, r)).bind(),
                  o
                );
              },
            },
          }),
            window.jQuery || window.$
              ? ((c =
                "on" in (a = window.jQuery || window.$).prototype
                  ? ["on", "off"]
                  : ["bind", "unbind"]),
                (o = c[0]),
                (l = c[1]),
                (s.Util = {
                  bindEvent: function (e, t, n) {
                    return a(e)[o](t, n);
                  },
                  unbindEvent: function (e, t, n) {
                    return a(e)[l](t, n);
                  },
                  getInputValue: function (e) {
                    var t;
                    return "checkbox" === (t = a(e)).attr("type")
                      ? t.is(":checked")
                      : t.val();
                  },
                }))
              : (s.Util = {
                bindEvent:
                  "addEventListener" in window
                    ? function (e, t, n) {
                      return e.addEventListener(t, n, !1);
                    }
                    : function (e, t, n) {
                      return e.attachEvent("on" + t, n);
                    },
                unbindEvent:
                  "removeEventListener" in window
                    ? function (e, t, n) {
                      return e.removeEventListener(t, n, !1);
                    }
                    : function (e, t, n) {
                      return e.detachEvent("on" + t, n);
                    },
                getInputValue: function (e) {
                  var t, n, r, i;
                  if ("checkbox" === e.type) return e.checked;
                  if ("select-multiple" === e.type) {
                    for (i = [], n = 0, r = e.length; n < r; n++)
                      (t = e[n]).selected && i.push(t.value);
                    return i;
                  }
                  return e.value;
                },
              }),
            (s.TypeParser = (function () {
              function e() { }
              return (
                (e.types = { primitive: 0, keypath: 1 }),
                (e.parse = function (e) {
                  return /^'.*'$|^".*"$/.test(e)
                    ? { type: this.types.primitive, value: e.slice(1, -1) }
                    : "true" === e
                      ? { type: this.types.primitive, value: !0 }
                      : "false" === e
                        ? { type: this.types.primitive, value: !1 }
                        : "null" === e
                          ? { type: this.types.primitive, value: null }
                          : "undefined" === e || "" === e
                            ? { type: this.types.primitive, value: void 0 }
                            : !1 === isNaN(Number(e))
                              ? { type: this.types.primitive, value: Number(e) }
                              : { type: this.types.keypath, value: e };
                }),
                e
              );
            })()),
            (s.TextTemplateParser = (function () {
              function e() { }
              return (
                (e.types = { text: 0, binding: 1 }),
                (e.parse = function (e, t) {
                  var n, r, i, s, o, a, l;
                  for (a = [], s = e.length, n = 0, r = 0; r < s;) {
                    if ((n = e.indexOf(t[0], r)) < 0) {
                      a.push({ type: this.types.text, value: e.slice(r) });
                      break;
                    }
                    if (
                      (n > 0 &&
                        r < n &&
                        a.push({
                          type: this.types.text,
                          value: e.slice(r, n),
                        }),
                        (r = n + t[0].length),
                        (n = e.indexOf(t[1], r)) < 0)
                    ) {
                      (o = e.slice(r - t[1].length)),
                        (null != (i = a[a.length - 1]) ? i.type : void 0) ===
                          this.types.text
                          ? (i.value += o)
                          : a.push({ type: this.types.text, value: o });
                      break;
                    }
                    (l = e.slice(r, n).trim()),
                      a.push({ type: this.types.binding, value: l }),
                      (r = n + t[1].length);
                  }
                  return a;
                }),
                e
              );
            })()),
            (s.View = (function () {
              function e(e, t, n) {
                var r, i, o, a, l, c, d, p, h, f, m, v, g;
                for (
                  this.els = e,
                  this.models = t,
                  null == n && (n = {}),
                  this.update = u(this.update, this),
                  this.publish = u(this.publish, this),
                  this.sync = u(this.sync, this),
                  this.unbind = u(this.unbind, this),
                  this.bind = u(this.bind, this),
                  this.select = u(this.select, this),
                  this.traverse = u(this.traverse, this),
                  this.build = u(this.build, this),
                  this.buildBinding = u(this.buildBinding, this),
                  this.bindingRegExp = u(this.bindingRegExp, this),
                  this.options = u(this.options, this),
                  this.els.jquery ||
                  this.els instanceof Array ||
                  (this.els = [this.els]),
                  l = 0,
                  d = (h = s.extensions).length;
                  l < d;
                  l++
                ) {
                  if (((this[(i = h[l])] = {}), n[i]))
                    for (r in (f = n[i])) (o = f[r]), (this[i][r] = o);
                  for (r in (m = s.public[i]))
                    (o = m[r]), null == (a = this[i])[r] && (a[r] = o);
                }
                for (c = 0, p = (v = s.options).length; c < p; c++)
                  this[(i = v[c])] = null != (g = n[i]) ? g : s.public[i];
                this.build();
              }
              return (
                (e.prototype.options = function () {
                  var e, t, n, r, i;
                  for (
                    t = {},
                    n = 0,
                    r = (i = s.extensions.concat(s.options)).length;
                    n < r;
                    n++
                  )
                    t[(e = i[n])] = this[e];
                  return t;
                }),
                (e.prototype.bindingRegExp = function () {
                  return new RegExp("^" + this.prefix + "-");
                }),
                (e.prototype.buildBinding = function (e, t, n, r) {
                  var i, o, a, l, c, u, d;
                  return (
                    (c = {}),
                    (d = (function () {
                      var e, t, n, i;
                      for (
                        i = [],
                        e = 0,
                        t = (n = r.match(
                          /((?:'[^']*')*(?:(?:[^\|']*(?:'[^']*')+[^\|']*)+|[^\|]+))|^$/g
                        )).length;
                        e < t;
                        e++
                      )
                        (u = n[e]), i.push(u.trim());
                      return i;
                    })()),
                    (l = (i = (function () {
                      var e, t, n, r;
                      for (
                        r = [], e = 0, t = (n = d.shift().split("<")).length;
                        e < t;
                        e++
                      )
                        (o = n[e]), r.push(o.trim());
                      return r;
                    })()).shift()),
                    (c.formatters = d),
                    (a = i.shift()) && (c.dependencies = a.split(/\s+/)),
                    this.bindings.push(new s[e](this, t, n, l, c))
                  );
                }),
                (e.prototype.build = function () {
                  var e, t, n, r, i, o;
                  for (
                    this.bindings = [],
                    o = this,
                    t = function (e) {
                      var n, r, i, a, l, c, u, d, p, h, f, m, v;
                      if (3 === e.nodeType) {
                        if (
                          ((l = s.TextTemplateParser),
                            (i = o.templateDelimiters) &&
                            (d = l.parse(e.data, i)).length &&
                            (1 !== d.length || d[0].type !== l.types.text))
                        ) {
                          for (p = 0, f = d.length; p < f; p++)
                            (u = d[p]),
                              (c = document.createTextNode(u.value)),
                              e.parentNode.insertBefore(c, e),
                              1 === u.type &&
                              o.buildBinding(
                                "TextBinding",
                                c,
                                null,
                                u.value
                              );
                          e.parentNode.removeChild(e);
                        }
                      } else 1 === e.nodeType && (n = o.traverse(e));
                      if (!n)
                        for (
                          v = (function () {
                            var t, n, r, i;
                            for (
                              i = [], t = 0, n = (r = e.childNodes).length;
                              t < n;
                              t++
                            )
                              (a = r[t]), i.push(a);
                            return i;
                          })(),
                          h = 0,
                          m = v.length;
                          h < m;
                          h++
                        )
                          (r = v[h]), t(r);
                    },
                    n = 0,
                    r = (i = this.els).length;
                    n < r;
                    n++
                  )
                    (e = i[n]), t(e);
                  this.bindings.sort(function (e, t) {
                    var n, r;
                    return (
                      ((null != (n = t.binder) ? n.priority : void 0) || 0) -
                      ((null != (r = e.binder) ? r.priority : void 0) || 0)
                    );
                  });
                }),
                (e.prototype.traverse = function (e) {
                  var t, n, r, i, o, a, l, c, u, d, p, h, f, m, v;
                  for (
                    i = this.bindingRegExp(),
                    o = "SCRIPT" === e.nodeName || "STYLE" === e.nodeName,
                    u = 0,
                    p = (f = e.attributes).length;
                    u < p;
                    u++
                  )
                    if (((t = f[u]), i.test(t.name))) {
                      if (
                        ((l = t.name.replace(i, "")), !(r = this.binders[l]))
                      )
                        for (a in (m = this.binders))
                          (c = m[a]),
                            "*" !== a &&
                            -1 !== a.indexOf("*") &&
                            new RegExp(
                              "^" + a.replace(/\*/g, ".+") + "$"
                            ).test(l) &&
                            (r = c);
                      r || (r = this.binders["*"]),
                        r.block && ((o = !0), (n = [t]));
                    }
                  for (d = 0, h = (v = n || e.attributes).length; d < h; d++)
                    (t = v[d]),
                      i.test(t.name) &&
                      ((l = t.name.replace(i, "")),
                        this.buildBinding("Binding", e, l, t.value));
                  return (
                    o ||
                    ((l = e.nodeName.toLowerCase()),
                      this.components[l] &&
                      !e._bound &&
                      (this.bindings.push(
                        new s.ComponentBinding(this, e, l)
                      ),
                        (o = !0))),
                    o
                  );
                }),
                (e.prototype.select = function (e) {
                  var t, n, r, i, s;
                  for (
                    s = [], n = 0, r = (i = this.bindings).length;
                    n < r;
                    n++
                  )
                    e((t = i[n])) && s.push(t);
                  return s;
                }),
                (e.prototype.bind = function () {
                  var e, t, n;
                  for (e = 0, t = (n = this.bindings).length; e < t; e++)
                    n[e].bind();
                }),
                (e.prototype.unbind = function () {
                  var e, t, n;
                  for (e = 0, t = (n = this.bindings).length; e < t; e++)
                    n[e].unbind();
                }),
                (e.prototype.sync = function () {
                  var e, t, n, r;
                  for (t = 0, n = (r = this.bindings).length; t < n; t++)
                    "function" == typeof (e = r[t]).sync && e.sync();
                }),
                (e.prototype.publish = function () {
                  var e, t, n;
                  for (
                    e = 0,
                    t = (n = this.select(function (e) {
                      var t;
                      return null != (t = e.binder) ? t.publishes : void 0;
                    })).length;
                    e < t;
                    e++
                  )
                    n[e].publish();
                }),
                (e.prototype.update = function (e) {
                  var t, n, r, i, s, o;
                  for (n in (null == e && (e = {}), e))
                    (r = e[n]), (this.models[n] = r);
                  for (i = 0, s = (o = this.bindings).length; i < s; i++)
                    "function" == typeof (t = o[i]).update && t.update(e);
                }),
                e
              );
            })()),
            (s.Binding = (function () {
              function e(e, t, n, r, i) {
                (this.view = e),
                  (this.el = t),
                  (this.type = n),
                  (this.keypath = r),
                  (this.options = null != i ? i : {}),
                  (this.getValue = u(this.getValue, this)),
                  (this.update = u(this.update, this)),
                  (this.unbind = u(this.unbind, this)),
                  (this.bind = u(this.bind, this)),
                  (this.publish = u(this.publish, this)),
                  (this.sync = u(this.sync, this)),
                  (this.set = u(this.set, this)),
                  (this.eventHandler = u(this.eventHandler, this)),
                  (this.formattedValue = u(this.formattedValue, this)),
                  (this.parseFormatterArguments = u(
                    this.parseFormatterArguments,
                    this
                  )),
                  (this.parseTarget = u(this.parseTarget, this)),
                  (this.observe = u(this.observe, this)),
                  (this.setBinder = u(this.setBinder, this)),
                  (this.formatters = this.options.formatters || []),
                  (this.dependencies = []),
                  (this.formatterObservers = {}),
                  (this.model = void 0),
                  this.setBinder();
              }
              return (
                (e.prototype.setBinder = function () {
                  var e, t, n;
                  if (!(this.binder = this.view.binders[this.type]))
                    for (e in (n = this.view.binders))
                      (t = n[e]),
                        "*" !== e &&
                        -1 !== e.indexOf("*") &&
                        new RegExp("^" + e.replace(/\*/g, ".+") + "$").test(
                          this.type
                        ) &&
                        ((this.binder = t),
                          (this.args = new RegExp(
                            "^" + e.replace(/\*/g, "(.+)") + "$"
                          ).exec(this.type)),
                          this.args.shift());
                  if (
                    (this.binder || (this.binder = this.view.binders["*"]),
                      this.binder instanceof Function)
                  )
                    return (this.binder = { routine: this.binder });
                }),
                (e.prototype.observe = function (e, t, n) {
                  return s.sightglass(e, t, n, {
                    root: this.view.rootInterface,
                    adapters: this.view.adapters,
                  });
                }),
                (e.prototype.parseTarget = function () {
                  var e;
                  return (e = s.TypeParser.parse(this.keypath)).type ===
                    s.TypeParser.types.primitive
                    ? (this.value = e.value)
                    : ((this.observer = this.observe(
                      this.view.models,
                      this.keypath,
                      this.sync
                    )),
                      (this.model = this.observer.target));
                }),
                (e.prototype.parseFormatterArguments = function (e, t) {
                  var n, r, i, o, a, l, c;
                  for (
                    e = (function () {
                      var t, n, i;
                      for (i = [], t = 0, n = e.length; t < n; t++)
                        (r = e[t]), i.push(s.TypeParser.parse(r));
                      return i;
                    })(),
                    o = [],
                    n = l = 0,
                    c = e.length;
                    l < c;
                    n = ++l
                  )
                    (r = e[n]),
                      o.push(
                        r.type === s.TypeParser.types.primitive
                          ? r.value
                          : ((a = this.formatterObservers)[t] || (a[t] = {}),
                            (i = this.formatterObservers[t][n]) ||
                            ((i = this.observe(
                              this.view.models,
                              r.value,
                              this.sync
                            )),
                              (this.formatterObservers[t][n] = i)),
                            i.value())
                      );
                  return o;
                }),
                (e.prototype.formattedValue = function (e) {
                  var t, n, r, i, s, o, a, l, c;
                  for (
                    n = o = 0, a = (l = this.formatters).length;
                    o < a;
                    n = ++o
                  )
                    (i = (t = (r = l[n]).match(
                      /[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g
                    )).shift()),
                      (r = this.view.formatters[i]),
                      (s = this.parseFormatterArguments(t, n)),
                      (null != r ? r.read : void 0) instanceof Function
                        ? (e = (c = r.read).call.apply(
                          c,
                          [this.model, e].concat(d.call(s))
                        ))
                        : r instanceof Function &&
                        (e = r.call.apply(
                          r,
                          [this.model, e].concat(d.call(s))
                        ));
                  return e;
                }),
                (e.prototype.eventHandler = function (e) {
                  var t, n;
                  return (
                    (n = (t = this).view.handler),
                    function (r) {
                      return n.call(e, this, r, t);
                    }
                  );
                }),
                (e.prototype.set = function (e) {
                  var t;
                  return (
                    (e =
                      e instanceof Function &&
                        !this.binder.function &&
                        s.public.executeFunctions
                        ? this.formattedValue(e.call(this.model))
                        : this.formattedValue(e)),
                    null != (t = this.binder.routine)
                      ? t.call(this, this.el, e)
                      : void 0
                  );
                }),
                (e.prototype.sync = function () {
                  var e, t;
                  return this.set(
                    function () {
                      var n, r, i, s, o, a, l;
                      if (this.observer) {
                        if (this.model !== this.observer.target) {
                          for (
                            n = 0, i = (o = this.dependencies).length;
                            n < i;
                            n++
                          )
                            (t = o[n]).unobserve();
                          if (
                            ((this.dependencies = []),
                              null != (this.model = this.observer.target) &&
                              (null != (a = this.options.dependencies)
                                ? a.length
                                : void 0))
                          )
                            for (
                              r = 0,
                              s = (l = this.options.dependencies).length;
                              r < s;
                              r++
                            )
                              (e = l[r]),
                                (t = this.observe(this.model, e, this.sync)),
                                this.dependencies.push(t);
                        }
                        return this.observer.value();
                      }
                      return this.value;
                    }.call(this)
                  );
                }),
                (e.prototype.publish = function () {
                  var e, t, n, r, i, s, o, a, l, c, u, p;
                  if (this.observer) {
                    for (
                      o = this.getValue(this.el),
                      i = this.formatters.length - 1,
                      n = a = 0,
                      l = (c = this.formatters.slice(0).reverse()).length;
                      a < l;
                      n = ++a
                    )
                      (t = i - n),
                        (r = (e = c[n].split(/\s+/)).shift()),
                        (s = this.parseFormatterArguments(e, t)),
                        (null != (u = this.view.formatters[r])
                          ? u.publish
                          : void 0) &&
                        (o = (p = this.view.formatters[r]).publish.apply(
                          p,
                          [o].concat(d.call(s))
                        ));
                    return this.observer.setValue(o);
                  }
                }),
                (e.prototype.bind = function () {
                  var e, t, n, r, i, s, o;
                  if (
                    (this.parseTarget(),
                      null != (i = this.binder.bind) && i.call(this, this.el),
                      null != this.model &&
                      (null != (s = this.options.dependencies)
                        ? s.length
                        : void 0))
                  )
                    for (
                      n = 0, r = (o = this.options.dependencies).length;
                      n < r;
                      n++
                    )
                      (e = o[n]),
                        (t = this.observe(this.model, e, this.sync)),
                        this.dependencies.push(t);
                  if (this.view.preloadData) return this.sync();
                }),
                (e.prototype.unbind = function () {
                  var e, t, n, r, i, s, o, a, l;
                  for (
                    null != (s = this.binder.unbind) && s.call(this, this.el),
                    null != (o = this.observer) && o.unobserve(),
                    r = 0,
                    i = (a = this.dependencies).length;
                    r < i;
                    r++
                  )
                    a[r].unobserve();
                  for (n in ((this.dependencies = []),
                    (l = this.formatterObservers)))
                    for (e in (t = l[n])) t[e].unobserve();
                  return (this.formatterObservers = {});
                }),
                (e.prototype.update = function (e) {
                  var t, n;
                  return (
                    null == e && (e = {}),
                    (this.model =
                      null != (t = this.observer) ? t.target : void 0),
                    null != (n = this.binder.update)
                      ? n.call(this, e)
                      : void 0
                  );
                }),
                (e.prototype.getValue = function (e) {
                  return this.binder && null != this.binder.getValue
                    ? this.binder.getValue.call(this, e)
                    : s.Util.getInputValue(e);
                }),
                e
              );
            })()),
            (s.ComponentBinding = (function (e) {
              function t(e, t, n) {
                var r, i, o, a, l, c, d, p;
                for (
                  this.view = e,
                  this.el = t,
                  this.type = n,
                  this.unbind = u(this.unbind, this),
                  this.bind = u(this.bind, this),
                  this.locals = u(this.locals, this),
                  this.component = this.view.components[this.type],
                  this.static = {},
                  this.observers = {},
                  this.upstreamObservers = {},
                  i = e.bindingRegExp(),
                  l = 0,
                  c = (d = this.el.attributes || []).length;
                  l < c;
                  l++
                )
                  (r = d[l]),
                    i.test(r.name) ||
                    ((o = this.camelCase(r.name)),
                      (a = s.TypeParser.parse(r.value)),
                      f.call(
                        null != (p = this.component.static) ? p : [],
                        o
                      ) >= 0
                        ? (this.static[o] = r.value)
                        : a.type === s.TypeParser.types.primitive
                          ? (this.static[o] = a.value)
                          : (this.observers[o] = r.value));
              }
              return (
                h(t, e),
                (t.prototype.sync = function () { }),
                (t.prototype.update = function () { }),
                (t.prototype.publish = function () { }),
                (t.prototype.locals = function () {
                  var e, t, n, r, i, s;
                  for (e in ((n = {}), (i = this.static)))
                    (r = i[e]), (n[e] = r);
                  for (e in (s = this.observers))
                    (t = s[e]), (n[e] = t.value());
                  return n;
                }),
                (t.prototype.camelCase = function (e) {
                  return e.replace(/-([a-z])/g, function (e) {
                    return e[1].toUpperCase();
                  });
                }),
                (t.prototype.bind = function () {
                  var e,
                    t,
                    n,
                    r,
                    i,
                    o,
                    a,
                    l,
                    c,
                    u,
                    d,
                    p,
                    h,
                    f,
                    m,
                    v,
                    g,
                    y,
                    b,
                    w;
                  if (!this.bound) {
                    for (t in (f = this.observers))
                      (n = f[t]),
                        (this.observers[t] = this.observe(
                          this.view.models,
                          n,
                          (function (e) {
                            return function (t) {
                              return function () {
                                return (e.componentView.models[t] =
                                  e.observers[t].value());
                              };
                            };
                          })(this).call(this, t)
                        ));
                    this.bound = !0;
                  }
                  if (null != this.componentView) this.componentView.bind();
                  else {
                    for (
                      this.el.innerHTML = this.component.template.call(this),
                      a = this.component.initialize.call(
                        this,
                        this.el,
                        this.locals()
                      ),
                      this.el._bound = !0,
                      o = {},
                      u = 0,
                      p = (m = s.extensions).length;
                      u < p;
                      u++
                    ) {
                      if (((o[(i = m[u])] = {}), this.component[i]))
                        for (e in (v = this.component[i]))
                          (l = v[e]), (o[i][e] = l);
                      for (e in (g = this.view[i]))
                        (l = g[e]), null == (c = o[i])[e] && (c[e] = l);
                    }
                    for (d = 0, h = (y = s.options).length; d < h; d++)
                      o[(i = y[d])] =
                        null != (b = this.component[i]) ? b : this.view[i];
                    for (t in ((this.componentView = new s.View(
                      Array.prototype.slice.call(this.el.childNodes),
                      a,
                      o
                    )),
                      this.componentView.bind(),
                      (w = this.observers)))
                      (r = w[t]),
                        (this.upstreamObservers[t] = this.observe(
                          this.componentView.models,
                          t,
                          (function (e) {
                            return function (t, n) {
                              return function () {
                                return n.setValue(e.componentView.models[t]);
                              };
                            };
                          })(this).call(this, t, r)
                        ));
                  }
                }),
                (t.prototype.unbind = function () {
                  var e, t, n, r;
                  for (e in (t = this.upstreamObservers)) t[e].unobserve();
                  for (e in (n = this.observers)) n[e].unobserve();
                  return null != (r = this.componentView)
                    ? r.unbind.call(this)
                    : void 0;
                }),
                t
              );
            })(s.Binding)),
            (s.TextBinding = (function (e) {
              function t(e, t, n, r, i) {
                (this.view = e),
                  (this.el = t),
                  (this.type = n),
                  (this.keypath = r),
                  (this.options = null != i ? i : {}),
                  (this.sync = u(this.sync, this)),
                  (this.formatters = this.options.formatters || []),
                  (this.dependencies = []),
                  (this.formatterObservers = {});
              }
              return (
                h(t, e),
                (t.prototype.binder = {
                  routine: function (e, t) {
                    return (e.data = null != t ? t : "");
                  },
                }),
                (t.prototype.sync = function () {
                  return t.__super__.sync.apply(this, arguments);
                }),
                t
              );
            })(s.Binding)),
            (s.public.binders.text = function (e, t) {
              return null != e.textContent
                ? (e.textContent = null != t ? t : "")
                : (e.innerText = null != t ? t : "");
            }),
            (s.public.binders.html = function (e, t) {
              return (e.innerHTML = null != t ? t : "");
            }),
            (s.public.binders.show = function (e, t) {
              return (e.style.display = t ? "" : "none");
            }),
            (s.public.binders.hide = function (e, t) {
              return (e.style.display = t ? "none" : "");
            }),
            (s.public.binders.enabled = function (e, t) {
              return (e.disabled = !t);
            }),
            (s.public.binders.disabled = function (e, t) {
              return (e.disabled = !!t);
            }),
            (s.public.binders.checked = {
              publishes: !0,
              priority: 2e3,
              bind: function (e) {
                return s.Util.bindEvent(e, "change", this.publish);
              },
              unbind: function (e) {
                return s.Util.unbindEvent(e, "change", this.publish);
              },
              routine: function (e, t) {
                var n;
                return "radio" === e.type
                  ? (e.checked =
                    (null != (n = e.value) ? n.toString() : void 0) ===
                    (null != t ? t.toString() : void 0))
                  : (e.checked = !!t);
              },
            }),
            (s.public.binders.unchecked = {
              publishes: !0,
              priority: 2e3,
              bind: function (e) {
                return s.Util.bindEvent(e, "change", this.publish);
              },
              unbind: function (e) {
                return s.Util.unbindEvent(e, "change", this.publish);
              },
              routine: function (e, t) {
                var n;
                return "radio" === e.type
                  ? (e.checked =
                    (null != (n = e.value) ? n.toString() : void 0) !==
                    (null != t ? t.toString() : void 0))
                  : (e.checked = !t);
              },
            }),
            (s.public.binders.value = {
              publishes: !0,
              priority: 3e3,
              bind: function (e) {
                if ("INPUT" !== e.tagName || "radio" !== e.type)
                  return (
                    (this.event =
                      "SELECT" === e.tagName ? "change" : "input"),
                    s.Util.bindEvent(e, this.event, this.publish)
                  );
              },
              unbind: function (e) {
                if ("INPUT" !== e.tagName || "radio" !== e.type)
                  return s.Util.unbindEvent(e, this.event, this.publish);
              },
              routine: function (e, t) {
                var n, r, i, s, o, l, c;
                if ("INPUT" === e.tagName && "radio" === e.type)
                  return e.setAttribute("value", t);
                if (null != window.jQuery) {
                  if (
                    ((e = a(e)),
                      (null != t ? t.toString() : void 0) !==
                      (null != (s = e.val()) ? s.toString() : void 0))
                  )
                    return e.val(null != t ? t : "");
                } else if ("select-multiple" === e.type) {
                  if (null != t) {
                    for (c = [], r = 0, i = e.length; r < i; r++)
                      (n = e[r]),
                        c.push(
                          (n.selected = ((o = n.value), f.call(t, o) >= 0))
                        );
                    return c;
                  }
                } else if (
                  (null != t ? t.toString() : void 0) !==
                  (null != (l = e.value) ? l.toString() : void 0)
                )
                  return (e.value = null != t ? t : "");
              },
            }),
            (s.public.binders.if = {
              block: !0,
              priority: 4e3,
              bind: function (e) {
                var t, n;
                if (null == this.marker)
                  return (
                    (t = [this.view.prefix, this.type]
                      .join("-")
                      .replace("--", "-")),
                    (n = e.getAttribute(t)),
                    (this.marker = document.createComment(
                      " rivets: " + this.type + " " + n + " "
                    )),
                    (this.bound = !1),
                    e.removeAttribute(t),
                    e.parentNode.insertBefore(this.marker, e),
                    e.parentNode.removeChild(e)
                  );
              },
              unbind: function () {
                if (this.nested)
                  return this.nested.unbind(), (this.bound = !1);
              },
              routine: function (e, t) {
                var n, r, i, o;
                if (!!t == !this.bound) {
                  if (t) {
                    for (n in ((i = {}), (o = this.view.models)))
                      (r = o[n]), (i[n] = r);
                    return (
                      (
                        this.nested ||
                        (this.nested = new s.View(e, i, this.view.options()))
                      ).bind(),
                      this.marker.parentNode.insertBefore(
                        e,
                        this.marker.nextSibling
                      ),
                      (this.bound = !0)
                    );
                  }
                  return (
                    e.parentNode.removeChild(e),
                    this.nested.unbind(),
                    (this.bound = !1)
                  );
                }
              },
              update: function (e) {
                var t;
                return null != (t = this.nested) ? t.update(e) : void 0;
              },
            }),
            (s.public.binders.unless = {
              block: !0,
              priority: 4e3,
              bind: function (e) {
                return s.public.binders.if.bind.call(this, e);
              },
              unbind: function () {
                return s.public.binders.if.unbind.call(this);
              },
              routine: function (e, t) {
                return s.public.binders.if.routine.call(this, e, !t);
              },
              update: function (e) {
                return s.public.binders.if.update.call(this, e);
              },
            }),
            (s.public.binders["on-*"] = {
              function: !0,
              priority: 1e3,
              unbind: function (e) {
                if (this.handler)
                  return s.Util.unbindEvent(e, this.args[0], this.handler);
              },
              routine: function (e, t) {
                return (
                  this.handler &&
                  s.Util.unbindEvent(e, this.args[0], this.handler),
                  s.Util.bindEvent(
                    e,
                    this.args[0],
                    (this.handler = this.eventHandler(t))
                  )
                );
              },
            }),
            (s.public.binders["each-*"] = {
              block: !0,
              priority: 4e3,
              bind: function (e) {
                var t, n, r, i;
                if (null == this.marker)
                  (t = [this.view.prefix, this.type]
                    .join("-")
                    .replace("--", "-")),
                    (this.marker = document.createComment(
                      " rivets: " + this.type + " "
                    )),
                    (this.iterated = []),
                    e.removeAttribute(t),
                    e.parentNode.insertBefore(this.marker, e),
                    e.parentNode.removeChild(e);
                else
                  for (n = 0, r = (i = this.iterated).length; n < r; n++)
                    i[n].bind();
              },
              unbind: function (e) {
                var t, n, r;
                if (null != this.iterated)
                  for (t = 0, n = (r = this.iterated).length; t < n; t++)
                    r[t].unbind();
              },
              routine: function (e, t) {
                var n, r, i, o, a, l, c, u, d, p, h, f, m, v, g, y, b, w, E;
                if (
                  ((l = this.args[0]),
                    (t = t || []),
                    this.iterated.length > t.length)
                )
                  for (
                    h = 0,
                    v = (b = Array(this.iterated.length - t.length)).length;
                    h < v;
                    h++
                  )
                    b[h],
                      (p = this.iterated.pop()).unbind(),
                      this.marker.parentNode.removeChild(p.els[0]);
                for (i = f = 0, g = t.length; f < g; i = ++f)
                  if (
                    ((a = t[i]),
                      ((r = { index: i })[s.public.iterationAlias(l)] = i),
                      (r[l] = a),
                      null == this.iterated[i])
                  ) {
                    for (o in (w = this.view.models))
                      (a = w[o]), null == r[o] && (r[o] = a);
                    (u = this.iterated.length
                      ? this.iterated[this.iterated.length - 1].els[0]
                      : this.marker),
                      ((c = this.view.options()).preloadData = !0),
                      (d = e.cloneNode(!0)),
                      (p = new s.View(d, r, c)).bind(),
                      this.iterated.push(p),
                      this.marker.parentNode.insertBefore(d, u.nextSibling);
                  } else
                    this.iterated[i].models[l] !== a &&
                      this.iterated[i].update(r);
                if ("OPTION" === e.nodeName)
                  for (m = 0, y = (E = this.view.bindings).length; m < y; m++)
                    (n = E[m]).el === this.marker.parentNode &&
                      "value" === n.type &&
                      n.sync();
              },
              update: function (e) {
                var t, n, r, i, s, o;
                for (n in ((t = {}), e))
                  (r = e[n]), n !== this.args[0] && (t[n] = r);
                for (i = 0, s = (o = this.iterated).length; i < s; i++)
                  o[i].update(t);
              },
            }),
            (s.public.binders["class-*"] = function (e, t) {
              var n;
              if (
                !t ==
                (-1 !==
                  (n = " " + e.className + " ").indexOf(
                    " " + this.args[0] + " "
                  ))
              )
                return (e.className = t
                  ? e.className + " " + this.args[0]
                  : n.replace(" " + this.args[0] + " ", " ").trim());
            }),
            (s.public.binders["*"] = function (e, t) {
              return null != t
                ? e.setAttribute(this.type, t)
                : e.removeAttribute(this.type);
            }),
            (s.public.formatters.call = function () {
              var e, t;
              return (
                (t = arguments[0]),
                (e = 2 <= arguments.length ? d.call(arguments, 1) : []),
                t.call.apply(t, [this].concat(d.call(e)))
              );
            }),
            (s.public.adapters["."] = {
              id: "_rv",
              counter: 0,
              weakmap: {},
              weakReference: function (e) {
                var t, n, r;
                return (
                  e.hasOwnProperty(this.id) ||
                  ((t = this.counter++),
                    Object.defineProperty(e, this.id, { value: t })),
                  (n = this.weakmap)[(r = e[this.id])] ||
                  (n[r] = { callbacks: {} })
                );
              },
              cleanupWeakReference: function (e, t) {
                if (
                  !(
                    Object.keys(e.callbacks).length ||
                    (e.pointers && Object.keys(e.pointers).length)
                  )
                )
                  return delete this.weakmap[t];
              },
              stubFunction: function (e, t) {
                var n, r, i;
                return (
                  (r = e[t]),
                  (n = this.weakReference(e)),
                  (i = this.weakmap),
                  (e[t] = function () {
                    var t, s, o, a, l, c, u, d, p;
                    for (s in ((o = r.apply(e, arguments)), (c = n.pointers)))
                      for (
                        t = c[s],
                        a = 0,
                        l = (p =
                          null !=
                            (u = null != (d = i[s]) ? d.callbacks[t] : void 0)
                            ? u
                            : []).length;
                        a < l;
                        a++
                      )
                        (0, p[a])();
                    return o;
                  })
                );
              },
              observeMutations: function (e, t, n) {
                var r, i, s, o, a, l;
                if (Array.isArray(e)) {
                  if (null == (s = this.weakReference(e)).pointers)
                    for (
                      s.pointers = {},
                      a = 0,
                      l = (i = [
                        "push",
                        "pop",
                        "shift",
                        "unshift",
                        "sort",
                        "reverse",
                        "splice",
                      ]).length;
                      a < l;
                      a++
                    )
                      (r = i[a]), this.stubFunction(e, r);
                  if (
                    (null == (o = s.pointers)[t] && (o[t] = []),
                      f.call(s.pointers[t], n) < 0)
                  )
                    return s.pointers[t].push(n);
                }
              },
              unobserveMutations: function (e, t, n) {
                var r, i, s;
                if (
                  Array.isArray(e) &&
                  null != e[this.id] &&
                  (i = this.weakmap[e[this.id]]) &&
                  (s = i.pointers[t])
                )
                  return (
                    (r = s.indexOf(n)) >= 0 && s.splice(r, 1),
                    s.length || delete i.pointers[t],
                    this.cleanupWeakReference(i, e[this.id])
                  );
              },
              observe: function (e, t, n) {
                var r, i, s, o;
                return (
                  null == (r = this.weakReference(e).callbacks)[t] &&
                  ((r[t] = []),
                    (null != (i = Object.getOwnPropertyDescriptor(e, t))
                      ? i.get
                      : void 0) ||
                    (null != i ? i.set : void 0) ||
                    ((s = e[t]),
                      Object.defineProperty(e, t, {
                        enumerable: !0,
                        get: function () {
                          return s;
                        },
                        set:
                          ((o = this),
                            function (n) {
                              var i, a, l, c, u;
                              if (
                                n !== s &&
                                (o.unobserveMutations(s, e[o.id], t),
                                  (s = n),
                                  (a = o.weakmap[e[o.id]]))
                              ) {
                                if ((r = a.callbacks)[t])
                                  for (
                                    l = 0, c = (u = r[t].slice()).length;
                                    l < c;
                                    l++
                                  )
                                    (i = u[l]), f.call(r[t], i) >= 0 && i();
                                return o.observeMutations(n, e[o.id], t);
                              }
                            }),
                      }))),
                  f.call(r[t], n) < 0 && r[t].push(n),
                  this.observeMutations(e[t], e[this.id], t)
                );
              },
              unobserve: function (e, t, n) {
                var r, i, s;
                if ((s = this.weakmap[e[this.id]]) && (r = s.callbacks[t]))
                  return (
                    (i = r.indexOf(n)) >= 0 &&
                    (r.splice(i, 1),
                      r.length ||
                      (delete s.callbacks[t],
                        this.unobserveMutations(e[t], e[this.id], t))),
                    this.cleanupWeakReference(s, e[this.id])
                  );
              },
              get: function (e, t) {
                return e[t];
              },
              set: function (e, t, n) {
                return (e[t] = n);
              },
            }),
            (s.factory = function (e) {
              return (s.sightglass = e), (s.public._ = s), s.public;
            }),
            "object" == typeof (null !== e ? e.exports : void 0)
              ? (e.exports = s.factory(n(206)))
              : ((r = [n(206)]),
                void 0 ===
                (i = function (e) {
                  return (this.rivets = s.factory(e));
                }.apply(t, r)) || (e.exports = i));
        }.call(this);
    },
    206: function (e, t) {
      var n;
      (function () {
        function r(e, t, n, r) {
          return new i(e, t, n, r);
        }
        function i(e, t, n, r) {
          (this.options = r || {}),
            (this.options.adapters = this.options.adapters || {}),
            (this.obj = e),
            (this.keypath = t),
            (this.callback = n),
            (this.objectPath = []),
            (this.update = this.update.bind(this)),
            this.parse(),
            s((this.target = this.realize())) &&
            this.set(!0, this.key, this.target, this.callback);
        }
        function s(e) {
          return "object" == typeof e && null !== e;
        }
        function o(e) {
          throw new Error("[sightglass] " + e);
        }
        (r.adapters = {}),
          (i.tokenize = function (e, t, n) {
            var r,
              i,
              s = [],
              o = { i: n, path: "" };
            for (r = 0; r < e.length; r++)
              (i = e.charAt(r)),
                ~t.indexOf(i)
                  ? (s.push(o), (o = { i: i, path: "" }))
                  : (o.path += i);
            return s.push(o), s;
          }),
          (i.prototype.parse = function () {
            var e,
              t,
              n = this.interfaces();
            n.length || o("Must define at least one adapter interface."),
              ~n.indexOf(this.keypath[0])
                ? ((e = this.keypath[0]), (t = this.keypath.substr(1)))
                : (void 0 === (e = this.options.root || r.root) &&
                  o("Must define a default root adapter."),
                  (t = this.keypath)),
              (this.tokens = i.tokenize(t, n, e)),
              (this.key = this.tokens.pop());
          }),
          (i.prototype.realize = function () {
            var e,
              t = this.obj,
              n = !1;
            return (
              this.tokens.forEach(function (r, i) {
                s(t)
                  ? (void 0 !== this.objectPath[i]
                    ? t !== (e = this.objectPath[i]) &&
                    (this.set(!1, r, e, this.update),
                      this.set(!0, r, t, this.update),
                      (this.objectPath[i] = t))
                    : (this.set(!0, r, t, this.update),
                      (this.objectPath[i] = t)),
                    (t = this.get(r, t)))
                  : (!1 === n && (n = i),
                    (e = this.objectPath[i]) &&
                    this.set(!1, r, e, this.update));
              }, this),
              !1 !== n && this.objectPath.splice(n),
              t
            );
          }),
          (i.prototype.update = function () {
            var e, t;
            (e = this.realize()) !== this.target &&
              (s(this.target) &&
                this.set(!1, this.key, this.target, this.callback),
                s(e) && this.set(!0, this.key, e, this.callback),
                (t = this.value()),
                (this.target = e),
                (this.value() instanceof Function || this.value() !== t) &&
                this.callback());
          }),
          (i.prototype.value = function () {
            if (s(this.target)) return this.get(this.key, this.target);
          }),
          (i.prototype.setValue = function (e) {
            s(this.target) &&
              this.adapter(this.key).set(this.target, this.key.path, e);
          }),
          (i.prototype.get = function (e, t) {
            return this.adapter(e).get(t, e.path);
          }),
          (i.prototype.set = function (e, t, n, r) {
            var i = e ? "observe" : "unobserve";
            this.adapter(t)[i](n, t.path, r);
          }),
          (i.prototype.interfaces = function () {
            var e = Object.keys(this.options.adapters);
            return (
              Object.keys(r.adapters).forEach(function (t) {
                ~e.indexOf(t) || e.push(t);
              }),
              e
            );
          }),
          (i.prototype.adapter = function (e) {
            return this.options.adapters[e.i] || r.adapters[e.i];
          }),
          (i.prototype.unobserve = function () {
            var e;
            this.tokens.forEach(function (t, n) {
              (e = this.objectPath[n]) && this.set(!1, t, e, this.update);
            }, this),
              s(this.target) &&
              this.set(!1, this.key, this.target, this.callback);
          }),
          e.exports
            ? (e.exports = r)
            : void 0 ===
            (n = function () {
              return (this.sightglass = r);
            }.apply(t, [])) || (e.exports = n);
      }).call(this);
    },
    61: function (e, t, n) {
      var r = n(698).default;
      function i() {
        "use strict";
        (e.exports = i =
          function () {
            return t;
          }),
          (e.exports.__esModule = !0),
          (e.exports.default = e.exports);
        var t = {},
          n = Object.prototype,
          s = n.hasOwnProperty,
          o =
            Object.defineProperty ||
            function (e, t, n) {
              e[t] = n.value;
            },
          a = "function" == typeof Symbol ? Symbol : {},
          l = a.iterator || "@@iterator",
          c = a.asyncIterator || "@@asyncIterator",
          u = a.toStringTag || "@@toStringTag";
        function d(e, t, n) {
          return (
            Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            }),
            e[t]
          );
        }
        try {
          d({}, "");
        } catch (e) {
          d = function (e, t, n) {
            return (e[t] = n);
          };
        }
        function p(e, t, n, r) {
          var i = t && t.prototype instanceof m ? t : m,
            s = Object.create(i.prototype),
            a = new P(r || []);
          return o(s, "_invoke", { value: S(e, n, a) }), s;
        }
        function h(e, t, n) {
          try {
            return { type: "normal", arg: e.call(t, n) };
          } catch (e) {
            return { type: "throw", arg: e };
          }
        }
        t.wrap = p;
        var f = {};
        function m() { }
        function v() { }
        function g() { }
        var y = {};
        d(y, l, function () {
          return this;
        });
        var b = Object.getPrototypeOf,
          w = b && b(b(L([])));
        w && w !== n && s.call(w, l) && (y = w);
        var E = (g.prototype = m.prototype = Object.create(y));
        function x(e) {
          ["next", "throw", "return"].forEach(function (t) {
            d(e, t, function (e) {
              return this._invoke(t, e);
            });
          });
        }
        function T(e, t) {
          function n(i, o, a, l) {
            var c = h(e[i], e, o);
            if ("throw" !== c.type) {
              var u = c.arg,
                d = u.value;
              return d && "object" == r(d) && s.call(d, "__await")
                ? t.resolve(d.__await).then(
                  function (e) {
                    n("next", e, a, l);
                  },
                  function (e) {
                    n("throw", e, a, l);
                  }
                )
                : t.resolve(d).then(
                  function (e) {
                    (u.value = e), a(u);
                  },
                  function (e) {
                    return n("throw", e, a, l);
                  }
                );
            }
            l(c.arg);
          }
          var i;
          o(this, "_invoke", {
            value: function (e, r) {
              function s() {
                return new t(function (t, i) {
                  n(e, r, t, i);
                });
              }
              return (i = i ? i.then(s, s) : s());
            },
          });
        }
        function S(e, t, n) {
          var r = "suspendedStart";
          return function (i, s) {
            if ("executing" === r)
              throw new Error("Generator is already running");
            if ("completed" === r) {
              if ("throw" === i) throw s;
              return $();
            }
            for (n.method = i, n.arg = s; ;) {
              var o = n.delegate;
              if (o) {
                var a = C(o, n);
                if (a) {
                  if (a === f) continue;
                  return a;
                }
              }
              if ("next" === n.method) n.sent = n._sent = n.arg;
              else if ("throw" === n.method) {
                if ("suspendedStart" === r) throw ((r = "completed"), n.arg);
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = "executing";
              var l = h(e, t, n);
              if ("normal" === l.type) {
                if (
                  ((r = n.done ? "completed" : "suspendedYield"), l.arg === f)
                )
                  continue;
                return { value: l.arg, done: n.done };
              }
              "throw" === l.type &&
                ((r = "completed"), (n.method = "throw"), (n.arg = l.arg));
            }
          };
        }
        function C(e, t) {
          var n = t.method,
            r = e.iterator[n];
          if (void 0 === r)
            return (
              (t.delegate = null),
              ("throw" === n &&
                e.iterator.return &&
                ((t.method = "return"),
                  (t.arg = void 0),
                  C(e, t),
                  "throw" === t.method)) ||
              ("return" !== n &&
                ((t.method = "throw"),
                  (t.arg = new TypeError(
                    "The iterator does not provide a '" + n + "' method"
                  )))),
              f
            );
          var i = h(r, e.iterator, t.arg);
          if ("throw" === i.type)
            return (
              (t.method = "throw"), (t.arg = i.arg), (t.delegate = null), f
            );
          var s = i.arg;
          return s
            ? s.done
              ? ((t[e.resultName] = s.value),
                (t.next = e.nextLoc),
                "return" !== t.method &&
                ((t.method = "next"), (t.arg = void 0)),
                (t.delegate = null),
                f)
              : s
            : ((t.method = "throw"),
              (t.arg = new TypeError("iterator result is not an object")),
              (t.delegate = null),
              f);
        }
        function k(e) {
          var t = { tryLoc: e[0] };
          1 in e && (t.catchLoc = e[1]),
            2 in e && ((t.finallyLoc = e[2]), (t.afterLoc = e[3])),
            this.tryEntries.push(t);
        }
        function O(e) {
          var t = e.completion || {};
          (t.type = "normal"), delete t.arg, (e.completion = t);
        }
        function P(e) {
          (this.tryEntries = [{ tryLoc: "root" }]),
            e.forEach(k, this),
            this.reset(!0);
        }
        function L(e) {
          if (e) {
            var t = e[l];
            if (t) return t.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
              var n = -1,
                r = function t() {
                  for (; ++n < e.length;)
                    if (s.call(e, n))
                      return (t.value = e[n]), (t.done = !1), t;
                  return (t.value = void 0), (t.done = !0), t;
                };
              return (r.next = r);
            }
          }
          return { next: $ };
        }
        function $() {
          return { value: void 0, done: !0 };
        }
        return (
          (v.prototype = g),
          o(E, "constructor", { value: g, configurable: !0 }),
          o(g, "constructor", { value: v, configurable: !0 }),
          (v.displayName = d(g, u, "GeneratorFunction")),
          (t.isGeneratorFunction = function (e) {
            var t = "function" == typeof e && e.constructor;
            return (
              !!t &&
              (t === v || "GeneratorFunction" === (t.displayName || t.name))
            );
          }),
          (t.mark = function (e) {
            return (
              Object.setPrototypeOf
                ? Object.setPrototypeOf(e, g)
                : ((e.__proto__ = g), d(e, u, "GeneratorFunction")),
              (e.prototype = Object.create(E)),
              e
            );
          }),
          (t.awrap = function (e) {
            return { __await: e };
          }),
          x(T.prototype),
          d(T.prototype, c, function () {
            return this;
          }),
          (t.AsyncIterator = T),
          (t.async = function (e, n, r, i, s) {
            void 0 === s && (s = Promise);
            var o = new T(p(e, n, r, i), s);
            return t.isGeneratorFunction(n)
              ? o
              : o.next().then(function (e) {
                return e.done ? e.value : o.next();
              });
          }),
          x(E),
          d(E, u, "Generator"),
          d(E, l, function () {
            return this;
          }),
          d(E, "toString", function () {
            return "[object Generator]";
          }),
          (t.keys = function (e) {
            var t = Object(e),
              n = [];
            for (var r in t) n.push(r);
            return (
              n.reverse(),
              function e() {
                for (; n.length;) {
                  var r = n.pop();
                  if (r in t) return (e.value = r), (e.done = !1), e;
                }
                return (e.done = !0), e;
              }
            );
          }),
          (t.values = L),
          (P.prototype = {
            constructor: P,
            reset: function (e) {
              if (
                ((this.prev = 0),
                  (this.next = 0),
                  (this.sent = this._sent = void 0),
                  (this.done = !1),
                  (this.delegate = null),
                  (this.method = "next"),
                  (this.arg = void 0),
                  this.tryEntries.forEach(O),
                  !e)
              )
                for (var t in this)
                  "t" === t.charAt(0) &&
                    s.call(this, t) &&
                    !isNaN(+t.slice(1)) &&
                    (this[t] = void 0);
            },
            stop: function () {
              this.done = !0;
              var e = this.tryEntries[0].completion;
              if ("throw" === e.type) throw e.arg;
              return this.rval;
            },
            dispatchException: function (e) {
              if (this.done) throw e;
              var t = this;
              function n(n, r) {
                return (
                  (o.type = "throw"),
                  (o.arg = e),
                  (t.next = n),
                  r && ((t.method = "next"), (t.arg = void 0)),
                  !!r
                );
              }
              for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                var i = this.tryEntries[r],
                  o = i.completion;
                if ("root" === i.tryLoc) return n("end");
                if (i.tryLoc <= this.prev) {
                  var a = s.call(i, "catchLoc"),
                    l = s.call(i, "finallyLoc");
                  if (a && l) {
                    if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                    if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                  } else if (a) {
                    if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                  } else {
                    if (!l)
                      throw new Error(
                        "try statement without catch or finally"
                      );
                    if (this.prev < i.finallyLoc) return n(i.finallyLoc);
                  }
                }
              }
            },
            abrupt: function (e, t) {
              for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                var r = this.tryEntries[n];
                if (
                  r.tryLoc <= this.prev &&
                  s.call(r, "finallyLoc") &&
                  this.prev < r.finallyLoc
                ) {
                  var i = r;
                  break;
                }
              }
              i &&
                ("break" === e || "continue" === e) &&
                i.tryLoc <= t &&
                t <= i.finallyLoc &&
                (i = null);
              var o = i ? i.completion : {};
              return (
                (o.type = e),
                (o.arg = t),
                i
                  ? ((this.method = "next"), (this.next = i.finallyLoc), f)
                  : this.complete(o)
              );
            },
            complete: function (e, t) {
              if ("throw" === e.type) throw e.arg;
              return (
                "break" === e.type || "continue" === e.type
                  ? (this.next = e.arg)
                  : "return" === e.type
                    ? ((this.rval = this.arg = e.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === e.type && t && (this.next = t),
                f
              );
            },
            finish: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.finallyLoc === e)
                  return this.complete(n.completion, n.afterLoc), O(n), f;
              }
            },
            catch: function (e) {
              for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                var n = this.tryEntries[t];
                if (n.tryLoc === e) {
                  var r = n.completion;
                  if ("throw" === r.type) {
                    var i = r.arg;
                    O(n);
                  }
                  return i;
                }
              }
              throw new Error("illegal catch attempt");
            },
            delegateYield: function (e, t, n) {
              return (
                (this.delegate = {
                  iterator: L(e),
                  resultName: t,
                  nextLoc: n,
                }),
                "next" === this.method && (this.arg = void 0),
                f
              );
            },
          }),
          t
        );
      }
      (e.exports = i),
        (e.exports.__esModule = !0),
        (e.exports.default = e.exports);
    },
    698: function (e) {
      function t(n) {
        return (
          (e.exports = t =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (e) {
                return typeof e;
              }
              : function (e) {
                return e &&
                  "function" == typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              }),
          (e.exports.__esModule = !0),
          (e.exports.default = e.exports),
          t(n)
        );
      }
      (e.exports = t),
        (e.exports.__esModule = !0),
        (e.exports.default = e.exports);
    },
    687: function (e, t, n) {
      var r = n(61)();
      e.exports = r;
      try {
        regeneratorRuntime = r;
      } catch (e) {
        "object" == typeof globalThis
          ? (globalThis.regeneratorRuntime = r)
          : Function("r", "regeneratorRuntime = r")(r);
      }
    },
  },
    t = {};
  function n(r) {
    var i = t[r];
    if (void 0 !== i) return i.exports;
    var s = (t[r] = { id: r, loaded: !1, exports: {} });
    return e[r].call(s.exports, s, s.exports, n), (s.loaded = !0), s.exports;
  }
  (n.n = function (e) {
    var t =
      e && e.__esModule
        ? function () {
          return e.default;
        }
        : function () {
          return e;
        };
    return n.d(t, { a: t }), t;
  }),
    (n.d = function (e, t) {
      for (var r in t)
        n.o(t, r) &&
          !n.o(e, r) &&
          Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    }),
    (n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (n.nmd = function (e) {
      return (e.paths = []), e.children || (e.children = []), e;
    }),
    (function () {
      "use strict";
      function e(e, t, n, r, i, s, o) {
        try {
          var a = e[s](o),
            l = a.value;
        } catch (e) {
          return void n(e);
        }
        a.done ? t(l) : Promise.resolve(l).then(r, i);
      }
      function t(t) {
        return function () {
          var n = this,
            r = arguments;
          return new Promise(function (i, s) {
            var o = t.apply(n, r);
            function a(t) {
              e(o, i, s, a, l, "next", t);
            }
            function l(t) {
              e(o, i, s, a, l, "throw", t);
            }
            a(void 0);
          });
        };
      }
      function r(e, t) {
        if (!(e instanceof t))
          throw new TypeError("Cannot call a class as a function");
      }
      function i(e) {
        return (
          (i =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (e) {
                return typeof e;
              }
              : function (e) {
                return e &&
                  "function" == typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              }),
          i(e)
        );
      }
      function s(e) {
        var t = (function (e, t) {
          if ("object" !== i(e) || null === e) return e;
          var n = e[Symbol.toPrimitive];
          if (void 0 !== n) {
            var r = n.call(e, t || "default");
            if ("object" !== i(r)) return r;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return ("string" === t ? String : Number)(e);
        })(e, "string");
        return "symbol" === i(t) ? t : String(t);
      }
      function o(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1),
            (r.configurable = !0),
            "value" in r && (r.writable = !0),
            Object.defineProperty(e, s(r.key), r);
        }
      }
      function a(e, t, n) {
        return (
          t && o(e.prototype, t),
          n && o(e, n),
          Object.defineProperty(e, "prototype", { writable: !1 }),
          e
        );
      }
      function l(e, t) {
        return (
          (l = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (e, t) {
              return (e.__proto__ = t), e;
            }),
          l(e, t)
        );
      }
      function c(e, t) {
        if ("function" != typeof t && null !== t)
          throw new TypeError(
            "Super expression must either be null or a function"
          );
        (e.prototype = Object.create(t && t.prototype, {
          constructor: { value: e, writable: !0, configurable: !0 },
        })),
          Object.defineProperty(e, "prototype", { writable: !1 }),
          t && l(e, t);
      }
      function u(e) {
        if (void 0 === e)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return e;
      }
      function d(e, t) {
        if (t && ("object" === i(t) || "function" == typeof t)) return t;
        if (void 0 !== t)
          throw new TypeError(
            "Derived constructors may only return object or undefined"
          );
        return u(e);
      }
      function p(e) {
        return (
          (p = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (e) {
              return e.__proto__ || Object.getPrototypeOf(e);
            }),
          p(e)
        );
      }
      function h(e, t, n) {
        return (
          (h = (function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () { })
                ),
                !0
              );
            } catch (e) {
              return !1;
            }
          })()
            ? Reflect.construct.bind()
            : function (e, t, n) {
              var r = [null];
              r.push.apply(r, t);
              var i = new (Function.bind.apply(e, r))();
              return n && l(i, n.prototype), i;
            }),
          h.apply(null, arguments)
        );
      }
      function f(e) {
        var t = "function" == typeof Map ? new Map() : void 0;
        return (
          (f = function (e) {
            if (
              null === e ||
              ((n = e),
                -1 === Function.toString.call(n).indexOf("[native code]"))
            )
              return e;
            var n;
            if ("function" != typeof e)
              throw new TypeError(
                "Super expression must either be null or a function"
              );
            if (void 0 !== t) {
              if (t.has(e)) return t.get(e);
              t.set(e, r);
            }
            function r() {
              return h(e, arguments, p(this).constructor);
            }
            return (
              (r.prototype = Object.create(e.prototype, {
                constructor: {
                  value: r,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                },
              })),
              l(r, e)
            );
          }),
          f(e)
        );
      }
      var m = n(687),
        v = n.n(m);
      function g(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function y(e) {
        return (
          (function (e) {
            if (Array.isArray(e)) return g(e);
          })(e) ||
          (function (e) {
            if (
              ("undefined" != typeof Symbol && null != e[Symbol.iterator]) ||
              null != e["@@iterator"]
            )
              return Array.from(e);
          })(e) ||
          (function (e, t) {
            if (e) {
              if ("string" == typeof e) return g(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              return (
                "Object" === n && e.constructor && (n = e.constructor.name),
                "Map" === n || "Set" === n
                  ? Array.from(e)
                  : "Arguments" === n ||
                    /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                    ? g(e, t)
                    : void 0
              );
            }
          })(e) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          })()
        );
      }
      var b = n(669),
        w = n.n(b)(),
        E = n(711),
        x = n.n(E)();
      function T(e, t) {
        var n =
          ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
          e["@@iterator"];
        if (!n) {
          if (
            Array.isArray(e) ||
            (n = (function (e, t) {
              if (!e) return;
              if ("string" == typeof e) return S(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              "Object" === n && e.constructor && (n = e.constructor.name);
              if ("Map" === n || "Set" === n) return Array.from(e);
              if (
                "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              )
                return S(e, t);
            })(e)) ||
            (t && e && "number" == typeof e.length)
          ) {
            n && (e = n);
            var r = 0,
              i = function () { };
            return {
              s: i,
              n: function () {
                return r >= e.length
                  ? { done: !0 }
                  : { done: !1, value: e[r++] };
              },
              e: function (e) {
                throw e;
              },
              f: i,
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        }
        var s,
          o = !0,
          a = !1;
        return {
          s: function () {
            n = n.call(e);
          },
          n: function () {
            var e = n.next();
            return (o = e.done), e;
          },
          e: function (e) {
            (a = !0), (s = e);
          },
          f: function () {
            try {
              o || null == n.return || n.return();
            } finally {
              if (a) throw s;
            }
          },
        };
      }
      function S(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function C(e) {
        var t = (function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Boolean.prototype.valueOf.call(
                Reflect.construct(Boolean, [], function () { })
              ),
              !0
            );
          } catch (e) {
            return !1;
          }
        })();
        return function () {
          var n,
            r = p(e);
          if (t) {
            var i = p(this).constructor;
            n = Reflect.construct(r, arguments, i);
          } else n = r.apply(this, arguments);
          return d(this, n);
        };
      }
      var k = (function () {
        function e() {
          r(this, e),
            (this.axios_backend = w.create({
              baseURL: window.serverUrl,
              timeout: 1e3,
              headers: { Token: window.signature, ID: window.customer_id },
            })),
            (this.overlay = document.getElementById("generic-overlay")),
            (this.loader = document.getElementById("generic-loader")),
            this.functions(),
            x.init();
        }
        return (
          a(e, [
            {
              key: "functions",
              value: function () {
                var e = this;
                (this.slideUp = function (e) {
                  var t =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : 300;
                  return new Promise(function (n, r) {
                    (e.style.height = e.offsetHeight + "px"),
                      (e.style.transitionProperty = "height, margin, padding"),
                      (e.style.transitionDuration = t + "ms"),
                      e.offsetHeight,
                      (e.style.overflow = "hidden"),
                      (e.style.height = 0),
                      (e.style.paddingTop = 0),
                      (e.style.paddingBottom = 0),
                      (e.style.marginTop = 0),
                      (e.style.marginBottom = 0),
                      window.setTimeout(function () {
                        (e.style.display = "none"),
                          e.style.removeProperty("height"),
                          e.style.removeProperty("padding-top"),
                          e.style.removeProperty("padding-bottom"),
                          e.style.removeProperty("margin-top"),
                          e.style.removeProperty("margin-bottom"),
                          e.style.removeProperty("overflow"),
                          e.style.removeProperty("transition-duration"),
                          e.style.removeProperty("transition-property"),
                          n(!1);
                      }, t);
                  });
                }),
                  (this.slideDown = function (e) {
                    var t =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : 300;
                    return new Promise(function (n, r) {
                      e.style.removeProperty("display");
                      var i = window.getComputedStyle(e).display;
                      "none" === i && (i = "block"), (e.style.display = i);
                      var s = e.offsetHeight;
                      (e.style.overflow = "hidden"),
                        (e.style.height = 0),
                        (e.style.paddingTop = 0),
                        (e.style.paddingBottom = 0),
                        (e.style.marginTop = 0),
                        (e.style.marginBottom = 0),
                        e.offsetHeight,
                        (e.style.transitionProperty =
                          "height, margin, padding"),
                        (e.style.transitionDuration = t + "ms"),
                        (e.style.height = s + "px"),
                        e.style.removeProperty("padding-top"),
                        e.style.removeProperty("padding-bottom"),
                        e.style.removeProperty("margin-top"),
                        e.style.removeProperty("margin-bottom"),
                        window.setTimeout(function () {
                          e.style.removeProperty("height"),
                            e.style.removeProperty("overflow"),
                            e.style.removeProperty("transition-duration"),
                            e.style.removeProperty("transition-property"),
                            n(!1);
                        }, t);
                    });
                  }),
                  (this.slideToggle = function (t) {
                    var n =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : 300;
                    return "none" == window.getComputedStyle(t).display
                      ? e.slideDown(t, n)
                      : e.slideUp(t, n);
                  }),
                  (this.debounce = function (t, n) {
                    var r;
                    return function () {
                      for (
                        var i = arguments.length, s = new Array(i), o = 0;
                        o < i;
                        o++
                      )
                        s[o] = arguments[o];
                      clearTimeout(r),
                        (r = setTimeout(function () {
                          return t.apply(e, s);
                        }, n));
                    };
                  }),
                  (this.toggleOverlay = function () {
                    e.overlay.toggleAttribute("hidden"),
                      document.body.classList.toggle("overflow-hidden");
                  }),
                  (this.toggleLoader = function () {
                    e.loader.toggleAttribute("hidden"),
                      document.body.classList.toggle("overflow-hidden");
                  }),
                  (this.Observe = function (e, t, n) {
                    var r = new MutationObserver(function (e) {
                      return y(e).forEach(n);
                    });
                    document.querySelectorAll(e).forEach(function (e) {
                      return r.observe(e, t);
                    });
                  }),
                  (this.handleize = function (e) {
                    if (null != e)
                      return (e = (e = (e = e
                        .replace(/'/g, "")
                        .replace("ß", "ss"))
                        .normalize("NFD")
                        .replace(/[\u0300-\u036f]/g, ""))
                        .toLowerCase()
                        .replace(/[^a-z0-9]+/g, "-")
                        .replace(/-$/, "")
                        .replace(/^-/, "")
                        .replace("ß", "ss"));
                  }),
                  (this.handleizeWithAccent = function (e) {
                    if (null != e)
                      return (e = (e = (e = e
                        .replace(/'/g, "")
                        .replace("ß", "ss"))
                        .normalize("NFD")
                        .replace(/[\u0300-\u036f]/g, ""))
                        .toLowerCase()
                        .replace(/[^a-z0-9]+/g, "-")
                        .replace(/-$/, "")
                        .replace(/^-/, "")
                        .replace("ß", "ss"));
                  }),
                  (this.opacityGo = function () {
                    document.addEventListener(
                      "DOMContentLoaded",
                      function () {
                        document.body.classList.remove("opacity-0");
                      },
                      { passive: !0 }
                    );
                  });
              },
            },
          ]),
          e
        );
      })();
      window.KercambreTheme = new k();
      var O = (function (e) {
        c(n, e);
        var t = C(n);
        function n() {
          var e;
          return r(this, n), ((e = t.call(this)).opened = !1), e;
        }
        return (
          a(n, [
            {
              key: "connectedCallback",
              value: function () {
                var e = this;
                (window.KercambreTheme.modal = this),
                  document.addEventListener("DOMContentLoaded", function () {
                    e.toggleListener();
                  });
              },
            },
            {
              key: "toggle",
              value: function (e) {
                var t = new CustomEvent("modal", {
                  detail: { opened: this.opened, html: e },
                });
                document.dispatchEvent(t);
              },
            },
            {
              key: "toggleListener",
              value: function () {
                var e = this,
                  t = this;
                document.addEventListener(
                  "modal",
                  function (e) {
                    var n = "opacity-100",
                      r = "opacity-0";
                    e.detail.opened
                      ? (t.classList.remove(n),
                        t.classList.add("pointer-events-none"),
                        t.classList.add(r),
                        (t.querySelector(".modal_content").innerHTML = ""))
                      : (null != e.detail.html &&
                        (t
                          .querySelector(".modal_content")
                          .append(e.detail.html),
                          t
                            .querySelector("#".concat(e.detail.html.id))
                            .classList.remove("hidden")),
                        t.classList.add(n),
                        t.classList.remove("pointer-events-none"),
                        t.classList.remove(r)),
                      window.overlay.toggle(),
                      (t.opened = !t.opened);
                  },
                  { passive: !0 }
                ),
                  document
                    .querySelectorAll("[action-toggle-modal]")
                    .forEach(function (t) {
                      t.addEventListener(
                        "click",
                        function () {
                          var n = t.dataset.modal
                            ? document
                              .querySelector("#".concat(t.dataset.modal))
                              .cloneNode(!0)
                            : null;
                          e.toggle(n);
                        },
                        { passive: !0 }
                      );
                    });
              },
            },
          ]),
          n
        );
      })(f(HTMLElement));
      customElements.define("modal-kercambre", O);
      var P = (function (e) {
        c(s, e);
        var n,
          i = C(s);
        function s() {
          var e;
          return (
            r(this, s),
            ((e = i.call(this)).opened = "true" == e.dataset.open),
            (e.contentElement = e.querySelector("[extra-content]")),
            (e.titleElement = e.querySelector("[extra-title]")),
            e
          );
        }
        return (
          a(s, [
            {
              key: "connectedCallback",
              value: function () {
                var e = this;
                this.updateElement(this.opened),
                  this.onClickListner(),
                  this.hasAttribute("data-optional") &&
                  this.optionalToggleHandle(),
                  document.addEventListener("DOMContentLoaded", function () {
                    e.footerCloseOnMobile();
                  });
              },
            },
            {
              key: "optionalToggleHandle",
              value: function () {
                var e = this;
                if (document.querySelector("#optionalOption")) {
                  var t = document.querySelector("#optionalOption");
                  t.onclick = function () {
                    t.checked
                      ? (e.classList.add("!block"),
                        document.querySelector("input[data-optional='true'") &&
                        (document.querySelector(
                          "input[data-optional='true'"
                        ).checked = !0))
                      : ((document.querySelector(
                        '[data-optional="true"][hidden]'
                      ).checked = !0),
                        e.classList.remove("!block"));
                  };
                }
              },
            },
            {
              key: "footerCloseOnMobile",
              value: function () {
                document.querySelectorAll("footer toggle-content-kercambre")
                  .length &&
                  document
                    .querySelectorAll("footer toggle-content-kercambre")
                    .forEach(
                      (function () {
                        var e = t(
                          v().mark(function e(t) {
                            return v().wrap(function (e) {
                              for (; ;)
                                switch ((e.prev = e.next)) {
                                  case 0:
                                    if (
                                      !matchMedia(
                                        "screen and (max-width: 768px)"
                                      ).matches
                                    ) {
                                      e.next = 4;
                                      break;
                                    }
                                    return (
                                      (e.next = 3),
                                      window.KercambreTheme.slideToggle(
                                        t.contentElement,
                                        200
                                      )
                                    );
                                  case 3:
                                    t.updateElement(!1);
                                  case 4:
                                  case "end":
                                    return e.stop();
                                }
                            }, e);
                          })
                        );
                        return function (t) {
                          return e.apply(this, arguments);
                        };
                      })()
                    );
              },
            },
            {
              key: "closeOthers",
              value: function () {
                var e = this;
                document.querySelectorAll(
                  "#collection-filters toggle-content-kercambre"
                ).length &&
                  document
                    .querySelectorAll(
                      "#collection-filters toggle-content-kercambre"
                    )
                    .forEach(
                      (function () {
                        var n = t(
                          v().mark(function t(n) {
                            return v().wrap(function (t) {
                              for (; ;)
                                switch ((t.prev = t.next)) {
                                  case 0:
                                    if (
                                      n == e ||
                                      !n.classList.contains("opened")
                                    ) {
                                      t.next = 4;
                                      break;
                                    }
                                    return (
                                      (t.next = 3),
                                      window.KercambreTheme.slideToggle(
                                        n.contentElement,
                                        200
                                      )
                                    );
                                  case 3:
                                    n.updateElement(!1);
                                  case 4:
                                  case "end":
                                    return t.stop();
                                }
                            }, t);
                          })
                        );
                        return function (e) {
                          return n.apply(this, arguments);
                        };
                      })()
                    ),
                  document.querySelectorAll(
                    "#mobile-menu toggle-content-kercambre"
                  ).length &&
                  document
                    .querySelectorAll("#mobile-menu toggle-content-kercambre")
                    .forEach(
                      (function () {
                        var n = t(
                          v().mark(function t(n) {
                            return v().wrap(function (t) {
                              for (; ;)
                                switch ((t.prev = t.next)) {
                                  case 0:
                                    if (
                                      n == e ||
                                      !n.classList.contains("opened")
                                    ) {
                                      t.next = 4;
                                      break;
                                    }
                                    return (
                                      (t.next = 3),
                                      window.KercambreTheme.slideToggle(
                                        n.contentElement,
                                        200
                                      )
                                    );
                                  case 3:
                                    n.updateElement(!1);
                                  case 4:
                                  case "end":
                                    return t.stop();
                                }
                            }, t);
                          })
                        );
                        return function (e) {
                          return n.apply(this, arguments);
                        };
                      })()
                    ),
                  document.querySelectorAll(
                    "#product-content toggle-content-kercambre"
                  ).length &&
                  document
                    .querySelectorAll(
                      "#product-content toggle-content-kercambre"
                    )
                    .forEach(
                      (function () {
                        var n = t(
                          v().mark(function t(n) {
                            return v().wrap(function (t) {
                              for (; ;)
                                switch ((t.prev = t.next)) {
                                  case 0:
                                    if (
                                      n == e ||
                                      !n.classList.contains("opened") ||
                                      "true" == n.dataset.optional
                                    ) {
                                      t.next = 4;
                                      break;
                                    }
                                    return (
                                      (t.next = 3),
                                      window.KercambreTheme.slideToggle(
                                        n.contentElement,
                                        200
                                      )
                                    );
                                  case 3:
                                    n.updateElement(!1);
                                  case 4:
                                  case "end":
                                    return t.stop();
                                }
                            }, t);
                          })
                        );
                        return function (e) {
                          return n.apply(this, arguments);
                        };
                      })()
                    ),
                  document.querySelectorAll("[faq]").length &&
                  document
                    .querySelectorAll("[faq] toggle-content-kercambre")
                    .forEach(
                      (function () {
                        var n = t(
                          v().mark(function t(n) {
                            return v().wrap(function (t) {
                              for (; ;)
                                switch ((t.prev = t.next)) {
                                  case 0:
                                    if (
                                      n == e ||
                                      !n.classList.contains("opened")
                                    ) {
                                      t.next = 4;
                                      break;
                                    }
                                    return (
                                      (t.next = 3),
                                      window.KercambreTheme.slideToggle(
                                        n.contentElement,
                                        200
                                      )
                                    );
                                  case 3:
                                    n.updateElement(!1);
                                  case 4:
                                  case "end":
                                    return t.stop();
                                }
                            }, t);
                          })
                        );
                        return function (e) {
                          return n.apply(this, arguments);
                        };
                      })()
                    );
              },
            },
            {
              key: "onClickListner",
              value: function () {
                var e = this;
                this.titleElement.addEventListener(
                  "click",
                  (function () {
                    var n = t(
                      v().mark(function t(n) {
                        return v().wrap(function (t) {
                          for (; ;)
                            switch ((t.prev = t.next)) {
                              case 0:
                                return (
                                  e.closeOthers(),
                                  (t.next = 3),
                                  window.KercambreTheme.slideToggle(
                                    e.contentElement,
                                    200
                                  )
                                );
                              case 3:
                                e.updateElement(!e.opened),
                                  e.filterToggleUpdateChildHeight();
                              case 5:
                              case "end":
                                return t.stop();
                            }
                        }, t);
                      })
                    );
                    return function (e) {
                      return n.apply(this, arguments);
                    };
                  })(),
                  { passive: !0 }
                );
              },
            },
            {
              key: "filterToggleUpdateChildHeight",
              value: function () {
                var e = this;
                this.contentElement.hasAttribute("collection-filter-toggle") &&
                  setTimeout(function () {
                    matchMedia("screen and (min-width: 768px)").matches &&
                      (e.contentElement.querySelector(".loader").style.height =
                        e.contentElement.scrollHeight + "px");
                  }, 1e3);
              },
            },
            {
              key: "updateElement",
              value: function (e) {
                e
                  ? (this.classList.add("opened"),
                    this.titleElement.querySelector(".arrow-icon") &&
                    ((this.titleElement.querySelector(
                      ".arrow-icon"
                    ).style.transform = "rotate(135deg)"),
                      (this.titleElement.querySelector(
                        ".arrow-icon"
                      ).style.marginBottom = "5px")))
                  : (this.classList.remove("opened"),
                    this.titleElement.querySelector(".arrow-icon") &&
                    ((this.titleElement.querySelector(
                      ".arrow-icon"
                    ).style.transform = "rotate(45deg)"),
                      (this.titleElement.querySelector(
                        ".arrow-icon"
                      ).style.marginBottom = "0px")),
                    (this.contentElement.style.display = "none")),
                  (this.opened = e);
              },
            },
            {
              key: "toggle",
              value:
                ((n = t(
                  v().mark(function e() {
                    return v().wrap(
                      function (e) {
                        for (; ;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              return (
                                this.closeOthers(),
                                (e.next = 3),
                                window.KercambreTheme.slideToggle(
                                  this.contentElement,
                                  200
                                )
                              );
                            case 3:
                              this.updateElement(!this.opened),
                                this.filterToggleUpdateChildHeight();
                            case 5:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      this
                    );
                  })
                )),
                  function () {
                    return n.apply(this, arguments);
                  }),
            },
          ]),
          s
        );
      })(f(HTMLElement));
      customElements.define("toggle-content-kercambre", P);
      var L = document.querySelectorAll(".collection toggle-content-kercambre");
      function $(e) {
        return (
          null !== e &&
          "object" == typeof e &&
          "constructor" in e &&
          e.constructor === Object
        );
      }
      function M(e = {}, t = {}) {
        Object.keys(t).forEach((n) => {
          void 0 === e[n]
            ? (e[n] = t[n])
            : $(t[n]) &&
            $(e[n]) &&
            Object.keys(t[n]).length > 0 &&
            M(e[n], t[n]);
        });
      }
      document.addEventListener(
        "click",
        (function () {
          var e = t(
            v().mark(function e(n) {
              var r, i, s, o;
              return v().wrap(
                function (e) {
                  for (; ;)
                    switch ((e.prev = e.next)) {
                      case 0:
                        if (!n.target.hasAttribute("extra-title")) {
                          e.next = 2;
                          break;
                        }
                        return e.abrupt("return");
                      case 2:
                        (r = (function () {
                          var e = !1;
                          return (function () {
                            var n = t(
                              v().mark(function t(n) {
                                return v().wrap(function (t) {
                                  for (; ;)
                                    switch ((t.prev = t.next)) {
                                      case 0:
                                        if (e) {
                                          t.next = 5;
                                          break;
                                        }
                                        return (
                                          (e = !0),
                                          (t.next = 4),
                                          window.KercambreTheme.slideToggle(
                                            n.contentElement,
                                            200
                                          )
                                        );
                                      case 4:
                                        n.updateElement(!1);
                                      case 5:
                                      case "end":
                                        return t.stop();
                                    }
                                }, t);
                              })
                            );
                            return function (e) {
                              return n.apply(this, arguments);
                            };
                          })();
                        })()),
                          (i = T(L)),
                          (e.prev = 4),
                          i.s();
                      case 6:
                        if ((s = i.n()).done) {
                          e.next = 16;
                          break;
                        }
                        if (!(o = s.value).opened) {
                          e.next = 14;
                          break;
                        }
                        if ("LABEL" != n.srcElement.nodeName) {
                          e.next = 11;
                          break;
                        }
                        return e.abrupt("return");
                      case 11:
                        if ("INPUT" != n.srcElement.nodeName) {
                          e.next = 13;
                          break;
                        }
                        return e.abrupt("return");
                      case 13:
                        r(o);
                      case 14:
                        e.next = 6;
                        break;
                      case 16:
                        e.next = 21;
                        break;
                      case 18:
                        (e.prev = 18), (e.t0 = e.catch(4)), i.e(e.t0);
                      case 21:
                        return (e.prev = 21), i.f(), e.finish(21);
                      case 24:
                      case "end":
                        return e.stop();
                    }
                },
                e,
                null,
                [[4, 18, 21, 24]]
              );
            })
          );
          return function (t) {
            return e.apply(this, arguments);
          };
        })()
      );
      const A = {
        body: {},
        addEventListener() { },
        removeEventListener() { },
        activeElement: { blur() { }, nodeName: "" },
        querySelector() {
          return null;
        },
        querySelectorAll() {
          return [];
        },
        getElementById() {
          return null;
        },
        createEvent() {
          return { initEvent() { } };
        },
        createElement() {
          return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute() { },
            getElementsByTagName() {
              return [];
            },
          };
        },
        createElementNS() {
          return {};
        },
        importNode() {
          return null;
        },
        location: {
          hash: "",
          host: "",
          hostname: "",
          href: "",
          origin: "",
          pathname: "",
          protocol: "",
          search: "",
        },
      };
      function I() {
        const e = "undefined" != typeof document ? document : {};
        return M(e, A), e;
      }
      const j = {
        document: A,
        navigator: { userAgent: "" },
        location: {
          hash: "",
          host: "",
          hostname: "",
          href: "",
          origin: "",
          pathname: "",
          protocol: "",
          search: "",
        },
        history: { replaceState() { }, pushState() { }, go() { }, back() { } },
        CustomEvent: function () {
          return this;
        },
        addEventListener() { },
        removeEventListener() { },
        getComputedStyle() {
          return {
            getPropertyValue() {
              return "";
            },
          };
        },
        Image() { },
        Date() { },
        screen: {},
        setTimeout() { },
        clearTimeout() { },
        matchMedia() {
          return {};
        },
        requestAnimationFrame(e) {
          return "undefined" == typeof setTimeout
            ? (e(), null)
            : setTimeout(e, 0);
        },
        cancelAnimationFrame(e) {
          "undefined" != typeof setTimeout && clearTimeout(e);
        },
      };
      function _() {
        const e = "undefined" != typeof window ? window : {};
        return M(e, j), e;
      }
      class N extends Array {
        constructor(e) {
          "number" == typeof e
            ? super(e)
            : (super(...(e || [])),
              (function (e) {
                const t = e.__proto__;
                Object.defineProperty(e, "__proto__", {
                  get() {
                    return t;
                  },
                  set(e) {
                    t.__proto__ = e;
                  },
                });
              })(this));
        }
      }
      function R(e = []) {
        const t = [];
        return (
          e.forEach((e) => {
            Array.isArray(e) ? t.push(...R(e)) : t.push(e);
          }),
          t
        );
      }
      function D(e, t) {
        return Array.prototype.filter.call(e, t);
      }
      function z(e, t) {
        const n = _(),
          r = I();
        let i = [];
        if (!t && e instanceof N) return e;
        if (!e) return new N(i);
        if ("string" == typeof e) {
          const n = e.trim();
          if (n.indexOf("<") >= 0 && n.indexOf(">") >= 0) {
            let e = "div";
            0 === n.indexOf("<li") && (e = "ul"),
              0 === n.indexOf("<tr") && (e = "tbody"),
              (0 !== n.indexOf("<td") && 0 !== n.indexOf("<th")) || (e = "tr"),
              0 === n.indexOf("<tbody") && (e = "table"),
              0 === n.indexOf("<option") && (e = "select");
            const t = r.createElement(e);
            t.innerHTML = n;
            for (let e = 0; e < t.childNodes.length; e += 1)
              i.push(t.childNodes[e]);
          } else
            i = (function (e, t) {
              if ("string" != typeof e) return [e];
              const n = [],
                r = t.querySelectorAll(e);
              for (let e = 0; e < r.length; e += 1) n.push(r[e]);
              return n;
            })(e.trim(), t || r);
        } else if (e.nodeType || e === n || e === r) i.push(e);
        else if (Array.isArray(e)) {
          if (e instanceof N) return e;
          i = e;
        }
        return new N(
          (function (e) {
            const t = [];
            for (let n = 0; n < e.length; n += 1)
              -1 === t.indexOf(e[n]) && t.push(e[n]);
            return t;
          })(i)
        );
      }
      z.fn = N.prototype;
      const q = "resize scroll".split(" ");
      function B(e) {
        return function (...t) {
          if (void 0 === t[0]) {
            for (let t = 0; t < this.length; t += 1)
              q.indexOf(e) < 0 &&
                (e in this[t] ? this[t][e]() : z(this[t]).trigger(e));
            return this;
          }
          return this.on(e, ...t);
        };
      }
      B("click"),
        B("blur"),
        B("focus"),
        B("focusin"),
        B("focusout"),
        B("keyup"),
        B("keydown"),
        B("keypress"),
        B("submit"),
        B("change"),
        B("mousedown"),
        B("mousemove"),
        B("mouseup"),
        B("mouseenter"),
        B("mouseleave"),
        B("mouseout"),
        B("mouseover"),
        B("touchstart"),
        B("touchend"),
        B("touchmove"),
        B("resize"),
        B("scroll");
      const F = {
        addClass: function (...e) {
          const t = R(e.map((e) => e.split(" ")));
          return (
            this.forEach((e) => {
              e.classList.add(...t);
            }),
            this
          );
        },
        removeClass: function (...e) {
          const t = R(e.map((e) => e.split(" ")));
          return (
            this.forEach((e) => {
              e.classList.remove(...t);
            }),
            this
          );
        },
        hasClass: function (...e) {
          const t = R(e.map((e) => e.split(" ")));
          return (
            D(this, (e) => t.filter((t) => e.classList.contains(t)).length > 0)
              .length > 0
          );
        },
        toggleClass: function (...e) {
          const t = R(e.map((e) => e.split(" ")));
          this.forEach((e) => {
            t.forEach((t) => {
              e.classList.toggle(t);
            });
          });
        },
        attr: function (e, t) {
          if (1 === arguments.length && "string" == typeof e)
            return this[0] ? this[0].getAttribute(e) : void 0;
          for (let n = 0; n < this.length; n += 1)
            if (2 === arguments.length) this[n].setAttribute(e, t);
            else
              for (const t in e)
                (this[n][t] = e[t]), this[n].setAttribute(t, e[t]);
          return this;
        },
        removeAttr: function (e) {
          for (let t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
          return this;
        },
        transform: function (e) {
          for (let t = 0; t < this.length; t += 1) this[t].style.transform = e;
          return this;
        },
        transition: function (e) {
          for (let t = 0; t < this.length; t += 1)
            this[t].style.transitionDuration =
              "string" != typeof e ? `${e}ms` : e;
          return this;
        },
        on: function (...e) {
          let [t, n, r, i] = e;
          function s(e) {
            const t = e.target;
            if (!t) return;
            const i = e.target.dom7EventData || [];
            if ((i.indexOf(e) < 0 && i.unshift(e), z(t).is(n))) r.apply(t, i);
            else {
              const e = z(t).parents();
              for (let t = 0; t < e.length; t += 1)
                z(e[t]).is(n) && r.apply(e[t], i);
            }
          }
          function o(e) {
            const t = (e && e.target && e.target.dom7EventData) || [];
            t.indexOf(e) < 0 && t.unshift(e), r.apply(this, t);
          }
          "function" == typeof e[1] && (([t, r, i] = e), (n = void 0)),
            i || (i = !1);
          const a = t.split(" ");
          let l;
          for (let e = 0; e < this.length; e += 1) {
            const t = this[e];
            if (n)
              for (l = 0; l < a.length; l += 1) {
                const e = a[l];
                t.dom7LiveListeners || (t.dom7LiveListeners = {}),
                  t.dom7LiveListeners[e] || (t.dom7LiveListeners[e] = []),
                  t.dom7LiveListeners[e].push({
                    listener: r,
                    proxyListener: s,
                  }),
                  t.addEventListener(e, s, i);
              }
            else
              for (l = 0; l < a.length; l += 1) {
                const e = a[l];
                t.dom7Listeners || (t.dom7Listeners = {}),
                  t.dom7Listeners[e] || (t.dom7Listeners[e] = []),
                  t.dom7Listeners[e].push({ listener: r, proxyListener: o }),
                  t.addEventListener(e, o, i);
              }
          }
          return this;
        },
        off: function (...e) {
          let [t, n, r, i] = e;
          "function" == typeof e[1] && (([t, r, i] = e), (n = void 0)),
            i || (i = !1);
          const s = t.split(" ");
          for (let e = 0; e < s.length; e += 1) {
            const t = s[e];
            for (let e = 0; e < this.length; e += 1) {
              const s = this[e];
              let o;
              if (
                (!n && s.dom7Listeners
                  ? (o = s.dom7Listeners[t])
                  : n && s.dom7LiveListeners && (o = s.dom7LiveListeners[t]),
                  o && o.length)
              )
                for (let e = o.length - 1; e >= 0; e -= 1) {
                  const n = o[e];
                  (r && n.listener === r) ||
                    (r &&
                      n.listener &&
                      n.listener.dom7proxy &&
                      n.listener.dom7proxy === r)
                    ? (s.removeEventListener(t, n.proxyListener, i),
                      o.splice(e, 1))
                    : r ||
                    (s.removeEventListener(t, n.proxyListener, i),
                      o.splice(e, 1));
                }
            }
          }
          return this;
        },
        trigger: function (...e) {
          const t = _(),
            n = e[0].split(" "),
            r = e[1];
          for (let i = 0; i < n.length; i += 1) {
            const s = n[i];
            for (let n = 0; n < this.length; n += 1) {
              const i = this[n];
              if (t.CustomEvent) {
                const n = new t.CustomEvent(s, {
                  detail: r,
                  bubbles: !0,
                  cancelable: !0,
                });
                (i.dom7EventData = e.filter((e, t) => t > 0)),
                  i.dispatchEvent(n),
                  (i.dom7EventData = []),
                  delete i.dom7EventData;
              }
            }
          }
          return this;
        },
        transitionEnd: function (e) {
          const t = this;
          return (
            e &&
            t.on("transitionend", function n(r) {
              r.target === this &&
                (e.call(this, r), t.off("transitionend", n));
            }),
            this
          );
        },
        outerWidth: function (e) {
          if (this.length > 0) {
            if (e) {
              const e = this.styles();
              return (
                this[0].offsetWidth +
                parseFloat(e.getPropertyValue("margin-right")) +
                parseFloat(e.getPropertyValue("margin-left"))
              );
            }
            return this[0].offsetWidth;
          }
          return null;
        },
        outerHeight: function (e) {
          if (this.length > 0) {
            if (e) {
              const e = this.styles();
              return (
                this[0].offsetHeight +
                parseFloat(e.getPropertyValue("margin-top")) +
                parseFloat(e.getPropertyValue("margin-bottom"))
              );
            }
            return this[0].offsetHeight;
          }
          return null;
        },
        styles: function () {
          const e = _();
          return this[0] ? e.getComputedStyle(this[0], null) : {};
        },
        offset: function () {
          if (this.length > 0) {
            const e = _(),
              t = I(),
              n = this[0],
              r = n.getBoundingClientRect(),
              i = t.body,
              s = n.clientTop || i.clientTop || 0,
              o = n.clientLeft || i.clientLeft || 0,
              a = n === e ? e.scrollY : n.scrollTop,
              l = n === e ? e.scrollX : n.scrollLeft;
            return { top: r.top + a - s, left: r.left + l - o };
          }
          return null;
        },
        css: function (e, t) {
          const n = _();
          let r;
          if (1 === arguments.length) {
            if ("string" != typeof e) {
              for (r = 0; r < this.length; r += 1)
                for (const t in e) this[r].style[t] = e[t];
              return this;
            }
            if (this[0])
              return n.getComputedStyle(this[0], null).getPropertyValue(e);
          }
          if (2 === arguments.length && "string" == typeof e) {
            for (r = 0; r < this.length; r += 1) this[r].style[e] = t;
            return this;
          }
          return this;
        },
        each: function (e) {
          return e
            ? (this.forEach((t, n) => {
              e.apply(t, [t, n]);
            }),
              this)
            : this;
        },
        html: function (e) {
          if (void 0 === e) return this[0] ? this[0].innerHTML : null;
          for (let t = 0; t < this.length; t += 1) this[t].innerHTML = e;
          return this;
        },
        text: function (e) {
          if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
          for (let t = 0; t < this.length; t += 1) this[t].textContent = e;
          return this;
        },
        is: function (e) {
          const t = _(),
            n = I(),
            r = this[0];
          let i, s;
          if (!r || void 0 === e) return !1;
          if ("string" == typeof e) {
            if (r.matches) return r.matches(e);
            if (r.webkitMatchesSelector) return r.webkitMatchesSelector(e);
            if (r.msMatchesSelector) return r.msMatchesSelector(e);
            for (i = z(e), s = 0; s < i.length; s += 1)
              if (i[s] === r) return !0;
            return !1;
          }
          if (e === n) return r === n;
          if (e === t) return r === t;
          if (e.nodeType || e instanceof N) {
            for (i = e.nodeType ? [e] : e, s = 0; s < i.length; s += 1)
              if (i[s] === r) return !0;
            return !1;
          }
          return !1;
        },
        index: function () {
          let e,
            t = this[0];
          if (t) {
            for (e = 0; null !== (t = t.previousSibling);)
              1 === t.nodeType && (e += 1);
            return e;
          }
        },
        eq: function (e) {
          if (void 0 === e) return this;
          const t = this.length;
          if (e > t - 1) return z([]);
          if (e < 0) {
            const n = t + e;
            return z(n < 0 ? [] : [this[n]]);
          }
          return z([this[e]]);
        },
        append: function (...e) {
          let t;
          const n = I();
          for (let r = 0; r < e.length; r += 1) {
            t = e[r];
            for (let e = 0; e < this.length; e += 1)
              if ("string" == typeof t) {
                const r = n.createElement("div");
                for (r.innerHTML = t; r.firstChild;)
                  this[e].appendChild(r.firstChild);
              } else if (t instanceof N)
                for (let n = 0; n < t.length; n += 1) this[e].appendChild(t[n]);
              else this[e].appendChild(t);
          }
          return this;
        },
        prepend: function (e) {
          const t = I();
          let n, r;
          for (n = 0; n < this.length; n += 1)
            if ("string" == typeof e) {
              const i = t.createElement("div");
              for (i.innerHTML = e, r = i.childNodes.length - 1; r >= 0; r -= 1)
                this[n].insertBefore(i.childNodes[r], this[n].childNodes[0]);
            } else if (e instanceof N)
              for (r = 0; r < e.length; r += 1)
                this[n].insertBefore(e[r], this[n].childNodes[0]);
            else this[n].insertBefore(e, this[n].childNodes[0]);
          return this;
        },
        next: function (e) {
          return this.length > 0
            ? e
              ? this[0].nextElementSibling &&
                z(this[0].nextElementSibling).is(e)
                ? z([this[0].nextElementSibling])
                : z([])
              : this[0].nextElementSibling
                ? z([this[0].nextElementSibling])
                : z([])
            : z([]);
        },
        nextAll: function (e) {
          const t = [];
          let n = this[0];
          if (!n) return z([]);
          for (; n.nextElementSibling;) {
            const r = n.nextElementSibling;
            e ? z(r).is(e) && t.push(r) : t.push(r), (n = r);
          }
          return z(t);
        },
        prev: function (e) {
          if (this.length > 0) {
            const t = this[0];
            return e
              ? t.previousElementSibling && z(t.previousElementSibling).is(e)
                ? z([t.previousElementSibling])
                : z([])
              : t.previousElementSibling
                ? z([t.previousElementSibling])
                : z([]);
          }
          return z([]);
        },
        prevAll: function (e) {
          const t = [];
          let n = this[0];
          if (!n) return z([]);
          for (; n.previousElementSibling;) {
            const r = n.previousElementSibling;
            e ? z(r).is(e) && t.push(r) : t.push(r), (n = r);
          }
          return z(t);
        },
        parent: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1)
            null !== this[n].parentNode &&
              (e
                ? z(this[n].parentNode).is(e) && t.push(this[n].parentNode)
                : t.push(this[n].parentNode));
          return z(t);
        },
        parents: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1) {
            let r = this[n].parentNode;
            for (; r;)
              e ? z(r).is(e) && t.push(r) : t.push(r), (r = r.parentNode);
          }
          return z(t);
        },
        closest: function (e) {
          let t = this;
          return void 0 === e
            ? z([])
            : (t.is(e) || (t = t.parents(e).eq(0)), t);
        },
        find: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1) {
            const r = this[n].querySelectorAll(e);
            for (let e = 0; e < r.length; e += 1) t.push(r[e]);
          }
          return z(t);
        },
        children: function (e) {
          const t = [];
          for (let n = 0; n < this.length; n += 1) {
            const r = this[n].children;
            for (let n = 0; n < r.length; n += 1)
              (e && !z(r[n]).is(e)) || t.push(r[n]);
          }
          return z(t);
        },
        filter: function (e) {
          return z(D(this, e));
        },
        remove: function () {
          for (let e = 0; e < this.length; e += 1)
            this[e].parentNode && this[e].parentNode.removeChild(this[e]);
          return this;
        },
      };
      Object.keys(F).forEach((e) => {
        Object.defineProperty(z.fn, e, { value: F[e], writable: !0 });
      });
      var H = z;
      function W(e, t = 0) {
        return setTimeout(e, t);
      }
      function Y() {
        return Date.now();
      }
      function G(e, t = "x") {
        const n = _();
        let r, i, s;
        const o = (function (e) {
          const t = _();
          let n;
          return (
            t.getComputedStyle && (n = t.getComputedStyle(e, null)),
            !n && e.currentStyle && (n = e.currentStyle),
            n || (n = e.style),
            n
          );
        })(e);
        return (
          n.WebKitCSSMatrix
            ? ((i = o.transform || o.webkitTransform),
              i.split(",").length > 6 &&
              (i = i
                .split(", ")
                .map((e) => e.replace(",", "."))
                .join(", ")),
              (s = new n.WebKitCSSMatrix("none" === i ? "" : i)))
            : ((s =
              o.MozTransform ||
              o.OTransform ||
              o.MsTransform ||
              o.msTransform ||
              o.transform ||
              o
                .getPropertyValue("transform")
                .replace("translate(", "matrix(1, 0, 0, 1,")),
              (r = s.toString().split(","))),
          "x" === t &&
          (i = n.WebKitCSSMatrix
            ? s.m41
            : 16 === r.length
              ? parseFloat(r[12])
              : parseFloat(r[4])),
          "y" === t &&
          (i = n.WebKitCSSMatrix
            ? s.m42
            : 16 === r.length
              ? parseFloat(r[13])
              : parseFloat(r[5])),
          i || 0
        );
      }
      function X(e) {
        return (
          "object" == typeof e &&
          null !== e &&
          e.constructor &&
          "Object" === Object.prototype.toString.call(e).slice(8, -1)
        );
      }
      function U(...e) {
        const t = Object(e[0]),
          n = ["__proto__", "constructor", "prototype"];
        for (let i = 1; i < e.length; i += 1) {
          const s = e[i];
          if (
            null != s &&
            ((r = s),
              !("undefined" != typeof window && void 0 !== window.HTMLElement
                ? r instanceof HTMLElement
                : r && (1 === r.nodeType || 11 === r.nodeType)))
          ) {
            const e = Object.keys(Object(s)).filter((e) => n.indexOf(e) < 0);
            for (let n = 0, r = e.length; n < r; n += 1) {
              const r = e[n],
                i = Object.getOwnPropertyDescriptor(s, r);
              void 0 !== i &&
                i.enumerable &&
                (X(t[r]) && X(s[r])
                  ? s[r].__swiper__
                    ? (t[r] = s[r])
                    : U(t[r], s[r])
                  : !X(t[r]) && X(s[r])
                    ? ((t[r] = {}),
                      s[r].__swiper__ ? (t[r] = s[r]) : U(t[r], s[r]))
                    : (t[r] = s[r]));
            }
          }
        }
        var r;
        return t;
      }
      function V(e, t, n) {
        e.style.setProperty(t, n);
      }
      function K({ swiper: e, targetPosition: t, side: n }) {
        const r = _(),
          i = -e.translate;
        let s,
          o = null;
        const a = e.params.speed;
        (e.wrapperEl.style.scrollSnapType = "none"),
          r.cancelAnimationFrame(e.cssModeFrameID);
        const l = t > i ? "next" : "prev",
          c = (e, t) => ("next" === l && e >= t) || ("prev" === l && e <= t),
          u = () => {
            (s = new Date().getTime()), null === o && (o = s);
            const l = Math.max(Math.min((s - o) / a, 1), 0),
              d = 0.5 - Math.cos(l * Math.PI) / 2;
            let p = i + d * (t - i);
            if ((c(p, t) && (p = t), e.wrapperEl.scrollTo({ [n]: p }), c(p, t)))
              return (
                (e.wrapperEl.style.overflow = "hidden"),
                (e.wrapperEl.style.scrollSnapType = ""),
                setTimeout(() => {
                  (e.wrapperEl.style.overflow = ""),
                    e.wrapperEl.scrollTo({ [n]: p });
                }),
                void r.cancelAnimationFrame(e.cssModeFrameID)
              );
            e.cssModeFrameID = r.requestAnimationFrame(u);
          };
        u();
      }
      let J, Q, Z;
      function ee() {
        return (
          J ||
          (J = (function () {
            const e = _(),
              t = I();
            return {
              smoothScroll:
                t.documentElement &&
                "scrollBehavior" in t.documentElement.style,
              touch: !!(
                "ontouchstart" in e ||
                (e.DocumentTouch && t instanceof e.DocumentTouch)
              ),
              passiveListener: (function () {
                let t = !1;
                try {
                  const n = Object.defineProperty({}, "passive", {
                    get() {
                      t = !0;
                    },
                  });
                  e.addEventListener("testPassiveListener", null, n);
                } catch (e) { }
                return t;
              })(),
              gestures: "ongesturestart" in e,
            };
          })()),
          J
        );
      }
      function te(e = {}) {
        return (
          Q ||
          (Q = (function ({ userAgent: e } = {}) {
            const t = ee(),
              n = _(),
              r = n.navigator.platform,
              i = e || n.navigator.userAgent,
              s = { ios: !1, android: !1 },
              o = n.screen.width,
              a = n.screen.height,
              l = i.match(/(Android);?[\s\/]+([\d.]+)?/);
            let c = i.match(/(iPad).*OS\s([\d_]+)/);
            const u = i.match(/(iPod)(.*OS\s([\d_]+))?/),
              d = !c && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
              p = "Win32" === r;
            let h = "MacIntel" === r;
            return (
              !c &&
              h &&
              t.touch &&
              [
                "1024x1366",
                "1366x1024",
                "834x1194",
                "1194x834",
                "834x1112",
                "1112x834",
                "768x1024",
                "1024x768",
                "820x1180",
                "1180x820",
                "810x1080",
                "1080x810",
              ].indexOf(`${o}x${a}`) >= 0 &&
              ((c = i.match(/(Version)\/([\d.]+)/)),
                c || (c = [0, 1, "13_0_0"]),
                (h = !1)),
              l && !p && ((s.os = "android"), (s.android = !0)),
              (c || d || u) && ((s.os = "ios"), (s.ios = !0)),
              s
            );
          })(e)),
          Q
        );
      }
      function ne() {
        return (
          Z ||
          (Z = (function () {
            const e = _();
            return {
              isSafari: (function () {
                const t = e.navigator.userAgent.toLowerCase();
                return (
                  t.indexOf("safari") >= 0 &&
                  t.indexOf("chrome") < 0 &&
                  t.indexOf("android") < 0
                );
              })(),
              isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
                e.navigator.userAgent
              ),
            };
          })()),
          Z
        );
      }
      var re = {
        on(e, t, n) {
          const r = this;
          if (!r.eventsListeners || r.destroyed) return r;
          if ("function" != typeof t) return r;
          const i = n ? "unshift" : "push";
          return (
            e.split(" ").forEach((e) => {
              r.eventsListeners[e] || (r.eventsListeners[e] = []),
                r.eventsListeners[e][i](t);
            }),
            r
          );
        },
        once(e, t, n) {
          const r = this;
          if (!r.eventsListeners || r.destroyed) return r;
          if ("function" != typeof t) return r;
          function i(...n) {
            r.off(e, i),
              i.__emitterProxy && delete i.__emitterProxy,
              t.apply(r, n);
          }
          return (i.__emitterProxy = t), r.on(e, i, n);
        },
        onAny(e, t) {
          const n = this;
          if (!n.eventsListeners || n.destroyed) return n;
          if ("function" != typeof e) return n;
          const r = t ? "unshift" : "push";
          return (
            n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[r](e), n
          );
        },
        offAny(e) {
          const t = this;
          if (!t.eventsListeners || t.destroyed) return t;
          if (!t.eventsAnyListeners) return t;
          const n = t.eventsAnyListeners.indexOf(e);
          return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
        },
        off(e, t) {
          const n = this;
          return !n.eventsListeners || n.destroyed
            ? n
            : n.eventsListeners
              ? (e.split(" ").forEach((e) => {
                void 0 === t
                  ? (n.eventsListeners[e] = [])
                  : n.eventsListeners[e] &&
                  n.eventsListeners[e].forEach((r, i) => {
                    (r === t ||
                      (r.__emitterProxy && r.__emitterProxy === t)) &&
                      n.eventsListeners[e].splice(i, 1);
                  });
              }),
                n)
              : n;
        },
        emit(...e) {
          const t = this;
          if (!t.eventsListeners || t.destroyed) return t;
          if (!t.eventsListeners) return t;
          let n, r, i;
          "string" == typeof e[0] || Array.isArray(e[0])
            ? ((n = e[0]), (r = e.slice(1, e.length)), (i = t))
            : ((n = e[0].events), (r = e[0].data), (i = e[0].context || t)),
            r.unshift(i);
          return (
            (Array.isArray(n) ? n : n.split(" ")).forEach((e) => {
              t.eventsAnyListeners &&
                t.eventsAnyListeners.length &&
                t.eventsAnyListeners.forEach((t) => {
                  t.apply(i, [e, ...r]);
                }),
                t.eventsListeners &&
                t.eventsListeners[e] &&
                t.eventsListeners[e].forEach((e) => {
                  e.apply(i, r);
                });
            }),
            t
          );
        },
      };
      var ie = {
        updateSize: function () {
          const e = this;
          let t, n;
          const r = e.$el;
          (t =
            void 0 !== e.params.width && null !== e.params.width
              ? e.params.width
              : r[0].clientWidth),
            (n =
              void 0 !== e.params.height && null !== e.params.height
                ? e.params.height
                : r[0].clientHeight),
            (0 === t && e.isHorizontal()) ||
            (0 === n && e.isVertical()) ||
            ((t =
              t -
              parseInt(r.css("padding-left") || 0, 10) -
              parseInt(r.css("padding-right") || 0, 10)),
              (n =
                n -
                parseInt(r.css("padding-top") || 0, 10) -
                parseInt(r.css("padding-bottom") || 0, 10)),
              Number.isNaN(t) && (t = 0),
              Number.isNaN(n) && (n = 0),
              Object.assign(e, {
                width: t,
                height: n,
                size: e.isHorizontal() ? t : n,
              }));
        },
        updateSlides: function () {
          const e = this;
          function t(t) {
            return e.isHorizontal()
              ? t
              : {
                width: "height",
                "margin-top": "margin-left",
                "margin-bottom ": "margin-right",
                "margin-left": "margin-top",
                "margin-right": "margin-bottom",
                "padding-left": "padding-top",
                "padding-right": "padding-bottom",
                marginRight: "marginBottom",
              }[t];
          }
          function n(e, n) {
            return parseFloat(e.getPropertyValue(t(n)) || 0);
          }
          const r = e.params,
            { $wrapperEl: i, size: s, rtlTranslate: o, wrongRTL: a } = e,
            l = e.virtual && r.virtual.enabled,
            c = l ? e.virtual.slides.length : e.slides.length,
            u = i.children(`.${e.params.slideClass}`),
            d = l ? e.virtual.slides.length : u.length;
          let p = [];
          const h = [],
            f = [];
          let m = r.slidesOffsetBefore;
          "function" == typeof m && (m = r.slidesOffsetBefore.call(e));
          let v = r.slidesOffsetAfter;
          "function" == typeof v && (v = r.slidesOffsetAfter.call(e));
          const g = e.snapGrid.length,
            y = e.slidesGrid.length;
          let b = r.spaceBetween,
            w = -m,
            E = 0,
            x = 0;
          if (void 0 === s) return;
          "string" == typeof b &&
            b.indexOf("%") >= 0 &&
            (b = (parseFloat(b.replace("%", "")) / 100) * s),
            (e.virtualSize = -b),
            o
              ? u.css({ marginLeft: "", marginBottom: "", marginTop: "" })
              : u.css({ marginRight: "", marginBottom: "", marginTop: "" }),
            r.centeredSlides &&
            r.cssMode &&
            (V(e.wrapperEl, "--swiper-centered-offset-before", ""),
              V(e.wrapperEl, "--swiper-centered-offset-after", ""));
          const T = r.grid && r.grid.rows > 1 && e.grid;
          let S;
          T && e.grid.initSlides(d);
          const C =
            "auto" === r.slidesPerView &&
            r.breakpoints &&
            Object.keys(r.breakpoints).filter(
              (e) => void 0 !== r.breakpoints[e].slidesPerView
            ).length > 0;
          for (let i = 0; i < d; i += 1) {
            S = 0;
            const o = u.eq(i);
            if (
              (T && e.grid.updateSlide(i, o, d, t), "none" !== o.css("display"))
            ) {
              if ("auto" === r.slidesPerView) {
                C && (u[i].style[t("width")] = "");
                const s = getComputedStyle(o[0]),
                  a = o[0].style.transform,
                  l = o[0].style.webkitTransform;
                if (
                  (a && (o[0].style.transform = "none"),
                    l && (o[0].style.webkitTransform = "none"),
                    r.roundLengths)
                )
                  S = e.isHorizontal() ? o.outerWidth(!0) : o.outerHeight(!0);
                else {
                  const e = n(s, "width"),
                    t = n(s, "padding-left"),
                    r = n(s, "padding-right"),
                    i = n(s, "margin-left"),
                    a = n(s, "margin-right"),
                    l = s.getPropertyValue("box-sizing");
                  if (l && "border-box" === l) S = e + i + a;
                  else {
                    const { clientWidth: n, offsetWidth: s } = o[0];
                    S = e + t + r + i + a + (s - n);
                  }
                }
                a && (o[0].style.transform = a),
                  l && (o[0].style.webkitTransform = l),
                  r.roundLengths && (S = Math.floor(S));
              } else
                (S = (s - (r.slidesPerView - 1) * b) / r.slidesPerView),
                  r.roundLengths && (S = Math.floor(S)),
                  u[i] && (u[i].style[t("width")] = `${S}px`);
              u[i] && (u[i].swiperSlideSize = S),
                f.push(S),
                r.centeredSlides
                  ? ((w = w + S / 2 + E / 2 + b),
                    0 === E && 0 !== i && (w = w - s / 2 - b),
                    0 === i && (w = w - s / 2 - b),
                    Math.abs(w) < 0.001 && (w = 0),
                    r.roundLengths && (w = Math.floor(w)),
                    x % r.slidesPerGroup == 0 && p.push(w),
                    h.push(w))
                  : (r.roundLengths && (w = Math.floor(w)),
                    (x - Math.min(e.params.slidesPerGroupSkip, x)) %
                    e.params.slidesPerGroup ==
                    0 && p.push(w),
                    h.push(w),
                    (w = w + S + b)),
                (e.virtualSize += S + b),
                (E = S),
                (x += 1);
            }
          }
          if (
            ((e.virtualSize = Math.max(e.virtualSize, s) + v),
              o &&
              a &&
              ("slide" === r.effect || "coverflow" === r.effect) &&
              i.css({ width: `${e.virtualSize + r.spaceBetween}px` }),
              r.setWrapperSize &&
              i.css({ [t("width")]: `${e.virtualSize + r.spaceBetween}px` }),
              T && e.grid.updateWrapperSize(S, p, t),
              !r.centeredSlides)
          ) {
            const t = [];
            for (let n = 0; n < p.length; n += 1) {
              let i = p[n];
              r.roundLengths && (i = Math.floor(i)),
                p[n] <= e.virtualSize - s && t.push(i);
            }
            (p = t),
              Math.floor(e.virtualSize - s) - Math.floor(p[p.length - 1]) > 1 &&
              p.push(e.virtualSize - s);
          }
          if ((0 === p.length && (p = [0]), 0 !== r.spaceBetween)) {
            const n = e.isHorizontal() && o ? "marginLeft" : t("marginRight");
            u.filter((e, t) => !r.cssMode || t !== u.length - 1).css({
              [n]: `${b}px`,
            });
          }
          if (r.centeredSlides && r.centeredSlidesBounds) {
            let e = 0;
            f.forEach((t) => {
              e += t + (r.spaceBetween ? r.spaceBetween : 0);
            }),
              (e -= r.spaceBetween);
            const t = e - s;
            p = p.map((e) => (e < 0 ? -m : e > t ? t + v : e));
          }
          if (r.centerInsufficientSlides) {
            let e = 0;
            if (
              (f.forEach((t) => {
                e += t + (r.spaceBetween ? r.spaceBetween : 0);
              }),
                (e -= r.spaceBetween),
                e < s)
            ) {
              const t = (s - e) / 2;
              p.forEach((e, n) => {
                p[n] = e - t;
              }),
                h.forEach((e, n) => {
                  h[n] = e + t;
                });
            }
          }
          if (
            (Object.assign(e, {
              slides: u,
              snapGrid: p,
              slidesGrid: h,
              slidesSizesGrid: f,
            }),
              r.centeredSlides && r.cssMode && !r.centeredSlidesBounds)
          ) {
            V(e.wrapperEl, "--swiper-centered-offset-before", -p[0] + "px"),
              V(
                e.wrapperEl,
                "--swiper-centered-offset-after",
                e.size / 2 - f[f.length - 1] / 2 + "px"
              );
            const t = -e.snapGrid[0],
              n = -e.slidesGrid[0];
            (e.snapGrid = e.snapGrid.map((e) => e + t)),
              (e.slidesGrid = e.slidesGrid.map((e) => e + n));
          }
          if (
            (d !== c && e.emit("slidesLengthChange"),
              p.length !== g &&
              (e.params.watchOverflow && e.checkOverflow(),
                e.emit("snapGridLengthChange")),
              h.length !== y && e.emit("slidesGridLengthChange"),
              r.watchSlidesProgress && e.updateSlidesOffset(),
              !(l || r.cssMode || ("slide" !== r.effect && "fade" !== r.effect)))
          ) {
            const t = `${r.containerModifierClass}backface-hidden`,
              n = e.$el.hasClass(t);
            d <= r.maxBackfaceHiddenSlides
              ? n || e.$el.addClass(t)
              : n && e.$el.removeClass(t);
          }
        },
        updateAutoHeight: function (e) {
          const t = this,
            n = [],
            r = t.virtual && t.params.virtual.enabled;
          let i,
            s = 0;
          "number" == typeof e
            ? t.setTransition(e)
            : !0 === e && t.setTransition(t.params.speed);
          const o = (e) =>
            r
              ? t.slides.filter(
                (t) =>
                  parseInt(t.getAttribute("data-swiper-slide-index"), 10) ===
                  e
              )[0]
              : t.slides.eq(e)[0];
          if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
            if (t.params.centeredSlides)
              (t.visibleSlides || H([])).each((e) => {
                n.push(e);
              });
            else
              for (i = 0; i < Math.ceil(t.params.slidesPerView); i += 1) {
                const e = t.activeIndex + i;
                if (e > t.slides.length && !r) break;
                n.push(o(e));
              }
          else n.push(o(t.activeIndex));
          for (i = 0; i < n.length; i += 1)
            if (void 0 !== n[i]) {
              const e = n[i].offsetHeight;
              s = e > s ? e : s;
            }
          (s || 0 === s) && t.$wrapperEl.css("height", `${s}px`);
        },
        updateSlidesOffset: function () {
          const e = this,
            t = e.slides;
          for (let n = 0; n < t.length; n += 1)
            t[n].swiperSlideOffset = e.isHorizontal()
              ? t[n].offsetLeft
              : t[n].offsetTop;
        },
        updateSlidesProgress: function (e = (this && this.translate) || 0) {
          const t = this,
            n = t.params,
            { slides: r, rtlTranslate: i, snapGrid: s } = t;
          if (0 === r.length) return;
          void 0 === r[0].swiperSlideOffset && t.updateSlidesOffset();
          let o = -e;
          i && (o = e),
            r.removeClass(n.slideVisibleClass),
            (t.visibleSlidesIndexes = []),
            (t.visibleSlides = []);
          for (let e = 0; e < r.length; e += 1) {
            const a = r[e];
            let l = a.swiperSlideOffset;
            n.cssMode && n.centeredSlides && (l -= r[0].swiperSlideOffset);
            const c =
              (o + (n.centeredSlides ? t.minTranslate() : 0) - l) /
              (a.swiperSlideSize + n.spaceBetween),
              u =
                (o - s[0] + (n.centeredSlides ? t.minTranslate() : 0) - l) /
                (a.swiperSlideSize + n.spaceBetween),
              d = -(o - l),
              p = d + t.slidesSizesGrid[e];
            ((d >= 0 && d < t.size - 1) ||
              (p > 1 && p <= t.size) ||
              (d <= 0 && p >= t.size)) &&
              (t.visibleSlides.push(a),
                t.visibleSlidesIndexes.push(e),
                r.eq(e).addClass(n.slideVisibleClass)),
              (a.progress = i ? -c : c),
              (a.originalProgress = i ? -u : u);
          }
          t.visibleSlides = H(t.visibleSlides);
        },
        updateProgress: function (e) {
          const t = this;
          if (void 0 === e) {
            const n = t.rtlTranslate ? -1 : 1;
            e = (t && t.translate && t.translate * n) || 0;
          }
          const n = t.params,
            r = t.maxTranslate() - t.minTranslate();
          let { progress: i, isBeginning: s, isEnd: o } = t;
          const a = s,
            l = o;
          0 === r
            ? ((i = 0), (s = !0), (o = !0))
            : ((i = (e - t.minTranslate()) / r), (s = i <= 0), (o = i >= 1)),
            Object.assign(t, { progress: i, isBeginning: s, isEnd: o }),
            (n.watchSlidesProgress || (n.centeredSlides && n.autoHeight)) &&
            t.updateSlidesProgress(e),
            s && !a && t.emit("reachBeginning toEdge"),
            o && !l && t.emit("reachEnd toEdge"),
            ((a && !s) || (l && !o)) && t.emit("fromEdge"),
            t.emit("progress", i);
        },
        updateSlidesClasses: function () {
          const e = this,
            {
              slides: t,
              params: n,
              $wrapperEl: r,
              activeIndex: i,
              realIndex: s,
            } = e,
            o = e.virtual && n.virtual.enabled;
          let a;
          t.removeClass(
            `${n.slideActiveClass} ${n.slideNextClass} ${n.slidePrevClass} ${n.slideDuplicateActiveClass} ${n.slideDuplicateNextClass} ${n.slideDuplicatePrevClass}`
          ),
            (a = o
              ? e.$wrapperEl.find(
                `.${n.slideClass}[data-swiper-slide-index="${i}"]`
              )
              : t.eq(i)),
            a.addClass(n.slideActiveClass),
            n.loop &&
            (a.hasClass(n.slideDuplicateClass)
              ? r
                .children(
                  `.${n.slideClass}:not(.${n.slideDuplicateClass})[data-swiper-slide-index="${s}"]`
                )
                .addClass(n.slideDuplicateActiveClass)
              : r
                .children(
                  `.${n.slideClass}.${n.slideDuplicateClass}[data-swiper-slide-index="${s}"]`
                )
                .addClass(n.slideDuplicateActiveClass));
          let l = a
            .nextAll(`.${n.slideClass}`)
            .eq(0)
            .addClass(n.slideNextClass);
          n.loop &&
            0 === l.length &&
            ((l = t.eq(0)), l.addClass(n.slideNextClass));
          let c = a
            .prevAll(`.${n.slideClass}`)
            .eq(0)
            .addClass(n.slidePrevClass);
          n.loop &&
            0 === c.length &&
            ((c = t.eq(-1)), c.addClass(n.slidePrevClass)),
            n.loop &&
            (l.hasClass(n.slideDuplicateClass)
              ? r
                .children(
                  `.${n.slideClass}:not(.${n.slideDuplicateClass
                  })[data-swiper-slide-index="${l.attr(
                    "data-swiper-slide-index"
                  )}"]`
                )
                .addClass(n.slideDuplicateNextClass)
              : r
                .children(
                  `.${n.slideClass}.${n.slideDuplicateClass
                  }[data-swiper-slide-index="${l.attr(
                    "data-swiper-slide-index"
                  )}"]`
                )
                .addClass(n.slideDuplicateNextClass),
              c.hasClass(n.slideDuplicateClass)
                ? r
                  .children(
                    `.${n.slideClass}:not(.${n.slideDuplicateClass
                    })[data-swiper-slide-index="${c.attr(
                      "data-swiper-slide-index"
                    )}"]`
                  )
                  .addClass(n.slideDuplicatePrevClass)
                : r
                  .children(
                    `.${n.slideClass}.${n.slideDuplicateClass
                    }[data-swiper-slide-index="${c.attr(
                      "data-swiper-slide-index"
                    )}"]`
                  )
                  .addClass(n.slideDuplicatePrevClass)),
            e.emitSlidesClasses();
        },
        updateActiveIndex: function (e) {
          const t = this,
            n = t.rtlTranslate ? t.translate : -t.translate,
            {
              slidesGrid: r,
              snapGrid: i,
              params: s,
              activeIndex: o,
              realIndex: a,
              snapIndex: l,
            } = t;
          let c,
            u = e;
          if (void 0 === u) {
            for (let e = 0; e < r.length; e += 1)
              void 0 !== r[e + 1]
                ? n >= r[e] && n < r[e + 1] - (r[e + 1] - r[e]) / 2
                  ? (u = e)
                  : n >= r[e] && n < r[e + 1] && (u = e + 1)
                : n >= r[e] && (u = e);
            s.normalizeSlideIndex && (u < 0 || void 0 === u) && (u = 0);
          }
          if (i.indexOf(n) >= 0) c = i.indexOf(n);
          else {
            const e = Math.min(s.slidesPerGroupSkip, u);
            c = e + Math.floor((u - e) / s.slidesPerGroup);
          }
          if ((c >= i.length && (c = i.length - 1), u === o))
            return void (
              c !== l && ((t.snapIndex = c), t.emit("snapIndexChange"))
            );
          const d = parseInt(
            t.slides.eq(u).attr("data-swiper-slide-index") || u,
            10
          );
          Object.assign(t, {
            snapIndex: c,
            realIndex: d,
            previousIndex: o,
            activeIndex: u,
          }),
            t.emit("activeIndexChange"),
            t.emit("snapIndexChange"),
            a !== d && t.emit("realIndexChange"),
            (t.initialized || t.params.runCallbacksOnInit) &&
            t.emit("slideChange");
        },
        updateClickedSlide: function (e) {
          const t = this,
            n = t.params,
            r = H(e).closest(`.${n.slideClass}`)[0];
          let i,
            s = !1;
          if (r)
            for (let e = 0; e < t.slides.length; e += 1)
              if (t.slides[e] === r) {
                (s = !0), (i = e);
                break;
              }
          if (!r || !s)
            return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
          (t.clickedSlide = r),
            t.virtual && t.params.virtual.enabled
              ? (t.clickedIndex = parseInt(
                H(r).attr("data-swiper-slide-index"),
                10
              ))
              : (t.clickedIndex = i),
            n.slideToClickedSlide &&
            void 0 !== t.clickedIndex &&
            t.clickedIndex !== t.activeIndex &&
            t.slideToClickedSlide();
        },
      };
      var se = {
        getTranslate: function (e = this.isHorizontal() ? "x" : "y") {
          const {
            params: t,
            rtlTranslate: n,
            translate: r,
            $wrapperEl: i,
          } = this;
          if (t.virtualTranslate) return n ? -r : r;
          if (t.cssMode) return r;
          let s = G(i[0], e);
          return n && (s = -s), s || 0;
        },
        setTranslate: function (e, t) {
          const n = this,
            {
              rtlTranslate: r,
              params: i,
              $wrapperEl: s,
              wrapperEl: o,
              progress: a,
            } = n;
          let l,
            c = 0,
            u = 0;
          n.isHorizontal() ? (c = r ? -e : e) : (u = e),
            i.roundLengths && ((c = Math.floor(c)), (u = Math.floor(u))),
            i.cssMode
              ? (o[n.isHorizontal() ? "scrollLeft" : "scrollTop"] =
                n.isHorizontal() ? -c : -u)
              : i.virtualTranslate ||
              s.transform(`translate3d(${c}px, ${u}px, 0px)`),
            (n.previousTranslate = n.translate),
            (n.translate = n.isHorizontal() ? c : u);
          const d = n.maxTranslate() - n.minTranslate();
          (l = 0 === d ? 0 : (e - n.minTranslate()) / d),
            l !== a && n.updateProgress(e),
            n.emit("setTranslate", n.translate, t);
        },
        minTranslate: function () {
          return -this.snapGrid[0];
        },
        maxTranslate: function () {
          return -this.snapGrid[this.snapGrid.length - 1];
        },
        translateTo: function (
          e = 0,
          t = this.params.speed,
          n = !0,
          r = !0,
          i
        ) {
          const s = this,
            { params: o, wrapperEl: a } = s;
          if (s.animating && o.preventInteractionOnTransition) return !1;
          const l = s.minTranslate(),
            c = s.maxTranslate();
          let u;
          if (
            ((u = r && e > l ? l : r && e < c ? c : e),
              s.updateProgress(u),
              o.cssMode)
          ) {
            const e = s.isHorizontal();
            if (0 === t) a[e ? "scrollLeft" : "scrollTop"] = -u;
            else {
              if (!s.support.smoothScroll)
                return (
                  K({
                    swiper: s,
                    targetPosition: -u,
                    side: e ? "left" : "top",
                  }),
                  !0
                );
              a.scrollTo({ [e ? "left" : "top"]: -u, behavior: "smooth" });
            }
            return !0;
          }
          return (
            0 === t
              ? (s.setTransition(0),
                s.setTranslate(u),
                n &&
                (s.emit("beforeTransitionStart", t, i),
                  s.emit("transitionEnd")))
              : (s.setTransition(t),
                s.setTranslate(u),
                n &&
                (s.emit("beforeTransitionStart", t, i),
                  s.emit("transitionStart")),
                s.animating ||
                ((s.animating = !0),
                  s.onTranslateToWrapperTransitionEnd ||
                  (s.onTranslateToWrapperTransitionEnd = function (e) {
                    s &&
                      !s.destroyed &&
                      e.target === this &&
                      (s.$wrapperEl[0].removeEventListener(
                        "transitionend",
                        s.onTranslateToWrapperTransitionEnd
                      ),
                        s.$wrapperEl[0].removeEventListener(
                          "webkitTransitionEnd",
                          s.onTranslateToWrapperTransitionEnd
                        ),
                        (s.onTranslateToWrapperTransitionEnd = null),
                        delete s.onTranslateToWrapperTransitionEnd,
                        n && s.emit("transitionEnd"));
                  }),
                  s.$wrapperEl[0].addEventListener(
                    "transitionend",
                    s.onTranslateToWrapperTransitionEnd
                  ),
                  s.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    s.onTranslateToWrapperTransitionEnd
                  ))),
            !0
          );
        },
      };
      function oe({ swiper: e, runCallbacks: t, direction: n, step: r }) {
        const { activeIndex: i, previousIndex: s } = e;
        let o = n;
        if (
          (o || (o = i > s ? "next" : i < s ? "prev" : "reset"),
            e.emit(`transition${r}`),
            t && i !== s)
        ) {
          if ("reset" === o) return void e.emit(`slideResetTransition${r}`);
          e.emit(`slideChangeTransition${r}`),
            "next" === o
              ? e.emit(`slideNextTransition${r}`)
              : e.emit(`slidePrevTransition${r}`);
        }
      }
      var ae = {
        setTransition: function (e, t) {
          const n = this;
          n.params.cssMode || n.$wrapperEl.transition(e),
            n.emit("setTransition", e, t);
        },
        transitionStart: function (e = !0, t) {
          const n = this,
            { params: r } = n;
          r.cssMode ||
            (r.autoHeight && n.updateAutoHeight(),
              oe({ swiper: n, runCallbacks: e, direction: t, step: "Start" }));
        },
        transitionEnd: function (e = !0, t) {
          const n = this,
            { params: r } = n;
          (n.animating = !1),
            r.cssMode ||
            (n.setTransition(0),
              oe({ swiper: n, runCallbacks: e, direction: t, step: "End" }));
        },
      };
      var le = {
        slideTo: function (e = 0, t = this.params.speed, n = !0, r, i) {
          if ("number" != typeof e && "string" != typeof e)
            throw new Error(
              `The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`
            );
          if ("string" == typeof e) {
            const t = parseInt(e, 10);
            if (!isFinite(t))
              throw new Error(
                `The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`
              );
            e = t;
          }
          const s = this;
          let o = e;
          o < 0 && (o = 0);
          const {
            params: a,
            snapGrid: l,
            slidesGrid: c,
            previousIndex: u,
            activeIndex: d,
            rtlTranslate: p,
            wrapperEl: h,
            enabled: f,
          } = s;
          if (
            (s.animating && a.preventInteractionOnTransition) ||
            (!f && !r && !i)
          )
            return !1;
          const m = Math.min(s.params.slidesPerGroupSkip, o);
          let v = m + Math.floor((o - m) / s.params.slidesPerGroup);
          v >= l.length && (v = l.length - 1);
          const g = -l[v];
          if (a.normalizeSlideIndex)
            for (let e = 0; e < c.length; e += 1) {
              const t = -Math.floor(100 * g),
                n = Math.floor(100 * c[e]),
                r = Math.floor(100 * c[e + 1]);
              void 0 !== c[e + 1]
                ? t >= n && t < r - (r - n) / 2
                  ? (o = e)
                  : t >= n && t < r && (o = e + 1)
                : t >= n && (o = e);
            }
          if (s.initialized && o !== d) {
            if (!s.allowSlideNext && g < s.translate && g < s.minTranslate())
              return !1;
            if (
              !s.allowSlidePrev &&
              g > s.translate &&
              g > s.maxTranslate() &&
              (d || 0) !== o
            )
              return !1;
          }
          let y;
          if (
            (o !== (u || 0) && n && s.emit("beforeSlideChangeStart"),
              s.updateProgress(g),
              (y = o > d ? "next" : o < d ? "prev" : "reset"),
              (p && -g === s.translate) || (!p && g === s.translate))
          )
            return (
              s.updateActiveIndex(o),
              a.autoHeight && s.updateAutoHeight(),
              s.updateSlidesClasses(),
              "slide" !== a.effect && s.setTranslate(g),
              "reset" !== y && (s.transitionStart(n, y), s.transitionEnd(n, y)),
              !1
            );
          if (a.cssMode) {
            const e = s.isHorizontal(),
              n = p ? g : -g;
            if (0 === t) {
              const t = s.virtual && s.params.virtual.enabled;
              t &&
                ((s.wrapperEl.style.scrollSnapType = "none"),
                  (s._immediateVirtual = !0)),
                (h[e ? "scrollLeft" : "scrollTop"] = n),
                t &&
                requestAnimationFrame(() => {
                  (s.wrapperEl.style.scrollSnapType = ""),
                    (s._swiperImmediateVirtual = !1);
                });
            } else {
              if (!s.support.smoothScroll)
                return (
                  K({ swiper: s, targetPosition: n, side: e ? "left" : "top" }),
                  !0
                );
              h.scrollTo({ [e ? "left" : "top"]: n, behavior: "smooth" });
            }
            return !0;
          }
          return (
            s.setTransition(t),
            s.setTranslate(g),
            s.updateActiveIndex(o),
            s.updateSlidesClasses(),
            s.emit("beforeTransitionStart", t, r),
            s.transitionStart(n, y),
            0 === t
              ? s.transitionEnd(n, y)
              : s.animating ||
              ((s.animating = !0),
                s.onSlideToWrapperTransitionEnd ||
                (s.onSlideToWrapperTransitionEnd = function (e) {
                  s &&
                    !s.destroyed &&
                    e.target === this &&
                    (s.$wrapperEl[0].removeEventListener(
                      "transitionend",
                      s.onSlideToWrapperTransitionEnd
                    ),
                      s.$wrapperEl[0].removeEventListener(
                        "webkitTransitionEnd",
                        s.onSlideToWrapperTransitionEnd
                      ),
                      (s.onSlideToWrapperTransitionEnd = null),
                      delete s.onSlideToWrapperTransitionEnd,
                      s.transitionEnd(n, y));
                }),
                s.$wrapperEl[0].addEventListener(
                  "transitionend",
                  s.onSlideToWrapperTransitionEnd
                ),
                s.$wrapperEl[0].addEventListener(
                  "webkitTransitionEnd",
                  s.onSlideToWrapperTransitionEnd
                )),
            !0
          );
        },
        slideToLoop: function (e = 0, t = this.params.speed, n = !0, r) {
          if ("string" == typeof e) {
            const t = parseInt(e, 10);
            if (!isFinite(t))
              throw new Error(
                `The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`
              );
            e = t;
          }
          const i = this;
          let s = e;
          return i.params.loop && (s += i.loopedSlides), i.slideTo(s, t, n, r);
        },
        slideNext: function (e = this.params.speed, t = !0, n) {
          const r = this,
            { animating: i, enabled: s, params: o } = r;
          if (!s) return r;
          let a = o.slidesPerGroup;
          "auto" === o.slidesPerView &&
            1 === o.slidesPerGroup &&
            o.slidesPerGroupAuto &&
            (a = Math.max(r.slidesPerViewDynamic("current", !0), 1));
          const l = r.activeIndex < o.slidesPerGroupSkip ? 1 : a;
          if (o.loop) {
            if (i && o.loopPreventsSlide) return !1;
            r.loopFix(), (r._clientLeft = r.$wrapperEl[0].clientLeft);
          }
          return o.rewind && r.isEnd
            ? r.slideTo(0, e, t, n)
            : r.slideTo(r.activeIndex + l, e, t, n);
        },
        slidePrev: function (e = this.params.speed, t = !0, n) {
          const r = this,
            {
              params: i,
              animating: s,
              snapGrid: o,
              slidesGrid: a,
              rtlTranslate: l,
              enabled: c,
            } = r;
          if (!c) return r;
          if (i.loop) {
            if (s && i.loopPreventsSlide) return !1;
            r.loopFix(), (r._clientLeft = r.$wrapperEl[0].clientLeft);
          }
          function u(e) {
            return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
          }
          const d = u(l ? r.translate : -r.translate),
            p = o.map((e) => u(e));
          let h = o[p.indexOf(d) - 1];
          if (void 0 === h && i.cssMode) {
            let e;
            o.forEach((t, n) => {
              d >= t && (e = n);
            }),
              void 0 !== e && (h = o[e > 0 ? e - 1 : e]);
          }
          let f = 0;
          if (
            (void 0 !== h &&
              ((f = a.indexOf(h)),
                f < 0 && (f = r.activeIndex - 1),
                "auto" === i.slidesPerView &&
                1 === i.slidesPerGroup &&
                i.slidesPerGroupAuto &&
                ((f = f - r.slidesPerViewDynamic("previous", !0) + 1),
                  (f = Math.max(f, 0)))),
              i.rewind && r.isBeginning)
          ) {
            const i =
              r.params.virtual && r.params.virtual.enabled && r.virtual
                ? r.virtual.slides.length - 1
                : r.slides.length - 1;
            return r.slideTo(i, e, t, n);
          }
          return r.slideTo(f, e, t, n);
        },
        slideReset: function (e = this.params.speed, t = !0, n) {
          return this.slideTo(this.activeIndex, e, t, n);
        },
        slideToClosest: function (e = this.params.speed, t = !0, n, r = 0.5) {
          const i = this;
          let s = i.activeIndex;
          const o = Math.min(i.params.slidesPerGroupSkip, s),
            a = o + Math.floor((s - o) / i.params.slidesPerGroup),
            l = i.rtlTranslate ? i.translate : -i.translate;
          if (l >= i.snapGrid[a]) {
            const e = i.snapGrid[a];
            l - e > (i.snapGrid[a + 1] - e) * r &&
              (s += i.params.slidesPerGroup);
          } else {
            const e = i.snapGrid[a - 1];
            l - e <= (i.snapGrid[a] - e) * r && (s -= i.params.slidesPerGroup);
          }
          return (
            (s = Math.max(s, 0)),
            (s = Math.min(s, i.slidesGrid.length - 1)),
            i.slideTo(s, e, t, n)
          );
        },
        slideToClickedSlide: function () {
          const e = this,
            { params: t, $wrapperEl: n } = e,
            r =
              "auto" === t.slidesPerView
                ? e.slidesPerViewDynamic()
                : t.slidesPerView;
          let i,
            s = e.clickedIndex;
          if (t.loop) {
            if (e.animating) return;
            (i = parseInt(
              H(e.clickedSlide).attr("data-swiper-slide-index"),
              10
            )),
              t.centeredSlides
                ? s < e.loopedSlides - r / 2 ||
                  s > e.slides.length - e.loopedSlides + r / 2
                  ? (e.loopFix(),
                    (s = n
                      .children(
                        `.${t.slideClass}[data-swiper-slide-index="${i}"]:not(.${t.slideDuplicateClass})`
                      )
                      .eq(0)
                      .index()),
                    W(() => {
                      e.slideTo(s);
                    }))
                  : e.slideTo(s)
                : s > e.slides.length - r
                  ? (e.loopFix(),
                    (s = n
                      .children(
                        `.${t.slideClass}[data-swiper-slide-index="${i}"]:not(.${t.slideDuplicateClass})`
                      )
                      .eq(0)
                      .index()),
                    W(() => {
                      e.slideTo(s);
                    }))
                  : e.slideTo(s);
          } else e.slideTo(s);
        },
      };
      var ce = {
        loopCreate: function () {
          const e = this,
            t = I(),
            { params: n, $wrapperEl: r } = e,
            i = r.children().length > 0 ? H(r.children()[0].parentNode) : r;
          i.children(`.${n.slideClass}.${n.slideDuplicateClass}`).remove();
          let s = i.children(`.${n.slideClass}`);
          if (n.loopFillGroupWithBlank) {
            const e = n.slidesPerGroup - (s.length % n.slidesPerGroup);
            if (e !== n.slidesPerGroup) {
              for (let r = 0; r < e; r += 1) {
                const e = H(t.createElement("div")).addClass(
                  `${n.slideClass} ${n.slideBlankClass}`
                );
                i.append(e);
              }
              s = i.children(`.${n.slideClass}`);
            }
          }
          "auto" !== n.slidesPerView ||
            n.loopedSlides ||
            (n.loopedSlides = s.length),
            (e.loopedSlides = Math.ceil(
              parseFloat(n.loopedSlides || n.slidesPerView, 10)
            )),
            (e.loopedSlides += n.loopAdditionalSlides),
            e.loopedSlides > s.length &&
            e.params.loopedSlidesLimit &&
            (e.loopedSlides = s.length);
          const o = [],
            a = [];
          s.each((e, t) => {
            H(e).attr("data-swiper-slide-index", t);
          });
          for (let t = 0; t < e.loopedSlides; t += 1) {
            const e = t - Math.floor(t / s.length) * s.length;
            a.push(s.eq(e)[0]), o.unshift(s.eq(s.length - e - 1)[0]);
          }
          for (let e = 0; e < a.length; e += 1)
            i.append(H(a[e].cloneNode(!0)).addClass(n.slideDuplicateClass));
          for (let e = o.length - 1; e >= 0; e -= 1)
            i.prepend(H(o[e].cloneNode(!0)).addClass(n.slideDuplicateClass));
        },
        loopFix: function () {
          const e = this;
          e.emit("beforeLoopFix");
          const {
            activeIndex: t,
            slides: n,
            loopedSlides: r,
            allowSlidePrev: i,
            allowSlideNext: s,
            snapGrid: o,
            rtlTranslate: a,
          } = e;
          let l;
          (e.allowSlidePrev = !0), (e.allowSlideNext = !0);
          const c = -o[t] - e.getTranslate();
          if (t < r) {
            (l = n.length - 3 * r + t), (l += r);
            e.slideTo(l, 0, !1, !0) &&
              0 !== c &&
              e.setTranslate((a ? -e.translate : e.translate) - c);
          } else if (t >= n.length - r) {
            (l = -n.length + t + r), (l += r);
            e.slideTo(l, 0, !1, !0) &&
              0 !== c &&
              e.setTranslate((a ? -e.translate : e.translate) - c);
          }
          (e.allowSlidePrev = i), (e.allowSlideNext = s), e.emit("loopFix");
        },
        loopDestroy: function () {
          const { $wrapperEl: e, params: t, slides: n } = this;
          e
            .children(
              `.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`
            )
            .remove(),
            n.removeAttr("data-swiper-slide-index");
        },
      };
      var ue = {
        setGrabCursor: function (e) {
          const t = this;
          if (
            t.support.touch ||
            !t.params.simulateTouch ||
            (t.params.watchOverflow && t.isLocked) ||
            t.params.cssMode
          )
            return;
          const n =
            "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
          (n.style.cursor = "move"), (n.style.cursor = e ? "grabbing" : "grab");
        },
        unsetGrabCursor: function () {
          const e = this;
          e.support.touch ||
            (e.params.watchOverflow && e.isLocked) ||
            e.params.cssMode ||
            (e[
              "container" === e.params.touchEventsTarget ? "el" : "wrapperEl"
            ].style.cursor = "");
        },
      };
      function de(e) {
        const t = this,
          n = I(),
          r = _(),
          i = t.touchEventsData,
          { params: s, touches: o, enabled: a } = t;
        if (!a) return;
        if (t.animating && s.preventInteractionOnTransition) return;
        !t.animating && s.cssMode && s.loop && t.loopFix();
        let l = e;
        l.originalEvent && (l = l.originalEvent);
        let c = H(l.target);
        if ("wrapper" === s.touchEventsTarget && !c.closest(t.wrapperEl).length)
          return;
        if (
          ((i.isTouchEvent = "touchstart" === l.type),
            !i.isTouchEvent && "which" in l && 3 === l.which)
        )
          return;
        if (!i.isTouchEvent && "button" in l && l.button > 0) return;
        if (i.isTouched && i.isMoved) return;
        const u = !!s.noSwipingClass && "" !== s.noSwipingClass,
          d = e.composedPath ? e.composedPath() : e.path;
        u && l.target && l.target.shadowRoot && d && (c = H(d[0]));
        const p = s.noSwipingSelector
          ? s.noSwipingSelector
          : `.${s.noSwipingClass}`,
          h = !(!l.target || !l.target.shadowRoot);
        if (
          s.noSwiping &&
          (h
            ? (function (e, t = this) {
              return (function t(n) {
                if (!n || n === I() || n === _()) return null;
                n.assignedSlot && (n = n.assignedSlot);
                const r = n.closest(e);
                return r || n.getRootNode
                  ? r || t(n.getRootNode().host)
                  : null;
              })(t);
            })(p, c[0])
            : c.closest(p)[0])
        )
          return void (t.allowClick = !0);
        if (s.swipeHandler && !c.closest(s.swipeHandler)[0]) return;
        (o.currentX =
          "touchstart" === l.type ? l.targetTouches[0].pageX : l.pageX),
          (o.currentY =
            "touchstart" === l.type ? l.targetTouches[0].pageY : l.pageY);
        const f = o.currentX,
          m = o.currentY,
          v = s.edgeSwipeDetection || s.iOSEdgeSwipeDetection,
          g = s.edgeSwipeThreshold || s.iOSEdgeSwipeThreshold;
        if (v && (f <= g || f >= r.innerWidth - g)) {
          if ("prevent" !== v) return;
          e.preventDefault();
        }
        if (
          (Object.assign(i, {
            isTouched: !0,
            isMoved: !1,
            allowTouchCallbacks: !0,
            isScrolling: void 0,
            startMoving: void 0,
          }),
            (o.startX = f),
            (o.startY = m),
            (i.touchStartTime = Y()),
            (t.allowClick = !0),
            t.updateSize(),
            (t.swipeDirection = void 0),
            s.threshold > 0 && (i.allowThresholdMove = !1),
            "touchstart" !== l.type)
        ) {
          let e = !0;
          c.is(i.focusableElements) &&
            ((e = !1), "SELECT" === c[0].nodeName && (i.isTouched = !1)),
            n.activeElement &&
            H(n.activeElement).is(i.focusableElements) &&
            n.activeElement !== c[0] &&
            n.activeElement.blur();
          const r = e && t.allowTouchMove && s.touchStartPreventDefault;
          (!s.touchStartForcePreventDefault && !r) ||
            c[0].isContentEditable ||
            l.preventDefault();
        }
        t.params.freeMode &&
          t.params.freeMode.enabled &&
          t.freeMode &&
          t.animating &&
          !s.cssMode &&
          t.freeMode.onTouchStart(),
          t.emit("touchStart", l);
      }
      function pe(e) {
        const t = I(),
          n = this,
          r = n.touchEventsData,
          { params: i, touches: s, rtlTranslate: o, enabled: a } = n;
        if (!a) return;
        let l = e;
        if ((l.originalEvent && (l = l.originalEvent), !r.isTouched))
          return void (
            r.startMoving &&
            r.isScrolling &&
            n.emit("touchMoveOpposite", l)
          );
        if (r.isTouchEvent && "touchmove" !== l.type) return;
        const c =
          "touchmove" === l.type &&
          l.targetTouches &&
          (l.targetTouches[0] || l.changedTouches[0]),
          u = "touchmove" === l.type ? c.pageX : l.pageX,
          d = "touchmove" === l.type ? c.pageY : l.pageY;
        if (l.preventedByNestedSwiper)
          return (s.startX = u), void (s.startY = d);
        if (!n.allowTouchMove)
          return (
            H(l.target).is(r.focusableElements) || (n.allowClick = !1),
            void (
              r.isTouched &&
              (Object.assign(s, {
                startX: u,
                startY: d,
                currentX: u,
                currentY: d,
              }),
                (r.touchStartTime = Y()))
            )
          );
        if (r.isTouchEvent && i.touchReleaseOnEdges && !i.loop)
          if (n.isVertical()) {
            if (
              (d < s.startY && n.translate <= n.maxTranslate()) ||
              (d > s.startY && n.translate >= n.minTranslate())
            )
              return (r.isTouched = !1), void (r.isMoved = !1);
          } else if (
            (u < s.startX && n.translate <= n.maxTranslate()) ||
            (u > s.startX && n.translate >= n.minTranslate())
          )
            return;
        if (
          r.isTouchEvent &&
          t.activeElement &&
          l.target === t.activeElement &&
          H(l.target).is(r.focusableElements)
        )
          return (r.isMoved = !0), void (n.allowClick = !1);
        if (
          (r.allowTouchCallbacks && n.emit("touchMove", l),
            l.targetTouches && l.targetTouches.length > 1)
        )
          return;
        (s.currentX = u), (s.currentY = d);
        const p = s.currentX - s.startX,
          h = s.currentY - s.startY;
        if (
          n.params.threshold &&
          Math.sqrt(p ** 2 + h ** 2) < n.params.threshold
        )
          return;
        if (void 0 === r.isScrolling) {
          let e;
          (n.isHorizontal() && s.currentY === s.startY) ||
            (n.isVertical() && s.currentX === s.startX)
            ? (r.isScrolling = !1)
            : p * p + h * h >= 25 &&
            ((e = (180 * Math.atan2(Math.abs(h), Math.abs(p))) / Math.PI),
              (r.isScrolling = n.isHorizontal()
                ? e > i.touchAngle
                : 90 - e > i.touchAngle));
        }
        if (
          (r.isScrolling && n.emit("touchMoveOpposite", l),
            void 0 === r.startMoving &&
            ((s.currentX === s.startX && s.currentY === s.startY) ||
              (r.startMoving = !0)),
            r.isScrolling)
        )
          return void (r.isTouched = !1);
        if (!r.startMoving) return;
        (n.allowClick = !1),
          !i.cssMode && l.cancelable && l.preventDefault(),
          i.touchMoveStopPropagation && !i.nested && l.stopPropagation(),
          r.isMoved ||
          (i.loop && !i.cssMode && n.loopFix(),
            (r.startTranslate = n.getTranslate()),
            n.setTransition(0),
            n.animating &&
            n.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
            (r.allowMomentumBounce = !1),
            !i.grabCursor ||
            (!0 !== n.allowSlideNext && !0 !== n.allowSlidePrev) ||
            n.setGrabCursor(!0),
            n.emit("sliderFirstMove", l)),
          n.emit("sliderMove", l),
          (r.isMoved = !0);
        let f = n.isHorizontal() ? p : h;
        (s.diff = f),
          (f *= i.touchRatio),
          o && (f = -f),
          (n.swipeDirection = f > 0 ? "prev" : "next"),
          (r.currentTranslate = f + r.startTranslate);
        let m = !0,
          v = i.resistanceRatio;
        if (
          (i.touchReleaseOnEdges && (v = 0),
            f > 0 && r.currentTranslate > n.minTranslate()
              ? ((m = !1),
                i.resistance &&
                (r.currentTranslate =
                  n.minTranslate() -
                  1 +
                  (-n.minTranslate() + r.startTranslate + f) ** v))
              : f < 0 &&
              r.currentTranslate < n.maxTranslate() &&
              ((m = !1),
                i.resistance &&
                (r.currentTranslate =
                  n.maxTranslate() +
                  1 -
                  (n.maxTranslate() - r.startTranslate - f) ** v)),
            m && (l.preventedByNestedSwiper = !0),
            !n.allowSlideNext &&
            "next" === n.swipeDirection &&
            r.currentTranslate < r.startTranslate &&
            (r.currentTranslate = r.startTranslate),
            !n.allowSlidePrev &&
            "prev" === n.swipeDirection &&
            r.currentTranslate > r.startTranslate &&
            (r.currentTranslate = r.startTranslate),
            n.allowSlidePrev ||
            n.allowSlideNext ||
            (r.currentTranslate = r.startTranslate),
            i.threshold > 0)
        ) {
          if (!(Math.abs(f) > i.threshold || r.allowThresholdMove))
            return void (r.currentTranslate = r.startTranslate);
          if (!r.allowThresholdMove)
            return (
              (r.allowThresholdMove = !0),
              (s.startX = s.currentX),
              (s.startY = s.currentY),
              (r.currentTranslate = r.startTranslate),
              void (s.diff = n.isHorizontal()
                ? s.currentX - s.startX
                : s.currentY - s.startY)
            );
        }
        i.followFinger &&
          !i.cssMode &&
          (((i.freeMode && i.freeMode.enabled && n.freeMode) ||
            i.watchSlidesProgress) &&
            (n.updateActiveIndex(), n.updateSlidesClasses()),
            n.params.freeMode &&
            i.freeMode.enabled &&
            n.freeMode &&
            n.freeMode.onTouchMove(),
            n.updateProgress(r.currentTranslate),
            n.setTranslate(r.currentTranslate));
      }
      function he(e) {
        const t = this,
          n = t.touchEventsData,
          {
            params: r,
            touches: i,
            rtlTranslate: s,
            slidesGrid: o,
            enabled: a,
          } = t;
        if (!a) return;
        let l = e;
        if (
          (l.originalEvent && (l = l.originalEvent),
            n.allowTouchCallbacks && t.emit("touchEnd", l),
            (n.allowTouchCallbacks = !1),
            !n.isTouched)
        )
          return (
            n.isMoved && r.grabCursor && t.setGrabCursor(!1),
            (n.isMoved = !1),
            void (n.startMoving = !1)
          );
        r.grabCursor &&
          n.isMoved &&
          n.isTouched &&
          (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
          t.setGrabCursor(!1);
        const c = Y(),
          u = c - n.touchStartTime;
        if (t.allowClick) {
          const e = l.path || (l.composedPath && l.composedPath());
          t.updateClickedSlide((e && e[0]) || l.target),
            t.emit("tap click", l),
            u < 300 &&
            c - n.lastClickTime < 300 &&
            t.emit("doubleTap doubleClick", l);
        }
        if (
          ((n.lastClickTime = Y()),
            W(() => {
              t.destroyed || (t.allowClick = !0);
            }),
            !n.isTouched ||
            !n.isMoved ||
            !t.swipeDirection ||
            0 === i.diff ||
            n.currentTranslate === n.startTranslate)
        )
          return (
            (n.isTouched = !1), (n.isMoved = !1), void (n.startMoving = !1)
          );
        let d;
        if (
          ((n.isTouched = !1),
            (n.isMoved = !1),
            (n.startMoving = !1),
            (d = r.followFinger
              ? s
                ? t.translate
                : -t.translate
              : -n.currentTranslate),
            r.cssMode)
        )
          return;
        if (t.params.freeMode && r.freeMode.enabled)
          return void t.freeMode.onTouchEnd({ currentPos: d });
        let p = 0,
          h = t.slidesSizesGrid[0];
        for (
          let e = 0;
          e < o.length;
          e += e < r.slidesPerGroupSkip ? 1 : r.slidesPerGroup
        ) {
          const t = e < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
          void 0 !== o[e + t]
            ? d >= o[e] && d < o[e + t] && ((p = e), (h = o[e + t] - o[e]))
            : d >= o[e] && ((p = e), (h = o[o.length - 1] - o[o.length - 2]));
        }
        let f = null,
          m = null;
        r.rewind &&
          (t.isBeginning
            ? (m =
              t.params.virtual && t.params.virtual.enabled && t.virtual
                ? t.virtual.slides.length - 1
                : t.slides.length - 1)
            : t.isEnd && (f = 0));
        const v = (d - o[p]) / h,
          g = p < r.slidesPerGroupSkip - 1 ? 1 : r.slidesPerGroup;
        if (u > r.longSwipesMs) {
          if (!r.longSwipes) return void t.slideTo(t.activeIndex);
          "next" === t.swipeDirection &&
            (v >= r.longSwipesRatio
              ? t.slideTo(r.rewind && t.isEnd ? f : p + g)
              : t.slideTo(p)),
            "prev" === t.swipeDirection &&
            (v > 1 - r.longSwipesRatio
              ? t.slideTo(p + g)
              : null !== m && v < 0 && Math.abs(v) > r.longSwipesRatio
                ? t.slideTo(m)
                : t.slideTo(p));
        } else {
          if (!r.shortSwipes) return void t.slideTo(t.activeIndex);
          t.navigation &&
            (l.target === t.navigation.nextEl || l.target === t.navigation.prevEl)
            ? l.target === t.navigation.nextEl
              ? t.slideTo(p + g)
              : t.slideTo(p)
            : ("next" === t.swipeDirection && t.slideTo(null !== f ? f : p + g),
              "prev" === t.swipeDirection && t.slideTo(null !== m ? m : p));
        }
      }
      function fe() {
        const e = this,
          { params: t, el: n } = e;
        if (n && 0 === n.offsetWidth) return;
        t.breakpoints && e.setBreakpoint();
        const { allowSlideNext: r, allowSlidePrev: i, snapGrid: s } = e;
        (e.allowSlideNext = !0),
          (e.allowSlidePrev = !0),
          e.updateSize(),
          e.updateSlides(),
          e.updateSlidesClasses(),
          ("auto" === t.slidesPerView || t.slidesPerView > 1) &&
            e.isEnd &&
            !e.isBeginning &&
            !e.params.centeredSlides
            ? e.slideTo(e.slides.length - 1, 0, !1, !0)
            : e.slideTo(e.activeIndex, 0, !1, !0),
          e.autoplay &&
          e.autoplay.running &&
          e.autoplay.paused &&
          e.autoplay.run(),
          (e.allowSlidePrev = i),
          (e.allowSlideNext = r),
          e.params.watchOverflow && s !== e.snapGrid && e.checkOverflow();
      }
      function me(e) {
        const t = this;
        t.enabled &&
          (t.allowClick ||
            (t.params.preventClicks && e.preventDefault(),
              t.params.preventClicksPropagation &&
              t.animating &&
              (e.stopPropagation(), e.stopImmediatePropagation())));
      }
      function ve() {
        const e = this,
          { wrapperEl: t, rtlTranslate: n, enabled: r } = e;
        if (!r) return;
        let i;
        (e.previousTranslate = e.translate),
          e.isHorizontal()
            ? (e.translate = -t.scrollLeft)
            : (e.translate = -t.scrollTop),
          0 === e.translate && (e.translate = 0),
          e.updateActiveIndex(),
          e.updateSlidesClasses();
        const s = e.maxTranslate() - e.minTranslate();
        (i = 0 === s ? 0 : (e.translate - e.minTranslate()) / s),
          i !== e.progress && e.updateProgress(n ? -e.translate : e.translate),
          e.emit("setTranslate", e.translate, !1);
      }
      let ge = !1;
      function ye() { }
      const be = (e, t) => {
        const n = I(),
          {
            params: r,
            touchEvents: i,
            el: s,
            wrapperEl: o,
            device: a,
            support: l,
          } = e,
          c = !!r.nested,
          u = "on" === t ? "addEventListener" : "removeEventListener",
          d = t;
        if (l.touch) {
          const t = !(
            "touchstart" !== i.start ||
            !l.passiveListener ||
            !r.passiveListeners
          ) && { passive: !0, capture: !1 };
          s[u](i.start, e.onTouchStart, t),
            s[u](
              i.move,
              e.onTouchMove,
              l.passiveListener ? { passive: !1, capture: c } : c
            ),
            s[u](i.end, e.onTouchEnd, t),
            i.cancel && s[u](i.cancel, e.onTouchEnd, t);
        } else
          s[u](i.start, e.onTouchStart, !1),
            n[u](i.move, e.onTouchMove, c),
            n[u](i.end, e.onTouchEnd, !1);
        (r.preventClicks || r.preventClicksPropagation) &&
          s[u]("click", e.onClick, !0),
          r.cssMode && o[u]("scroll", e.onScroll),
          r.updateOnWindowResize
            ? e[d](
              a.ios || a.android
                ? "resize orientationchange observerUpdate"
                : "resize observerUpdate",
              fe,
              !0
            )
            : e[d]("observerUpdate", fe, !0);
      };
      var we = {
        attachEvents: function () {
          const e = this,
            t = I(),
            { params: n, support: r } = e;
          (e.onTouchStart = de.bind(e)),
            (e.onTouchMove = pe.bind(e)),
            (e.onTouchEnd = he.bind(e)),
            n.cssMode && (e.onScroll = ve.bind(e)),
            (e.onClick = me.bind(e)),
            r.touch && !ge && (t.addEventListener("touchstart", ye), (ge = !0)),
            be(e, "on");
        },
        detachEvents: function () {
          be(this, "off");
        },
      };
      const Ee = (e, t) => e.grid && t.grid && t.grid.rows > 1;
      var xe = {
        setBreakpoint: function () {
          const e = this,
            {
              activeIndex: t,
              initialized: n,
              loopedSlides: r = 0,
              params: i,
              $el: s,
            } = e,
            o = i.breakpoints;
          if (!o || (o && 0 === Object.keys(o).length)) return;
          const a = e.getBreakpoint(o, e.params.breakpointsBase, e.el);
          if (!a || e.currentBreakpoint === a) return;
          const l = (a in o ? o[a] : void 0) || e.originalParams,
            c = Ee(e, i),
            u = Ee(e, l),
            d = i.enabled;
          c && !u
            ? (s.removeClass(
              `${i.containerModifierClass}grid ${i.containerModifierClass}grid-column`
            ),
              e.emitContainerClasses())
            : !c &&
            u &&
            (s.addClass(`${i.containerModifierClass}grid`),
              ((l.grid.fill && "column" === l.grid.fill) ||
                (!l.grid.fill && "column" === i.grid.fill)) &&
              s.addClass(`${i.containerModifierClass}grid-column`),
              e.emitContainerClasses()),
            ["navigation", "pagination", "scrollbar"].forEach((t) => {
              const n = i[t] && i[t].enabled,
                r = l[t] && l[t].enabled;
              n && !r && e[t].disable(), !n && r && e[t].enable();
            });
          const p = l.direction && l.direction !== i.direction,
            h = i.loop && (l.slidesPerView !== i.slidesPerView || p);
          p && n && e.changeDirection(), U(e.params, l);
          const f = e.params.enabled;
          Object.assign(e, {
            allowTouchMove: e.params.allowTouchMove,
            allowSlideNext: e.params.allowSlideNext,
            allowSlidePrev: e.params.allowSlidePrev,
          }),
            d && !f ? e.disable() : !d && f && e.enable(),
            (e.currentBreakpoint = a),
            e.emit("_beforeBreakpoint", l),
            h &&
            n &&
            (e.loopDestroy(),
              e.loopCreate(),
              e.updateSlides(),
              e.slideTo(t - r + e.loopedSlides, 0, !1)),
            e.emit("breakpoint", l);
        },
        getBreakpoint: function (e, t = "window", n) {
          if (!e || ("container" === t && !n)) return;
          let r = !1;
          const i = _(),
            s = "window" === t ? i.innerHeight : n.clientHeight,
            o = Object.keys(e).map((e) => {
              if ("string" == typeof e && 0 === e.indexOf("@")) {
                const t = parseFloat(e.substr(1));
                return { value: s * t, point: e };
              }
              return { value: e, point: e };
            });
          o.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
          for (let e = 0; e < o.length; e += 1) {
            const { point: s, value: a } = o[e];
            "window" === t
              ? i.matchMedia(`(min-width: ${a}px)`).matches && (r = s)
              : a <= n.clientWidth && (r = s);
          }
          return r || "max";
        },
      };
      var Te = {
        addClasses: function () {
          const e = this,
            {
              classNames: t,
              params: n,
              rtl: r,
              $el: i,
              device: s,
              support: o,
            } = e,
            a = (function (e, t) {
              const n = [];
              return (
                e.forEach((e) => {
                  "object" == typeof e
                    ? Object.keys(e).forEach((r) => {
                      e[r] && n.push(t + r);
                    })
                    : "string" == typeof e && n.push(t + e);
                }),
                n
              );
            })(
              [
                "initialized",
                n.direction,
                { "pointer-events": !o.touch },
                { "free-mode": e.params.freeMode && n.freeMode.enabled },
                { autoheight: n.autoHeight },
                { rtl: r },
                { grid: n.grid && n.grid.rows > 1 },
                {
                  "grid-column":
                    n.grid && n.grid.rows > 1 && "column" === n.grid.fill,
                },
                { android: s.android },
                { ios: s.ios },
                { "css-mode": n.cssMode },
                { centered: n.cssMode && n.centeredSlides },
                { "watch-progress": n.watchSlidesProgress },
              ],
              n.containerModifierClass
            );
          t.push(...a), i.addClass([...t].join(" ")), e.emitContainerClasses();
        },
        removeClasses: function () {
          const { $el: e, classNames: t } = this;
          e.removeClass(t.join(" ")), this.emitContainerClasses();
        },
      };
      var Se = {
        loadImage: function (e, t, n, r, i, s) {
          const o = _();
          let a;
          function l() {
            s && s();
          }
          H(e).parent("picture")[0] || (e.complete && i)
            ? l()
            : t
              ? ((a = new o.Image()),
                (a.onload = l),
                (a.onerror = l),
                r && (a.sizes = r),
                n && (a.srcset = n),
                t && (a.src = t))
              : l();
        },
        preloadImages: function () {
          const e = this;
          function t() {
            null != e &&
              e &&
              !e.destroyed &&
              (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
                e.imagesLoaded === e.imagesToLoad.length &&
                (e.params.updateOnImagesReady && e.update(),
                  e.emit("imagesReady")));
          }
          e.imagesToLoad = e.$el.find("img");
          for (let n = 0; n < e.imagesToLoad.length; n += 1) {
            const r = e.imagesToLoad[n];
            e.loadImage(
              r,
              r.currentSrc || r.getAttribute("src"),
              r.srcset || r.getAttribute("srcset"),
              r.sizes || r.getAttribute("sizes"),
              !0,
              t
            );
          }
        },
      };
      var Ce = {
        checkOverflow: function () {
          const e = this,
            { isLocked: t, params: n } = e,
            { slidesOffsetBefore: r } = n;
          if (r) {
            const t = e.slides.length - 1,
              n = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * r;
            e.isLocked = e.size > n;
          } else e.isLocked = 1 === e.snapGrid.length;
          !0 === n.allowSlideNext && (e.allowSlideNext = !e.isLocked),
            !0 === n.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
            t && t !== e.isLocked && (e.isEnd = !1),
            t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
        },
      },
        ke = {
          init: !0,
          direction: "horizontal",
          touchEventsTarget: "wrapper",
          initialSlide: 0,
          speed: 300,
          cssMode: !1,
          updateOnWindowResize: !0,
          resizeObserver: !0,
          nested: !1,
          createElements: !1,
          enabled: !0,
          focusableElements:
            "input, select, option, textarea, button, video, label",
          width: null,
          height: null,
          preventInteractionOnTransition: !1,
          userAgent: null,
          url: null,
          edgeSwipeDetection: !1,
          edgeSwipeThreshold: 20,
          autoHeight: !1,
          setWrapperSize: !1,
          virtualTranslate: !1,
          effect: "slide",
          breakpoints: void 0,
          breakpointsBase: "window",
          spaceBetween: 0,
          slidesPerView: 1,
          slidesPerGroup: 1,
          slidesPerGroupSkip: 0,
          slidesPerGroupAuto: !1,
          centeredSlides: !1,
          centeredSlidesBounds: !1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          normalizeSlideIndex: !0,
          centerInsufficientSlides: !1,
          watchOverflow: !0,
          roundLengths: !1,
          touchRatio: 1,
          touchAngle: 45,
          simulateTouch: !0,
          shortSwipes: !0,
          longSwipes: !0,
          longSwipesRatio: 0.5,
          longSwipesMs: 300,
          followFinger: !0,
          allowTouchMove: !0,
          threshold: 0,
          touchMoveStopPropagation: !1,
          touchStartPreventDefault: !0,
          touchStartForcePreventDefault: !1,
          touchReleaseOnEdges: !1,
          uniqueNavElements: !0,
          resistance: !0,
          resistanceRatio: 0.85,
          watchSlidesProgress: !1,
          grabCursor: !1,
          preventClicks: !0,
          preventClicksPropagation: !0,
          slideToClickedSlide: !1,
          preloadImages: !0,
          updateOnImagesReady: !0,
          loop: !1,
          loopAdditionalSlides: 0,
          loopedSlides: null,
          loopedSlidesLimit: !0,
          loopFillGroupWithBlank: !1,
          loopPreventsSlide: !0,
          rewind: !1,
          allowSlidePrev: !0,
          allowSlideNext: !0,
          swipeHandler: null,
          noSwiping: !0,
          noSwipingClass: "swiper-no-swiping",
          noSwipingSelector: null,
          passiveListeners: !0,
          maxBackfaceHiddenSlides: 10,
          containerModifierClass: "swiper-",
          slideClass: "swiper-slide",
          slideBlankClass: "swiper-slide-invisible-blank",
          slideActiveClass: "swiper-slide-active",
          slideDuplicateActiveClass: "swiper-slide-duplicate-active",
          slideVisibleClass: "swiper-slide-visible",
          slideDuplicateClass: "swiper-slide-duplicate",
          slideNextClass: "swiper-slide-next",
          slideDuplicateNextClass: "swiper-slide-duplicate-next",
          slidePrevClass: "swiper-slide-prev",
          slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
          wrapperClass: "swiper-wrapper",
          runCallbacksOnInit: !0,
          _emitClasses: !1,
        };
      function Oe(e, t) {
        return function (n = {}) {
          const r = Object.keys(n)[0],
            i = n[r];
          "object" == typeof i && null !== i
            ? (["navigation", "pagination", "scrollbar"].indexOf(r) >= 0 &&
              !0 === e[r] &&
              (e[r] = { auto: !0 }),
              r in e && "enabled" in i
                ? (!0 === e[r] && (e[r] = { enabled: !0 }),
                  "object" != typeof e[r] ||
                  "enabled" in e[r] ||
                  (e[r].enabled = !0),
                  e[r] || (e[r] = { enabled: !1 }),
                  U(t, n))
                : U(t, n))
            : U(t, n);
        };
      }
      const Pe = {
        eventsEmitter: re,
        update: ie,
        translate: se,
        transition: ae,
        slide: le,
        loop: ce,
        grabCursor: ue,
        events: we,
        breakpoints: xe,
        checkOverflow: Ce,
        classes: Te,
        images: Se,
      },
        Le = {};
      class $e {
        constructor(...e) {
          let t, n;
          if (
            (1 === e.length &&
              e[0].constructor &&
              "Object" === Object.prototype.toString.call(e[0]).slice(8, -1)
              ? (n = e[0])
              : ([t, n] = e),
              n || (n = {}),
              (n = U({}, n)),
              t && !n.el && (n.el = t),
              n.el && H(n.el).length > 1)
          ) {
            const e = [];
            return (
              H(n.el).each((t) => {
                const r = U({}, n, { el: t });
                e.push(new $e(r));
              }),
              e
            );
          }
          const r = this;
          (r.__swiper__ = !0),
            (r.support = ee()),
            (r.device = te({ userAgent: n.userAgent })),
            (r.browser = ne()),
            (r.eventsListeners = {}),
            (r.eventsAnyListeners = []),
            (r.modules = [...r.__modules__]),
            n.modules &&
            Array.isArray(n.modules) &&
            r.modules.push(...n.modules);
          const i = {};
          r.modules.forEach((e) => {
            e({
              swiper: r,
              extendParams: Oe(n, i),
              on: r.on.bind(r),
              once: r.once.bind(r),
              off: r.off.bind(r),
              emit: r.emit.bind(r),
            });
          });
          const s = U({}, ke, i);
          return (
            (r.params = U({}, s, Le, n)),
            (r.originalParams = U({}, r.params)),
            (r.passedParams = U({}, n)),
            r.params &&
            r.params.on &&
            Object.keys(r.params.on).forEach((e) => {
              r.on(e, r.params.on[e]);
            }),
            r.params && r.params.onAny && r.onAny(r.params.onAny),
            (r.$ = H),
            Object.assign(r, {
              enabled: r.params.enabled,
              el: t,
              classNames: [],
              slides: H(),
              slidesGrid: [],
              snapGrid: [],
              slidesSizesGrid: [],
              isHorizontal() {
                return "horizontal" === r.params.direction;
              },
              isVertical() {
                return "vertical" === r.params.direction;
              },
              activeIndex: 0,
              realIndex: 0,
              isBeginning: !0,
              isEnd: !1,
              translate: 0,
              previousTranslate: 0,
              progress: 0,
              velocity: 0,
              animating: !1,
              allowSlideNext: r.params.allowSlideNext,
              allowSlidePrev: r.params.allowSlidePrev,
              touchEvents: (function () {
                const e = [
                  "touchstart",
                  "touchmove",
                  "touchend",
                  "touchcancel",
                ],
                  t = ["pointerdown", "pointermove", "pointerup"];
                return (
                  (r.touchEventsTouch = {
                    start: e[0],
                    move: e[1],
                    end: e[2],
                    cancel: e[3],
                  }),
                  (r.touchEventsDesktop = {
                    start: t[0],
                    move: t[1],
                    end: t[2],
                  }),
                  r.support.touch || !r.params.simulateTouch
                    ? r.touchEventsTouch
                    : r.touchEventsDesktop
                );
              })(),
              touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: r.params.focusableElements,
                lastClickTime: Y(),
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                isTouchEvent: void 0,
                startMoving: void 0,
              },
              allowClick: !0,
              allowTouchMove: r.params.allowTouchMove,
              touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0,
              },
              imagesToLoad: [],
              imagesLoaded: 0,
            }),
            r.emit("_swiper"),
            r.params.init && r.init(),
            r
          );
        }
        enable() {
          const e = this;
          e.enabled ||
            ((e.enabled = !0),
              e.params.grabCursor && e.setGrabCursor(),
              e.emit("enable"));
        }
        disable() {
          const e = this;
          e.enabled &&
            ((e.enabled = !1),
              e.params.grabCursor && e.unsetGrabCursor(),
              e.emit("disable"));
        }
        setProgress(e, t) {
          const n = this;
          e = Math.min(Math.max(e, 0), 1);
          const r = n.minTranslate(),
            i = (n.maxTranslate() - r) * e + r;
          n.translateTo(i, void 0 === t ? 0 : t),
            n.updateActiveIndex(),
            n.updateSlidesClasses();
        }
        emitContainerClasses() {
          const e = this;
          if (!e.params._emitClasses || !e.el) return;
          const t = e.el.className
            .split(" ")
            .filter(
              (t) =>
                0 === t.indexOf("swiper") ||
                0 === t.indexOf(e.params.containerModifierClass)
            );
          e.emit("_containerClasses", t.join(" "));
        }
        getSlideClasses(e) {
          const t = this;
          return t.destroyed
            ? ""
            : e.className
              .split(" ")
              .filter(
                (e) =>
                  0 === e.indexOf("swiper-slide") ||
                  0 === e.indexOf(t.params.slideClass)
              )
              .join(" ");
        }
        emitSlidesClasses() {
          const e = this;
          if (!e.params._emitClasses || !e.el) return;
          const t = [];
          e.slides.each((n) => {
            const r = e.getSlideClasses(n);
            t.push({ slideEl: n, classNames: r }), e.emit("_slideClass", n, r);
          }),
            e.emit("_slideClasses", t);
        }
        slidesPerViewDynamic(e = "current", t = !1) {
          const {
            params: n,
            slides: r,
            slidesGrid: i,
            slidesSizesGrid: s,
            size: o,
            activeIndex: a,
          } = this;
          let l = 1;
          if (n.centeredSlides) {
            let e,
              t = r[a].swiperSlideSize;
            for (let n = a + 1; n < r.length; n += 1)
              r[n] &&
                !e &&
                ((t += r[n].swiperSlideSize), (l += 1), t > o && (e = !0));
            for (let n = a - 1; n >= 0; n -= 1)
              r[n] &&
                !e &&
                ((t += r[n].swiperSlideSize), (l += 1), t > o && (e = !0));
          } else if ("current" === e)
            for (let e = a + 1; e < r.length; e += 1) {
              (t ? i[e] + s[e] - i[a] < o : i[e] - i[a] < o) && (l += 1);
            }
          else
            for (let e = a - 1; e >= 0; e -= 1) {
              i[a] - i[e] < o && (l += 1);
            }
          return l;
        }
        update() {
          const e = this;
          if (!e || e.destroyed) return;
          const { snapGrid: t, params: n } = e;
          function r() {
            const t = e.rtlTranslate ? -1 * e.translate : e.translate,
              n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
            e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses();
          }
          let i;
          n.breakpoints && e.setBreakpoint(),
            e.updateSize(),
            e.updateSlides(),
            e.updateProgress(),
            e.updateSlidesClasses(),
            e.params.freeMode && e.params.freeMode.enabled
              ? (r(), e.params.autoHeight && e.updateAutoHeight())
              : ((i =
                ("auto" === e.params.slidesPerView ||
                  e.params.slidesPerView > 1) &&
                  e.isEnd &&
                  !e.params.centeredSlides
                  ? e.slideTo(e.slides.length - 1, 0, !1, !0)
                  : e.slideTo(e.activeIndex, 0, !1, !0)),
                i || r()),
            n.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
            e.emit("update");
        }
        changeDirection(e, t = !0) {
          const n = this,
            r = n.params.direction;
          return (
            e || (e = "horizontal" === r ? "vertical" : "horizontal"),
            e === r ||
            ("horizontal" !== e && "vertical" !== e) ||
            (n.$el
              .removeClass(`${n.params.containerModifierClass}${r}`)
              .addClass(`${n.params.containerModifierClass}${e}`),
              n.emitContainerClasses(),
              (n.params.direction = e),
              n.slides.each((t) => {
                "vertical" === e ? (t.style.width = "") : (t.style.height = "");
              }),
              n.emit("changeDirection"),
              t && n.update()),
            n
          );
        }
        changeLanguageDirection(e) {
          const t = this;
          (t.rtl && "rtl" === e) ||
            (!t.rtl && "ltr" === e) ||
            ((t.rtl = "rtl" === e),
              (t.rtlTranslate = "horizontal" === t.params.direction && t.rtl),
              t.rtl
                ? (t.$el.addClass(`${t.params.containerModifierClass}rtl`),
                  (t.el.dir = "rtl"))
                : (t.$el.removeClass(`${t.params.containerModifierClass}rtl`),
                  (t.el.dir = "ltr")),
              t.update());
        }
        mount(e) {
          const t = this;
          if (t.mounted) return !0;
          const n = H(e || t.params.el);
          if (!(e = n[0])) return !1;
          e.swiper = t;
          const r = () =>
            `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
          let i = (() => {
            if (e && e.shadowRoot && e.shadowRoot.querySelector) {
              const t = H(e.shadowRoot.querySelector(r()));
              return (t.children = (e) => n.children(e)), t;
            }
            return n.children ? n.children(r()) : H(n).children(r());
          })();
          if (0 === i.length && t.params.createElements) {
            const e = I().createElement("div");
            (i = H(e)),
              (e.className = t.params.wrapperClass),
              n.append(e),
              n.children(`.${t.params.slideClass}`).each((e) => {
                i.append(e);
              });
          }
          return (
            Object.assign(t, {
              $el: n,
              el: e,
              $wrapperEl: i,
              wrapperEl: i[0],
              mounted: !0,
              rtl:
                "rtl" === e.dir.toLowerCase() || "rtl" === n.css("direction"),
              rtlTranslate:
                "horizontal" === t.params.direction &&
                ("rtl" === e.dir.toLowerCase() || "rtl" === n.css("direction")),
              wrongRTL: "-webkit-box" === i.css("display"),
            }),
            !0
          );
        }
        init(e) {
          const t = this;
          if (t.initialized) return t;
          return (
            !1 === t.mount(e) ||
            (t.emit("beforeInit"),
              t.params.breakpoints && t.setBreakpoint(),
              t.addClasses(),
              t.params.loop && t.loopCreate(),
              t.updateSize(),
              t.updateSlides(),
              t.params.watchOverflow && t.checkOverflow(),
              t.params.grabCursor && t.enabled && t.setGrabCursor(),
              t.params.preloadImages && t.preloadImages(),
              t.params.loop
                ? t.slideTo(
                  t.params.initialSlide + t.loopedSlides,
                  0,
                  t.params.runCallbacksOnInit,
                  !1,
                  !0
                )
                : t.slideTo(
                  t.params.initialSlide,
                  0,
                  t.params.runCallbacksOnInit,
                  !1,
                  !0
                ),
              t.attachEvents(),
              (t.initialized = !0),
              t.emit("init"),
              t.emit("afterInit")),
            t
          );
        }
        destroy(e = !0, t = !0) {
          const n = this,
            { params: r, $el: i, $wrapperEl: s, slides: o } = n;
          return (
            void 0 === n.params ||
            n.destroyed ||
            (n.emit("beforeDestroy"),
              (n.initialized = !1),
              n.detachEvents(),
              r.loop && n.loopDestroy(),
              t &&
              (n.removeClasses(),
                i.removeAttr("style"),
                s.removeAttr("style"),
                o &&
                o.length &&
                o
                  .removeClass(
                    [
                      r.slideVisibleClass,
                      r.slideActiveClass,
                      r.slideNextClass,
                      r.slidePrevClass,
                    ].join(" ")
                  )
                  .removeAttr("style")
                  .removeAttr("data-swiper-slide-index")),
              n.emit("destroy"),
              Object.keys(n.eventsListeners).forEach((e) => {
                n.off(e);
              }),
              !1 !== e &&
              ((n.$el[0].swiper = null),
                (function (e) {
                  const t = e;
                  Object.keys(t).forEach((e) => {
                    try {
                      t[e] = null;
                    } catch (e) { }
                    try {
                      delete t[e];
                    } catch (e) { }
                  });
                })(n)),
              (n.destroyed = !0)),
            null
          );
        }
        static extendDefaults(e) {
          U(Le, e);
        }
        static get extendedDefaults() {
          return Le;
        }
        static get defaults() {
          return ke;
        }
        static installModule(e) {
          $e.prototype.__modules__ || ($e.prototype.__modules__ = []);
          const t = $e.prototype.__modules__;
          "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
        }
        static use(e) {
          return Array.isArray(e)
            ? (e.forEach((e) => $e.installModule(e)), $e)
            : ($e.installModule(e), $e);
        }
      }
      Object.keys(Pe).forEach((e) => {
        Object.keys(Pe[e]).forEach((t) => {
          $e.prototype[t] = Pe[e][t];
        });
      }),
        $e.use([
          function ({ swiper: e, on: t, emit: n }) {
            const r = _();
            let i = null,
              s = null;
            const o = () => {
              e &&
                !e.destroyed &&
                e.initialized &&
                (n("beforeResize"), n("resize"));
            },
              a = () => {
                e && !e.destroyed && e.initialized && n("orientationchange");
              };
            t("init", () => {
              e.params.resizeObserver && void 0 !== r.ResizeObserver
                ? e &&
                !e.destroyed &&
                e.initialized &&
                ((i = new ResizeObserver((t) => {
                  s = r.requestAnimationFrame(() => {
                    const { width: n, height: r } = e;
                    let i = n,
                      s = r;
                    t.forEach(
                      ({ contentBoxSize: t, contentRect: n, target: r }) => {
                        (r && r !== e.el) ||
                          ((i = n ? n.width : (t[0] || t).inlineSize),
                            (s = n ? n.height : (t[0] || t).blockSize));
                      }
                    ),
                      (i === n && s === r) || o();
                  });
                })),
                  i.observe(e.el))
                : (r.addEventListener("resize", o),
                  r.addEventListener("orientationchange", a));
            }),
              t("destroy", () => {
                s && r.cancelAnimationFrame(s),
                  i && i.unobserve && e.el && (i.unobserve(e.el), (i = null)),
                  r.removeEventListener("resize", o),
                  r.removeEventListener("orientationchange", a);
              });
          },
          function ({ swiper: e, extendParams: t, on: n, emit: r }) {
            const i = [],
              s = _(),
              o = (e, t = {}) => {
                const n = new (s.MutationObserver || s.WebkitMutationObserver)(
                  (e) => {
                    if (1 === e.length) return void r("observerUpdate", e[0]);
                    const t = function () {
                      r("observerUpdate", e[0]);
                    };
                    s.requestAnimationFrame
                      ? s.requestAnimationFrame(t)
                      : s.setTimeout(t, 0);
                  }
                );
                n.observe(e, {
                  attributes: void 0 === t.attributes || t.attributes,
                  childList: void 0 === t.childList || t.childList,
                  characterData: void 0 === t.characterData || t.characterData,
                }),
                  i.push(n);
              };
            t({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
              n("init", () => {
                if (e.params.observer) {
                  if (e.params.observeParents) {
                    const t = e.$el.parents();
                    for (let e = 0; e < t.length; e += 1) o(t[e]);
                  }
                  o(e.$el[0], { childList: e.params.observeSlideChildren }),
                    o(e.$wrapperEl[0], { attributes: !1 });
                }
              }),
              n("destroy", () => {
                i.forEach((e) => {
                  e.disconnect();
                }),
                  i.splice(0, i.length);
              });
          },
        ]);
      var Me = $e;
      function Ae(e, t, n, r) {
        const i = I();
        return (
          e.params.createElements &&
          Object.keys(r).forEach((s) => {
            if (!n[s] && !0 === n.auto) {
              let o = e.$el.children(`.${r[s]}`)[0];
              o ||
                ((o = i.createElement("div")),
                  (o.className = r[s]),
                  e.$el.append(o)),
                (n[s] = o),
                (t[s] = o);
            }
          }),
          n
        );
      }
      function Ie(e = "") {
        return `.${e
          .trim()
          .replace(/([\.:!\/])/g, "\\$1")
          .replace(/ /g, ".")}`;
      }
      Me.use([
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          function i(t) {
            let n;
            return (
              t &&
              ((n = H(t)),
                e.params.uniqueNavElements &&
                "string" == typeof t &&
                n.length > 1 &&
                1 === e.$el.find(t).length &&
                (n = e.$el.find(t))),
              n
            );
          }
          function s(t, n) {
            const r = e.params.navigation;
            t &&
              t.length > 0 &&
              (t[n ? "addClass" : "removeClass"](r.disabledClass),
                t[0] && "BUTTON" === t[0].tagName && (t[0].disabled = n),
                e.params.watchOverflow &&
                e.enabled &&
                t[e.isLocked ? "addClass" : "removeClass"](r.lockClass));
          }
          function o() {
            if (e.params.loop) return;
            const { $nextEl: t, $prevEl: n } = e.navigation;
            s(n, e.isBeginning && !e.params.rewind),
              s(t, e.isEnd && !e.params.rewind);
          }
          function a(t) {
            t.preventDefault(),
              (!e.isBeginning || e.params.loop || e.params.rewind) &&
              (e.slidePrev(), r("navigationPrev"));
          }
          function l(t) {
            t.preventDefault(),
              (!e.isEnd || e.params.loop || e.params.rewind) &&
              (e.slideNext(), r("navigationNext"));
          }
          function c() {
            const t = e.params.navigation;
            if (
              ((e.params.navigation = Ae(
                e,
                e.originalParams.navigation,
                e.params.navigation,
                { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" }
              )),
                !t.nextEl && !t.prevEl)
            )
              return;
            const n = i(t.nextEl),
              r = i(t.prevEl);
            n && n.length > 0 && n.on("click", l),
              r && r.length > 0 && r.on("click", a),
              Object.assign(e.navigation, {
                $nextEl: n,
                nextEl: n && n[0],
                $prevEl: r,
                prevEl: r && r[0],
              }),
              e.enabled ||
              (n && n.addClass(t.lockClass), r && r.addClass(t.lockClass));
          }
          function u() {
            const { $nextEl: t, $prevEl: n } = e.navigation;
            t &&
              t.length &&
              (t.off("click", l),
                t.removeClass(e.params.navigation.disabledClass)),
              n &&
              n.length &&
              (n.off("click", a),
                n.removeClass(e.params.navigation.disabledClass));
          }
          t({
            navigation: {
              nextEl: null,
              prevEl: null,
              hideOnClick: !1,
              disabledClass: "swiper-button-disabled",
              hiddenClass: "swiper-button-hidden",
              lockClass: "swiper-button-lock",
              navigationDisabledClass: "swiper-navigation-disabled",
            },
          }),
            (e.navigation = {
              nextEl: null,
              $nextEl: null,
              prevEl: null,
              $prevEl: null,
            }),
            n("init", () => {
              !1 === e.params.navigation.enabled ? d() : (c(), o());
            }),
            n("toEdge fromEdge lock unlock", () => {
              o();
            }),
            n("destroy", () => {
              u();
            }),
            n("enable disable", () => {
              const { $nextEl: t, $prevEl: n } = e.navigation;
              t &&
                t[e.enabled ? "removeClass" : "addClass"](
                  e.params.navigation.lockClass
                ),
                n &&
                n[e.enabled ? "removeClass" : "addClass"](
                  e.params.navigation.lockClass
                );
            }),
            n("click", (t, n) => {
              const { $nextEl: i, $prevEl: s } = e.navigation,
                o = n.target;
              if (
                e.params.navigation.hideOnClick &&
                !H(o).is(s) &&
                !H(o).is(i)
              ) {
                if (
                  e.pagination &&
                  e.params.pagination &&
                  e.params.pagination.clickable &&
                  (e.pagination.el === o || e.pagination.el.contains(o))
                )
                  return;
                let t;
                i
                  ? (t = i.hasClass(e.params.navigation.hiddenClass))
                  : s && (t = s.hasClass(e.params.navigation.hiddenClass)),
                  r(!0 === t ? "navigationShow" : "navigationHide"),
                  i && i.toggleClass(e.params.navigation.hiddenClass),
                  s && s.toggleClass(e.params.navigation.hiddenClass);
              }
            });
          const d = () => {
            e.$el.addClass(e.params.navigation.navigationDisabledClass), u();
          };
          Object.assign(e.navigation, {
            enable: () => {
              e.$el.removeClass(e.params.navigation.navigationDisabledClass),
                c(),
                o();
            },
            disable: d,
            update: o,
            init: c,
            destroy: u,
          });
        },
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          const i = "swiper-pagination";
          let s;
          t({
            pagination: {
              el: null,
              bulletElement: "span",
              clickable: !1,
              hideOnClick: !1,
              renderBullet: null,
              renderProgressbar: null,
              renderFraction: null,
              renderCustom: null,
              progressbarOpposite: !1,
              type: "bullets",
              dynamicBullets: !1,
              dynamicMainBullets: 1,
              formatFractionCurrent: (e) => e,
              formatFractionTotal: (e) => e,
              bulletClass: `${i}-bullet`,
              bulletActiveClass: `${i}-bullet-active`,
              modifierClass: `${i}-`,
              currentClass: `${i}-current`,
              totalClass: `${i}-total`,
              hiddenClass: `${i}-hidden`,
              progressbarFillClass: `${i}-progressbar-fill`,
              progressbarOppositeClass: `${i}-progressbar-opposite`,
              clickableClass: `${i}-clickable`,
              lockClass: `${i}-lock`,
              horizontalClass: `${i}-horizontal`,
              verticalClass: `${i}-vertical`,
              paginationDisabledClass: `${i}-disabled`,
            },
          }),
            (e.pagination = { el: null, $el: null, bullets: [] });
          let o = 0;
          function a() {
            return (
              !e.params.pagination.el ||
              !e.pagination.el ||
              !e.pagination.$el ||
              0 === e.pagination.$el.length
            );
          }
          function l(t, n) {
            const { bulletActiveClass: r } = e.params.pagination;
            t[n]().addClass(`${r}-${n}`)[n]().addClass(`${r}-${n}-${n}`);
          }
          function c() {
            const t = e.rtl,
              n = e.params.pagination;
            if (a()) return;
            const i =
              e.virtual && e.params.virtual.enabled
                ? e.virtual.slides.length
                : e.slides.length,
              c = e.pagination.$el;
            let u;
            const d = e.params.loop
              ? Math.ceil((i - 2 * e.loopedSlides) / e.params.slidesPerGroup)
              : e.snapGrid.length;
            if (
              (e.params.loop
                ? ((u = Math.ceil(
                  (e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup
                )),
                  u > i - 1 - 2 * e.loopedSlides &&
                  (u -= i - 2 * e.loopedSlides),
                  u > d - 1 && (u -= d),
                  u < 0 && "bullets" !== e.params.paginationType && (u = d + u))
                : (u =
                  void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0),
                "bullets" === n.type &&
                e.pagination.bullets &&
                e.pagination.bullets.length > 0)
            ) {
              const r = e.pagination.bullets;
              let i, a, d;
              if (
                (n.dynamicBullets &&
                  ((s = r
                    .eq(0)
                  [e.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                    c.css(
                      e.isHorizontal() ? "width" : "height",
                      s * (n.dynamicMainBullets + 4) + "px"
                    ),
                    n.dynamicMainBullets > 1 &&
                    void 0 !== e.previousIndex &&
                    ((o += u - (e.previousIndex - e.loopedSlides || 0)),
                      o > n.dynamicMainBullets - 1
                        ? (o = n.dynamicMainBullets - 1)
                        : o < 0 && (o = 0)),
                    (i = Math.max(u - o, 0)),
                    (a = i + (Math.min(r.length, n.dynamicMainBullets) - 1)),
                    (d = (a + i) / 2)),
                  r.removeClass(
                    ["", "-next", "-next-next", "-prev", "-prev-prev", "-main"]
                      .map((e) => `${n.bulletActiveClass}${e}`)
                      .join(" ")
                  ),
                  c.length > 1)
              )
                r.each((e) => {
                  const t = H(e),
                    r = t.index();
                  r === u && t.addClass(n.bulletActiveClass),
                    n.dynamicBullets &&
                    (r >= i &&
                      r <= a &&
                      t.addClass(`${n.bulletActiveClass}-main`),
                      r === i && l(t, "prev"),
                      r === a && l(t, "next"));
                });
              else {
                const t = r.eq(u),
                  s = t.index();
                if ((t.addClass(n.bulletActiveClass), n.dynamicBullets)) {
                  const t = r.eq(i),
                    o = r.eq(a);
                  for (let e = i; e <= a; e += 1)
                    r.eq(e).addClass(`${n.bulletActiveClass}-main`);
                  if (e.params.loop)
                    if (s >= r.length) {
                      for (let e = n.dynamicMainBullets; e >= 0; e -= 1)
                        r.eq(r.length - e).addClass(
                          `${n.bulletActiveClass}-main`
                        );
                      r.eq(r.length - n.dynamicMainBullets - 1).addClass(
                        `${n.bulletActiveClass}-prev`
                      );
                    } else l(t, "prev"), l(o, "next");
                  else l(t, "prev"), l(o, "next");
                }
              }
              if (n.dynamicBullets) {
                const i = Math.min(r.length, n.dynamicMainBullets + 4),
                  o = (s * i - s) / 2 - d * s,
                  a = t ? "right" : "left";
                r.css(e.isHorizontal() ? a : "top", `${o}px`);
              }
            }
            if (
              ("fraction" === n.type &&
                (c
                  .find(Ie(n.currentClass))
                  .text(n.formatFractionCurrent(u + 1)),
                  c.find(Ie(n.totalClass)).text(n.formatFractionTotal(d))),
                "progressbar" === n.type)
            ) {
              let t;
              t = n.progressbarOpposite
                ? e.isHorizontal()
                  ? "vertical"
                  : "horizontal"
                : e.isHorizontal()
                  ? "horizontal"
                  : "vertical";
              const r = (u + 1) / d;
              let i = 1,
                s = 1;
              "horizontal" === t ? (i = r) : (s = r),
                c
                  .find(Ie(n.progressbarFillClass))
                  .transform(`translate3d(0,0,0) scaleX(${i}) scaleY(${s})`)
                  .transition(e.params.speed);
            }
            "custom" === n.type && n.renderCustom
              ? (c.html(n.renderCustom(e, u + 1, d)),
                r("paginationRender", c[0]))
              : r("paginationUpdate", c[0]),
              e.params.watchOverflow &&
              e.enabled &&
              c[e.isLocked ? "addClass" : "removeClass"](n.lockClass);
          }
          function u() {
            const t = e.params.pagination;
            if (a()) return;
            const n =
              e.virtual && e.params.virtual.enabled
                ? e.virtual.slides.length
                : e.slides.length,
              i = e.pagination.$el;
            let s = "";
            if ("bullets" === t.type) {
              let r = e.params.loop
                ? Math.ceil((n - 2 * e.loopedSlides) / e.params.slidesPerGroup)
                : e.snapGrid.length;
              e.params.freeMode &&
                e.params.freeMode.enabled &&
                !e.params.loop &&
                r > n &&
                (r = n);
              for (let n = 0; n < r; n += 1)
                t.renderBullet
                  ? (s += t.renderBullet.call(e, n, t.bulletClass))
                  : (s += `<${t.bulletElement} class="${t.bulletClass}"></${t.bulletElement}>`);
              i.html(s), (e.pagination.bullets = i.find(Ie(t.bulletClass)));
            }
            "fraction" === t.type &&
              ((s = t.renderFraction
                ? t.renderFraction.call(e, t.currentClass, t.totalClass)
                : `<span class="${t.currentClass}"></span> / <span class="${t.totalClass}"></span>`),
                i.html(s)),
              "progressbar" === t.type &&
              ((s = t.renderProgressbar
                ? t.renderProgressbar.call(e, t.progressbarFillClass)
                : `<span class="${t.progressbarFillClass}"></span>`),
                i.html(s)),
              "custom" !== t.type && r("paginationRender", e.pagination.$el[0]);
          }
          function d() {
            e.params.pagination = Ae(
              e,
              e.originalParams.pagination,
              e.params.pagination,
              { el: "swiper-pagination" }
            );
            const t = e.params.pagination;
            if (!t.el) return;
            let n = H(t.el);
            0 !== n.length &&
              (e.params.uniqueNavElements &&
                "string" == typeof t.el &&
                n.length > 1 &&
                ((n = e.$el.find(t.el)),
                  n.length > 1 &&
                  (n = n.filter((t) => H(t).parents(".swiper")[0] === e.el))),
                "bullets" === t.type &&
                t.clickable &&
                n.addClass(t.clickableClass),
                n.addClass(t.modifierClass + t.type),
                n.addClass(
                  e.isHorizontal() ? t.horizontalClass : t.verticalClass
                ),
                "bullets" === t.type &&
                t.dynamicBullets &&
                (n.addClass(`${t.modifierClass}${t.type}-dynamic`),
                  (o = 0),
                  t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
                "progressbar" === t.type &&
                t.progressbarOpposite &&
                n.addClass(t.progressbarOppositeClass),
                t.clickable &&
                n.on("click", Ie(t.bulletClass), function (t) {
                  t.preventDefault();
                  let n = H(this).index() * e.params.slidesPerGroup;
                  e.params.loop && (n += e.loopedSlides), e.slideTo(n);
                }),
                Object.assign(e.pagination, { $el: n, el: n[0] }),
                e.enabled || n.addClass(t.lockClass));
          }
          function p() {
            const t = e.params.pagination;
            if (a()) return;
            const n = e.pagination.$el;
            n.removeClass(t.hiddenClass),
              n.removeClass(t.modifierClass + t.type),
              n.removeClass(
                e.isHorizontal() ? t.horizontalClass : t.verticalClass
              ),
              e.pagination.bullets &&
              e.pagination.bullets.removeClass &&
              e.pagination.bullets.removeClass(t.bulletActiveClass),
              t.clickable && n.off("click", Ie(t.bulletClass));
          }
          n("init", () => {
            !1 === e.params.pagination.enabled ? h() : (d(), u(), c());
          }),
            n("activeIndexChange", () => {
              (e.params.loop || void 0 === e.snapIndex) && c();
            }),
            n("snapIndexChange", () => {
              e.params.loop || c();
            }),
            n("slidesLengthChange", () => {
              e.params.loop && (u(), c());
            }),
            n("snapGridLengthChange", () => {
              e.params.loop || (u(), c());
            }),
            n("destroy", () => {
              p();
            }),
            n("enable disable", () => {
              const { $el: t } = e.pagination;
              t &&
                t[e.enabled ? "removeClass" : "addClass"](
                  e.params.pagination.lockClass
                );
            }),
            n("lock unlock", () => {
              c();
            }),
            n("click", (t, n) => {
              const i = n.target,
                { $el: s } = e.pagination;
              if (
                e.params.pagination.el &&
                e.params.pagination.hideOnClick &&
                s &&
                s.length > 0 &&
                !H(i).hasClass(e.params.pagination.bulletClass)
              ) {
                if (
                  e.navigation &&
                  ((e.navigation.nextEl && i === e.navigation.nextEl) ||
                    (e.navigation.prevEl && i === e.navigation.prevEl))
                )
                  return;
                const t = s.hasClass(e.params.pagination.hiddenClass);
                r(!0 === t ? "paginationShow" : "paginationHide"),
                  s.toggleClass(e.params.pagination.hiddenClass);
              }
            });
          const h = () => {
            e.$el.addClass(e.params.pagination.paginationDisabledClass),
              e.pagination.$el &&
              e.pagination.$el.addClass(
                e.params.pagination.paginationDisabledClass
              ),
              p();
          };
          Object.assign(e.pagination, {
            enable: () => {
              e.$el.removeClass(e.params.pagination.paginationDisabledClass),
                e.pagination.$el &&
                e.pagination.$el.removeClass(
                  e.params.pagination.paginationDisabledClass
                ),
                d(),
                u(),
                c();
            },
            disable: h,
            render: u,
            update: c,
            init: d,
            destroy: p,
          });
        },
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          const i = _();
          t({
            zoom: {
              enabled: !1,
              maxRatio: 3,
              minRatio: 1,
              toggle: !0,
              containerClass: "swiper-zoom-container",
              zoomedSlideClass: "swiper-slide-zoomed",
            },
          }),
            (e.zoom = { enabled: !1 });
          let s,
            o,
            a,
            l = 1,
            c = !1;
          const u = {
            $slideEl: void 0,
            slideWidth: void 0,
            slideHeight: void 0,
            $imageEl: void 0,
            $imageWrapEl: void 0,
            maxRatio: 3,
          },
            d = {
              isTouched: void 0,
              isMoved: void 0,
              currentX: void 0,
              currentY: void 0,
              minX: void 0,
              minY: void 0,
              maxX: void 0,
              maxY: void 0,
              width: void 0,
              height: void 0,
              startX: void 0,
              startY: void 0,
              touchesStart: {},
              touchesCurrent: {},
            },
            p = {
              x: void 0,
              y: void 0,
              prevPositionX: void 0,
              prevPositionY: void 0,
              prevTime: void 0,
            };
          let h = 1;
          function f(e) {
            if (e.targetTouches.length < 2) return 1;
            const t = e.targetTouches[0].pageX,
              n = e.targetTouches[0].pageY,
              r = e.targetTouches[1].pageX,
              i = e.targetTouches[1].pageY;
            return Math.sqrt((r - t) ** 2 + (i - n) ** 2);
          }
          function m(t) {
            const n = e.support,
              r = e.params.zoom;
            if (((o = !1), (a = !1), !n.gestures)) {
              if (
                "touchstart" !== t.type ||
                ("touchstart" === t.type && t.targetTouches.length < 2)
              )
                return;
              (o = !0), (u.scaleStart = f(t));
            }
            (u.$slideEl && u.$slideEl.length) ||
              ((u.$slideEl = H(t.target).closest(`.${e.params.slideClass}`)),
                0 === u.$slideEl.length &&
                (u.$slideEl = e.slides.eq(e.activeIndex)),
                (u.$imageEl = u.$slideEl
                  .find(`.${r.containerClass}`)
                  .eq(0)
                  .find("picture, img, svg, canvas, .swiper-zoom-target")
                  .eq(0)),
                (u.$imageWrapEl = u.$imageEl.parent(`.${r.containerClass}`)),
                (u.maxRatio =
                  u.$imageWrapEl.attr("data-swiper-zoom") || r.maxRatio),
                0 !== u.$imageWrapEl.length)
              ? (u.$imageEl && u.$imageEl.transition(0), (c = !0))
              : (u.$imageEl = void 0);
          }
          function v(t) {
            const n = e.support,
              r = e.params.zoom,
              i = e.zoom;
            if (!n.gestures) {
              if (
                "touchmove" !== t.type ||
                ("touchmove" === t.type && t.targetTouches.length < 2)
              )
                return;
              (a = !0), (u.scaleMove = f(t));
            }
            u.$imageEl && 0 !== u.$imageEl.length
              ? (n.gestures
                ? (i.scale = t.scale * l)
                : (i.scale = (u.scaleMove / u.scaleStart) * l),
                i.scale > u.maxRatio &&
                (i.scale =
                  u.maxRatio - 1 + (i.scale - u.maxRatio + 1) ** 0.5),
                i.scale < r.minRatio &&
                (i.scale =
                  r.minRatio + 1 - (r.minRatio - i.scale + 1) ** 0.5),
                u.$imageEl.transform(`translate3d(0,0,0) scale(${i.scale})`))
              : "gesturechange" === t.type && m(t);
          }
          function g(t) {
            const n = e.device,
              r = e.support,
              i = e.params.zoom,
              s = e.zoom;
            if (!r.gestures) {
              if (!o || !a) return;
              if (
                "touchend" !== t.type ||
                ("touchend" === t.type &&
                  t.changedTouches.length < 2 &&
                  !n.android)
              )
                return;
              (o = !1), (a = !1);
            }
            u.$imageEl &&
              0 !== u.$imageEl.length &&
              ((s.scale = Math.max(Math.min(s.scale, u.maxRatio), i.minRatio)),
                u.$imageEl
                  .transition(e.params.speed)
                  .transform(`translate3d(0,0,0) scale(${s.scale})`),
                (l = s.scale),
                (c = !1),
                1 === s.scale && (u.$slideEl = void 0));
          }
          function y(t) {
            const n = e.zoom;
            if (!u.$imageEl || 0 === u.$imageEl.length) return;
            if (((e.allowClick = !1), !d.isTouched || !u.$slideEl)) return;
            d.isMoved ||
              ((d.width = u.$imageEl[0].offsetWidth),
                (d.height = u.$imageEl[0].offsetHeight),
                (d.startX = G(u.$imageWrapEl[0], "x") || 0),
                (d.startY = G(u.$imageWrapEl[0], "y") || 0),
                (u.slideWidth = u.$slideEl[0].offsetWidth),
                (u.slideHeight = u.$slideEl[0].offsetHeight),
                u.$imageWrapEl.transition(0));
            const r = d.width * n.scale,
              i = d.height * n.scale;
            if (!(r < u.slideWidth && i < u.slideHeight)) {
              if (
                ((d.minX = Math.min(u.slideWidth / 2 - r / 2, 0)),
                  (d.maxX = -d.minX),
                  (d.minY = Math.min(u.slideHeight / 2 - i / 2, 0)),
                  (d.maxY = -d.minY),
                  (d.touchesCurrent.x =
                    "touchmove" === t.type ? t.targetTouches[0].pageX : t.pageX),
                  (d.touchesCurrent.y =
                    "touchmove" === t.type ? t.targetTouches[0].pageY : t.pageY),
                  !d.isMoved && !c)
              ) {
                if (
                  e.isHorizontal() &&
                  ((Math.floor(d.minX) === Math.floor(d.startX) &&
                    d.touchesCurrent.x < d.touchesStart.x) ||
                    (Math.floor(d.maxX) === Math.floor(d.startX) &&
                      d.touchesCurrent.x > d.touchesStart.x))
                )
                  return void (d.isTouched = !1);
                if (
                  !e.isHorizontal() &&
                  ((Math.floor(d.minY) === Math.floor(d.startY) &&
                    d.touchesCurrent.y < d.touchesStart.y) ||
                    (Math.floor(d.maxY) === Math.floor(d.startY) &&
                      d.touchesCurrent.y > d.touchesStart.y))
                )
                  return void (d.isTouched = !1);
              }
              t.cancelable && t.preventDefault(),
                t.stopPropagation(),
                (d.isMoved = !0),
                (d.currentX = d.touchesCurrent.x - d.touchesStart.x + d.startX),
                (d.currentY = d.touchesCurrent.y - d.touchesStart.y + d.startY),
                d.currentX < d.minX &&
                (d.currentX = d.minX + 1 - (d.minX - d.currentX + 1) ** 0.8),
                d.currentX > d.maxX &&
                (d.currentX = d.maxX - 1 + (d.currentX - d.maxX + 1) ** 0.8),
                d.currentY < d.minY &&
                (d.currentY = d.minY + 1 - (d.minY - d.currentY + 1) ** 0.8),
                d.currentY > d.maxY &&
                (d.currentY = d.maxY - 1 + (d.currentY - d.maxY + 1) ** 0.8),
                p.prevPositionX || (p.prevPositionX = d.touchesCurrent.x),
                p.prevPositionY || (p.prevPositionY = d.touchesCurrent.y),
                p.prevTime || (p.prevTime = Date.now()),
                (p.x =
                  (d.touchesCurrent.x - p.prevPositionX) /
                  (Date.now() - p.prevTime) /
                  2),
                (p.y =
                  (d.touchesCurrent.y - p.prevPositionY) /
                  (Date.now() - p.prevTime) /
                  2),
                Math.abs(d.touchesCurrent.x - p.prevPositionX) < 2 && (p.x = 0),
                Math.abs(d.touchesCurrent.y - p.prevPositionY) < 2 && (p.y = 0),
                (p.prevPositionX = d.touchesCurrent.x),
                (p.prevPositionY = d.touchesCurrent.y),
                (p.prevTime = Date.now()),
                u.$imageWrapEl.transform(
                  `translate3d(${d.currentX}px, ${d.currentY}px,0)`
                );
            }
          }
          function b() {
            const t = e.zoom;
            u.$slideEl &&
              e.previousIndex !== e.activeIndex &&
              (u.$imageEl &&
                u.$imageEl.transform("translate3d(0,0,0) scale(1)"),
                u.$imageWrapEl && u.$imageWrapEl.transform("translate3d(0,0,0)"),
                (t.scale = 1),
                (l = 1),
                (u.$slideEl = void 0),
                (u.$imageEl = void 0),
                (u.$imageWrapEl = void 0));
          }
          function w(t) {
            const n = e.zoom,
              r = e.params.zoom;
            if (
              (u.$slideEl ||
                (t &&
                  t.target &&
                  (u.$slideEl = H(t.target).closest(`.${e.params.slideClass}`)),
                  u.$slideEl ||
                  (e.params.virtual && e.params.virtual.enabled && e.virtual
                    ? (u.$slideEl = e.$wrapperEl.children(
                      `.${e.params.slideActiveClass}`
                    ))
                    : (u.$slideEl = e.slides.eq(e.activeIndex))),
                  (u.$imageEl = u.$slideEl
                    .find(`.${r.containerClass}`)
                    .eq(0)
                    .find("picture, img, svg, canvas, .swiper-zoom-target")
                    .eq(0)),
                  (u.$imageWrapEl = u.$imageEl.parent(`.${r.containerClass}`))),
                !u.$imageEl ||
                0 === u.$imageEl.length ||
                !u.$imageWrapEl ||
                0 === u.$imageWrapEl.length)
            )
              return;
            let s, o, a, c, p, h, f, m, v, g, y, b, w, E, x, T, S, C;
            e.params.cssMode &&
              ((e.wrapperEl.style.overflow = "hidden"),
                (e.wrapperEl.style.touchAction = "none")),
              u.$slideEl.addClass(`${r.zoomedSlideClass}`),
              void 0 === d.touchesStart.x && t
                ? ((s =
                  "touchend" === t.type
                    ? t.changedTouches[0].pageX
                    : t.pageX),
                  (o =
                    "touchend" === t.type
                      ? t.changedTouches[0].pageY
                      : t.pageY))
                : ((s = d.touchesStart.x), (o = d.touchesStart.y)),
              (n.scale = u.$imageWrapEl.attr("data-swiper-zoom") || r.maxRatio),
              (l = u.$imageWrapEl.attr("data-swiper-zoom") || r.maxRatio),
              t
                ? ((S = u.$slideEl[0].offsetWidth),
                  (C = u.$slideEl[0].offsetHeight),
                  (a = u.$slideEl.offset().left + i.scrollX),
                  (c = u.$slideEl.offset().top + i.scrollY),
                  (p = a + S / 2 - s),
                  (h = c + C / 2 - o),
                  (v = u.$imageEl[0].offsetWidth),
                  (g = u.$imageEl[0].offsetHeight),
                  (y = v * n.scale),
                  (b = g * n.scale),
                  (w = Math.min(S / 2 - y / 2, 0)),
                  (E = Math.min(C / 2 - b / 2, 0)),
                  (x = -w),
                  (T = -E),
                  (f = p * n.scale),
                  (m = h * n.scale),
                  f < w && (f = w),
                  f > x && (f = x),
                  m < E && (m = E),
                  m > T && (m = T))
                : ((f = 0), (m = 0)),
              u.$imageWrapEl
                .transition(300)
                .transform(`translate3d(${f}px, ${m}px,0)`),
              u.$imageEl
                .transition(300)
                .transform(`translate3d(0,0,0) scale(${n.scale})`);
          }
          function E() {
            const t = e.zoom,
              n = e.params.zoom;
            u.$slideEl ||
              (e.params.virtual && e.params.virtual.enabled && e.virtual
                ? (u.$slideEl = e.$wrapperEl.children(
                  `.${e.params.slideActiveClass}`
                ))
                : (u.$slideEl = e.slides.eq(e.activeIndex)),
                (u.$imageEl = u.$slideEl
                  .find(`.${n.containerClass}`)
                  .eq(0)
                  .find("picture, img, svg, canvas, .swiper-zoom-target")
                  .eq(0)),
                (u.$imageWrapEl = u.$imageEl.parent(`.${n.containerClass}`))),
              u.$imageEl &&
              0 !== u.$imageEl.length &&
              u.$imageWrapEl &&
              0 !== u.$imageWrapEl.length &&
              (e.params.cssMode &&
                ((e.wrapperEl.style.overflow = ""),
                  (e.wrapperEl.style.touchAction = "")),
                (t.scale = 1),
                (l = 1),
                u.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),
                u.$imageEl
                  .transition(300)
                  .transform("translate3d(0,0,0) scale(1)"),
                u.$slideEl.removeClass(`${n.zoomedSlideClass}`),
                (u.$slideEl = void 0));
          }
          function x(t) {
            const n = e.zoom;
            n.scale && 1 !== n.scale ? E() : w(t);
          }
          function T() {
            const t = e.support;
            return {
              passiveListener: !(
                "touchstart" !== e.touchEvents.start ||
                !t.passiveListener ||
                !e.params.passiveListeners
              ) && { passive: !0, capture: !1 },
              activeListenerWithCapture: !t.passiveListener || {
                passive: !1,
                capture: !0,
              },
            };
          }
          function S() {
            return `.${e.params.slideClass}`;
          }
          function C(t) {
            const { passiveListener: n } = T(),
              r = S();
            e.$wrapperEl[t]("gesturestart", r, m, n),
              e.$wrapperEl[t]("gesturechange", r, v, n),
              e.$wrapperEl[t]("gestureend", r, g, n);
          }
          function k() {
            s || ((s = !0), C("on"));
          }
          function O() {
            s && ((s = !1), C("off"));
          }
          function P() {
            const t = e.zoom;
            if (t.enabled) return;
            t.enabled = !0;
            const n = e.support,
              { passiveListener: r, activeListenerWithCapture: i } = T(),
              s = S();
            n.gestures
              ? (e.$wrapperEl.on(e.touchEvents.start, k, r),
                e.$wrapperEl.on(e.touchEvents.end, O, r))
              : "touchstart" === e.touchEvents.start &&
              (e.$wrapperEl.on(e.touchEvents.start, s, m, r),
                e.$wrapperEl.on(e.touchEvents.move, s, v, i),
                e.$wrapperEl.on(e.touchEvents.end, s, g, r),
                e.touchEvents.cancel &&
                e.$wrapperEl.on(e.touchEvents.cancel, s, g, r)),
              e.$wrapperEl.on(
                e.touchEvents.move,
                `.${e.params.zoom.containerClass}`,
                y,
                i
              );
          }
          function L() {
            const t = e.zoom;
            if (!t.enabled) return;
            const n = e.support;
            t.enabled = !1;
            const { passiveListener: r, activeListenerWithCapture: i } = T(),
              s = S();
            n.gestures
              ? (e.$wrapperEl.off(e.touchEvents.start, k, r),
                e.$wrapperEl.off(e.touchEvents.end, O, r))
              : "touchstart" === e.touchEvents.start &&
              (e.$wrapperEl.off(e.touchEvents.start, s, m, r),
                e.$wrapperEl.off(e.touchEvents.move, s, v, i),
                e.$wrapperEl.off(e.touchEvents.end, s, g, r),
                e.touchEvents.cancel &&
                e.$wrapperEl.off(e.touchEvents.cancel, s, g, r)),
              e.$wrapperEl.off(
                e.touchEvents.move,
                `.${e.params.zoom.containerClass}`,
                y,
                i
              );
          }
          Object.defineProperty(e.zoom, "scale", {
            get() {
              return h;
            },
            set(e) {
              if (h !== e) {
                const t = u.$imageEl ? u.$imageEl[0] : void 0,
                  n = u.$slideEl ? u.$slideEl[0] : void 0;
                r("zoomChange", e, t, n);
              }
              h = e;
            },
          }),
            n("init", () => {
              e.params.zoom.enabled && P();
            }),
            n("destroy", () => {
              L();
            }),
            n("touchStart", (t, n) => {
              e.zoom.enabled &&
                (function (t) {
                  const n = e.device;
                  u.$imageEl &&
                    0 !== u.$imageEl.length &&
                    (d.isTouched ||
                      (n.android && t.cancelable && t.preventDefault(),
                        (d.isTouched = !0),
                        (d.touchesStart.x =
                          "touchstart" === t.type
                            ? t.targetTouches[0].pageX
                            : t.pageX),
                        (d.touchesStart.y =
                          "touchstart" === t.type
                            ? t.targetTouches[0].pageY
                            : t.pageY)));
                })(n);
            }),
            n("touchEnd", (t, n) => {
              e.zoom.enabled &&
                (function () {
                  const t = e.zoom;
                  if (!u.$imageEl || 0 === u.$imageEl.length) return;
                  if (!d.isTouched || !d.isMoved)
                    return (d.isTouched = !1), void (d.isMoved = !1);
                  (d.isTouched = !1), (d.isMoved = !1);
                  let n = 300,
                    r = 300;
                  const i = p.x * n,
                    s = d.currentX + i,
                    o = p.y * r,
                    a = d.currentY + o;
                  0 !== p.x && (n = Math.abs((s - d.currentX) / p.x)),
                    0 !== p.y && (r = Math.abs((a - d.currentY) / p.y));
                  const l = Math.max(n, r);
                  (d.currentX = s), (d.currentY = a);
                  const c = d.width * t.scale,
                    h = d.height * t.scale;
                  (d.minX = Math.min(u.slideWidth / 2 - c / 2, 0)),
                    (d.maxX = -d.minX),
                    (d.minY = Math.min(u.slideHeight / 2 - h / 2, 0)),
                    (d.maxY = -d.minY),
                    (d.currentX = Math.max(
                      Math.min(d.currentX, d.maxX),
                      d.minX
                    )),
                    (d.currentY = Math.max(
                      Math.min(d.currentY, d.maxY),
                      d.minY
                    )),
                    u.$imageWrapEl
                      .transition(l)
                      .transform(
                        `translate3d(${d.currentX}px, ${d.currentY}px,0)`
                      );
                })();
            }),
            n("doubleTap", (t, n) => {
              !e.animating &&
                e.params.zoom.enabled &&
                e.zoom.enabled &&
                e.params.zoom.toggle &&
                x(n);
            }),
            n("transitionEnd", () => {
              e.zoom.enabled && e.params.zoom.enabled && b();
            }),
            n("slideChange", () => {
              e.zoom.enabled &&
                e.params.zoom.enabled &&
                e.params.cssMode &&
                b();
            }),
            Object.assign(e.zoom, {
              enable: P,
              disable: L,
              in: w,
              out: E,
              toggle: x,
            });
        },
        function ({ swiper: e, extendParams: t, on: n }) {
          t({
            thumbs: {
              swiper: null,
              multipleActiveThumbs: !0,
              autoScrollOffset: 0,
              slideThumbActiveClass: "swiper-slide-thumb-active",
              thumbsContainerClass: "swiper-thumbs",
            },
          });
          let r = !1,
            i = !1;
          function s() {
            const t = e.thumbs.swiper;
            if (!t || t.destroyed) return;
            const n = t.clickedIndex,
              r = t.clickedSlide;
            if (r && H(r).hasClass(e.params.thumbs.slideThumbActiveClass))
              return;
            if (null == n) return;
            let i;
            if (
              ((i = t.params.loop
                ? parseInt(
                  H(t.clickedSlide).attr("data-swiper-slide-index"),
                  10
                )
                : n),
                e.params.loop)
            ) {
              let t = e.activeIndex;
              e.slides.eq(t).hasClass(e.params.slideDuplicateClass) &&
                (e.loopFix(),
                  (e._clientLeft = e.$wrapperEl[0].clientLeft),
                  (t = e.activeIndex));
              const n = e.slides
                .eq(t)
                .prevAll(`[data-swiper-slide-index="${i}"]`)
                .eq(0)
                .index(),
                r = e.slides
                  .eq(t)
                  .nextAll(`[data-swiper-slide-index="${i}"]`)
                  .eq(0)
                  .index();
              i = void 0 === n ? r : void 0 === r ? n : r - t < t - n ? r : n;
            }
            e.slideTo(i);
          }
          function o() {
            const { thumbs: t } = e.params;
            if (r) return !1;
            r = !0;
            const n = e.constructor;
            if (t.swiper instanceof n)
              (e.thumbs.swiper = t.swiper),
                Object.assign(e.thumbs.swiper.originalParams, {
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                }),
                Object.assign(e.thumbs.swiper.params, {
                  watchSlidesProgress: !0,
                  slideToClickedSlide: !1,
                });
            else if (X(t.swiper)) {
              const r = Object.assign({}, t.swiper);
              Object.assign(r, {
                watchSlidesProgress: !0,
                slideToClickedSlide: !1,
              }),
                (e.thumbs.swiper = new n(r)),
                (i = !0);
            }
            return (
              e.thumbs.swiper.$el.addClass(
                e.params.thumbs.thumbsContainerClass
              ),
              e.thumbs.swiper.on("tap", s),
              !0
            );
          }
          function a(t) {
            const n = e.thumbs.swiper;
            if (!n || n.destroyed) return;
            const r =
              "auto" === n.params.slidesPerView
                ? n.slidesPerViewDynamic()
                : n.params.slidesPerView;
            let i = 1;
            const s = e.params.thumbs.slideThumbActiveClass;
            if (
              (e.params.slidesPerView > 1 &&
                !e.params.centeredSlides &&
                (i = e.params.slidesPerView),
                e.params.thumbs.multipleActiveThumbs || (i = 1),
                (i = Math.floor(i)),
                n.slides.removeClass(s),
                n.params.loop || (n.params.virtual && n.params.virtual.enabled))
            )
              for (let t = 0; t < i; t += 1)
                n.$wrapperEl
                  .children(`[data-swiper-slide-index="${e.realIndex + t}"]`)
                  .addClass(s);
            else
              for (let t = 0; t < i; t += 1)
                n.slides.eq(e.realIndex + t).addClass(s);
            const o = e.params.thumbs.autoScrollOffset,
              a = o && !n.params.loop;
            if (e.realIndex !== n.realIndex || a) {
              let i,
                s,
                l = n.activeIndex;
              if (n.params.loop) {
                n.slides.eq(l).hasClass(n.params.slideDuplicateClass) &&
                  (n.loopFix(),
                    (n._clientLeft = n.$wrapperEl[0].clientLeft),
                    (l = n.activeIndex));
                const t = n.slides
                  .eq(l)
                  .prevAll(`[data-swiper-slide-index="${e.realIndex}"]`)
                  .eq(0)
                  .index(),
                  r = n.slides
                    .eq(l)
                    .nextAll(`[data-swiper-slide-index="${e.realIndex}"]`)
                    .eq(0)
                    .index();
                (i =
                  void 0 === t
                    ? r
                    : void 0 === r
                      ? t
                      : r - l == l - t
                        ? n.params.slidesPerGroup > 1
                          ? r
                          : l
                        : r - l < l - t
                          ? r
                          : t),
                  (s = e.activeIndex > e.previousIndex ? "next" : "prev");
              } else
                (i = e.realIndex), (s = i > e.previousIndex ? "next" : "prev");
              a && (i += "next" === s ? o : -1 * o),
                n.visibleSlidesIndexes &&
                n.visibleSlidesIndexes.indexOf(i) < 0 &&
                (n.params.centeredSlides
                  ? (i =
                    i > l
                      ? i - Math.floor(r / 2) + 1
                      : i + Math.floor(r / 2) - 1)
                  : i > l && n.params.slidesPerGroup,
                  n.slideTo(i, t ? 0 : void 0));
            }
          }
          (e.thumbs = { swiper: null }),
            n("beforeInit", () => {
              const { thumbs: t } = e.params;
              t && t.swiper && (o(), a(!0));
            }),
            n("slideChange update resize observerUpdate", () => {
              a();
            }),
            n("setTransition", (t, n) => {
              const r = e.thumbs.swiper;
              r && !r.destroyed && r.setTransition(n);
            }),
            n("beforeDestroy", () => {
              const t = e.thumbs.swiper;
              t && !t.destroyed && i && t.destroy();
            }),
            Object.assign(e.thumbs, { init: o, update: a });
        },
        function ({ swiper: e, extendParams: t, on: n, emit: r }) {
          let i;
          function s() {
            if (!e.size)
              return (e.autoplay.running = !1), void (e.autoplay.paused = !1);
            const t = e.slides.eq(e.activeIndex);
            let n = e.params.autoplay.delay;
            t.attr("data-swiper-autoplay") &&
              (n = t.attr("data-swiper-autoplay") || e.params.autoplay.delay),
              clearTimeout(i),
              (i = W(() => {
                let t;
                e.params.autoplay.reverseDirection
                  ? e.params.loop
                    ? (e.loopFix(),
                      (t = e.slidePrev(e.params.speed, !0, !0)),
                      r("autoplay"))
                    : e.isBeginning
                      ? e.params.autoplay.stopOnLastSlide
                        ? a()
                        : ((t = e.slideTo(
                          e.slides.length - 1,
                          e.params.speed,
                          !0,
                          !0
                        )),
                          r("autoplay"))
                      : ((t = e.slidePrev(e.params.speed, !0, !0)), r("autoplay"))
                  : e.params.loop
                    ? (e.loopFix(),
                      (t = e.slideNext(e.params.speed, !0, !0)),
                      r("autoplay"))
                    : e.isEnd
                      ? e.params.autoplay.stopOnLastSlide
                        ? a()
                        : ((t = e.slideTo(0, e.params.speed, !0, !0)),
                          r("autoplay"))
                      : ((t = e.slideNext(e.params.speed, !0, !0)), r("autoplay")),
                  ((e.params.cssMode && e.autoplay.running) || !1 === t) && s();
              }, n));
          }
          function o() {
            return (
              void 0 === i &&
              !e.autoplay.running &&
              ((e.autoplay.running = !0), r("autoplayStart"), s(), !0)
            );
          }
          function a() {
            return (
              !!e.autoplay.running &&
              void 0 !== i &&
              (i && (clearTimeout(i), (i = void 0)),
                (e.autoplay.running = !1),
                r("autoplayStop"),
                !0)
            );
          }
          function l(t) {
            e.autoplay.running &&
              (e.autoplay.paused ||
                (i && clearTimeout(i),
                  (e.autoplay.paused = !0),
                  0 !== t && e.params.autoplay.waitForTransition
                    ? ["transitionend", "webkitTransitionEnd"].forEach((t) => {
                      e.$wrapperEl[0].addEventListener(t, u);
                    })
                    : ((e.autoplay.paused = !1), s())));
          }
          function c() {
            const t = I();
            "hidden" === t.visibilityState && e.autoplay.running && l(),
              "visible" === t.visibilityState &&
              e.autoplay.paused &&
              (s(), (e.autoplay.paused = !1));
          }
          function u(t) {
            e &&
              !e.destroyed &&
              e.$wrapperEl &&
              t.target === e.$wrapperEl[0] &&
              (["transitionend", "webkitTransitionEnd"].forEach((t) => {
                e.$wrapperEl[0].removeEventListener(t, u);
              }),
                (e.autoplay.paused = !1),
                e.autoplay.running ? s() : a());
          }
          function d() {
            e.params.autoplay.disableOnInteraction
              ? a()
              : (r("autoplayPause"), l()),
              ["transitionend", "webkitTransitionEnd"].forEach((t) => {
                e.$wrapperEl[0].removeEventListener(t, u);
              });
          }
          function p() {
            e.params.autoplay.disableOnInteraction ||
              ((e.autoplay.paused = !1), r("autoplayResume"), s());
          }
          (e.autoplay = { running: !1, paused: !1 }),
            t({
              autoplay: {
                enabled: !1,
                delay: 3e3,
                waitForTransition: !0,
                disableOnInteraction: !0,
                stopOnLastSlide: !1,
                reverseDirection: !1,
                pauseOnMouseEnter: !1,
              },
            }),
            n("init", () => {
              if (e.params.autoplay.enabled) {
                o();
                I().addEventListener("visibilitychange", c),
                  e.params.autoplay.pauseOnMouseEnter &&
                  (e.$el.on("mouseenter", d), e.$el.on("mouseleave", p));
              }
            }),
            n("beforeTransitionStart", (t, n, r) => {
              e.autoplay.running &&
                (r || !e.params.autoplay.disableOnInteraction
                  ? e.autoplay.pause(n)
                  : a());
            }),
            n("sliderFirstMove", () => {
              e.autoplay.running &&
                (e.params.autoplay.disableOnInteraction ? a() : l());
            }),
            n("touchEnd", () => {
              e.params.cssMode &&
                e.autoplay.paused &&
                !e.params.autoplay.disableOnInteraction &&
                s();
            }),
            n("destroy", () => {
              e.$el.off("mouseenter", d),
                e.$el.off("mouseleave", p),
                e.autoplay.running && a();
              I().removeEventListener("visibilitychange", c);
            }),
            Object.assign(e.autoplay, { pause: l, run: s, start: o, stop: a });
        },
      ]);
      var je = Me;
      function _e(e) {
        var t = (function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Boolean.prototype.valueOf.call(
                Reflect.construct(Boolean, [], function () { })
              ),
              !0
            );
          } catch (e) {
            return !1;
          }
        })();
        return function () {
          var n,
            r = p(e);
          if (t) {
            var i = p(this).constructor;
            n = Reflect.construct(r, arguments, i);
          } else n = r.apply(this, arguments);
          return d(this, n);
        };
      }
      var Ne = (function (e) {
        c(n, e);
        var t = _e(n);
        function n() {
          var e;
          return (
            r(this, n),
            ((e = t.call(this)).opened = !1),
            (e.mobileMenu = document.querySelector("#mobile-menu")),
            e
          );
        }
        return (
          a(n, [
            {
              key: "connectedCallback",
              value: function () {
                (window.KercambreHeader = this), this.toggleListener();
              },
            },
            {
              key: "toggle",
              value: function () {
                var e = new CustomEvent("mobileMenu", { detail: this.opened });
                document.dispatchEvent(e);
              },
            },
            {
              key: "toggleListener",
              value: function () {
                var e = this;
                document.addEventListener(
                  "mobileMenu",
                  function (t) {
                    console.log("mobileMenu event", t.detail);
                    var n = "translate-x-0",
                      r = "-translate-x-full";
                    t.detail
                      ? (e.mobileMenu.classList.remove(n),
                        e.mobileMenu.classList.add(r))
                      : (e.mobileMenu.classList.add(n),
                        e.mobileMenu.classList.remove(r)),
                      window.overlay.toggle(),
                      (e.opened = !e.opened);
                  },
                  { passive: !0 }
                ),
                  document
                    .querySelectorAll("[action-toggle-mobileMenu]")
                    .forEach(function (t) {
                      t.addEventListener("click", e.toggle.bind(e), {
                        passive: !0,
                      });
                    }),
                  document
                    .querySelectorAll("[action-toggle-search]")
                    .forEach(function (e) {
                      e.addEventListener("click", function () {
                        document
                          .querySelector("[header-search]")
                          .classList.toggle("!flex");
                      });
                    }),
                  document.querySelector("announcement-kercambre") &&
                  window.addEventListener(
                    "scroll",
                    function () {
                      window.pageYOffset >
                        document.querySelector("announcement-kercambre")
                          .offsetHeight
                        ? (document
                          .querySelector("announcement-kercambre")
                          .classList.add("-translate-y-full"),
                          document
                            .querySelector("announcement-kercambre")
                            .classList.add("!hidden"))
                        : (document
                          .querySelector("announcement-kercambre")
                          .classList.remove("-translate-y-full"),
                          document
                            .querySelector("announcement-kercambre")
                            .classList.remove("!hidden"));
                    },
                    { passive: !0 }
                  );
              },
            },
          ]),
          n
        );
      })(f(HTMLElement));
      customElements.define("header-kercambre", Ne);
      var Re = (function (e) {
        c(n, e);
        var t = _e(n);
        function n() {
          return r(this, n), t.call(this);
        }
        return (
          a(n, [
            {
              key: "connectedCallback",
              value: function () {
                var e = this;
                document.addEventListener("DOMContentLoaded", function () {
                  console.log("DOM entièrement chargé et analysé"),
                    e.initSlider();
                });
              },
            },
            {
              key: "initSlider",
              value: function () {
                var e = this.querySelector(".swiper");
                this.swiper = new je(e, {
                  direction: "vertical",
                  centeredSlides: !0,
                  slidesPerView: 1,
                  loop: !0,
                  navigation: { enabled: !1 },
                  autoplay: { delay: 3e3, disableOnInteraction: !1 },
                });
              },
            },
          ]),
          n
        );
      })(f(HTMLElement));
      function De(e, t, n) {
        return (
          (t = s(t)) in e
            ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
            : (e[t] = n),
          e
        );
      }
      customElements.define("announcement-kercambre", Re);
      var ze = n(551),
        qe = n.n(ze);
      qe().configure({
        prefix: "rv",
        preloadData: !0,
        rootInterface: ".",
        templateDelimiters: ["{", "}"],
        handler: function (e, t, n) {
          this.call(e, t, n.view.models);
        },
      }),
        (qe().formatters.money = function (e) {
          var t;
          return new Intl.NumberFormat("fr-FR", {
            style: "currency",
            currency:
              null !== (t = window.Shopify.currency.active) && void 0 !== t
                ? t
                : "EUR",
            maximumFractionDigits: 0,
          }).format(e / 100);
        }),
        (qe().formatters.moneyFloat = function (e) {
          var t;
          return new Intl.NumberFormat("fr-FR", {
            style: "currency",
            currency:
              null !== (t = window.Shopify.currency.active) && void 0 !== t
                ? t
                : "EUR",
            maximumFractionDigits: 2,
          }).format(e / 100);
        }),
        (qe().formatters.vat = function (e) {
          return parseFloat(parseInt(1.2 * e))
            .toFixed(2)
            .toString();
        }),
        (qe().formatters.currentProperty = function (e, t) {
          return console.log(e, t), t ? t[e] : "TEST";
        }),
        (qe().formatters.getColorName = function (e) {
          var t = e;
          t.includes("Anses") && (t = t.split("-")[1]);
          var n = t
            .replace("Cuir", "")
            .replace("Grained", "")
            .replace("Colored", "")
            .replace("Standard", "")
            .replace("Grainé", "")
            .replace("Couleur", "")
            .replace("Leather", "")
            .replace("Color", "");
          return (
            (n = n.trim()),
            console.log("COLOR IS", n.charAt(0), n.charAt(1), n.charAt(2)),
            n.charAt(0).toUpperCase() + n.slice(1).toLowerCase()
          );
        }),
        (qe().formatters.vatitem = function (e, t) {
          return t.taxable ? parseFloat(1.2 * e) : e;
        }),
        (qe().formatters.totalvat = function (e) {
          for (var t = 0, n = 0; n < e.length; n++) {
            var r = e[n];
            r.title.includes("cadeau") || r.title.includes("Contribution")
              ? (t += r.price * r.quantity)
              : (t += r.price * r.quantity * 1.2);
          }
          return t;
        }),
        (qe().formatters.total = function (e) {
          for (var t = 0, n = 0; n < e.length; n++) {
            t += e[n].line_price;
          }
          return t;
        }),
        (qe().formatters.checkIfExists = function (e) {
          return null != e;
        }),
        (qe().formatters.checkPropKey = function (e, t) {
          return null != e && !!e[t];
        }),
        (qe().formatters.productImage = function (e) {
          return (
            e &&
            (e = (e = e.replace(".jpg", "_200x200_crop_center.jpg")).replace(
              ".png",
              "_200x200_crop_center.png"
            )),
            e
          );
        }),
        (qe().formatters.properties = function (e) {
          var t = [];
          for (var n in e.properties)
            t.push({ name: n, value: e.properties[n] });
          return (
            (t = t.filter(function (e) {
              return !e.name.startsWith("_") && "linked_to" !== e.name;
            })),
            !!t.length && t
          );
        }),
        (qe().formatters.above = function (e, t) {
          return (e = parseInt(e)) > (t = parseInt(t));
        }),
        (qe().formatters.under = function (e, t) {
          return (e = parseInt(e)) < (t = parseInt(t));
        }),
        (qe().formatters.not = function (e) {
          return !e;
        }),
        (qe().formatters.availabilityText = function (e, t, n) {
          return "almostExtinct" === e.inventory_quantity
            ? t
            : "extinct" === e.inventory_quantity
              ? n
              : "";
        }),
        (qe().formatters.sup = function (e, t) {
          return parseInt(e) > parseInt(t);
        }),
        (qe().formatters.equalString = function (e, t) {
          return e === t;
        }),
        (qe().formatters.stringNotNull = function (e) {
          return !!e && "" != e.length;
        }),
        (qe().formatters.includes = function (e, t) {
          return !!e.includes(t);
        }),
        (qe().formatters.handleToUrl = function (e) {
          return "/products/" + e;
        }),
        (qe().formatters.wishlist = function (e) {
          if (e) {
            var t = parseFloat(parseInt(e)).toFixed(2);
            return (
              (t = (t = t.toString()).replace(".", ",")),
              window.Shopify.shop.includes("wholesale") ? t + "€ht" : t + "€"
            );
          }
          return "";
        }),
        (qe().formatters.discountedLinePrice = function (e) {
          return e.original_line_price - (e.total_discount || 0);
        }),
        (qe().formatters.totalDiscounted = function (e) {
          for (var t = 0, n = 0; n < e.length; n++) {
            t += e[n].original_line_price - (e[n].total_discount || 0);
          }
          return t;
        }),
        (qe().formatters.cartProductTitle = function (e) {
          var t = (e && e.product_title) || "";
          return t.includes(" - ") ? t.split(" - ")[0] : t;
        }),
        (qe().formatters.cartVariantTitle = function (e) {
          var t = (e && e.product_title) || "";
          return t.includes(" - ")
            ? t.split(" - ").pop()
            : (e && e.variant_title) || "";
        }),
        (qe().formatters.showVariantTitle = function (e) {
          var t = (e && e.variant_title) || "";
          return !!t && t !== qe().formatters.cartVariantTitle(e);
        });
      var Be = qe();
      function Fe(e) {
        var t = (function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Boolean.prototype.valueOf.call(
                Reflect.construct(Boolean, [], function () { })
              ),
              !0
            );
          } catch (e) {
            return !1;
          }
        })();
        return function () {
          var n,
            r = p(e);
          if (t) {
            var i = p(this).constructor;
            n = Reflect.construct(r, arguments, i);
          } else n = r.apply(this, arguments);
          return d(this, n);
        };
      }
      function He(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function We(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? He(Object(n), !0).forEach(function (t) {
              De(e, t, n[t]);
            })
            : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
              : He(Object(n)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(n, t)
                );
              });
        }
        return e;
      }
      console.log("MINI CART");
      var Ye = (function () {
        function e() {
          var n = this;
          r(this, e),
            (this.opened = !1),
            (this.locale = document.querySelector("html").getAttribute("lang")),
            (this.minicartElement = document.querySelector("#minicart")),
            (this.cartElement = document.querySelector("#cart")),
            fetch("/cart.json").then(
              (function () {
                var e = t(
                  v().mark(function e(t) {
                    return v().wrap(function (e) {
                      for (; ;)
                        switch ((e.prev = e.next)) {
                          case 0:
                            return (e.next = 2), t.json();
                          case 2:
                            (n.cart = e.sent),
                              (n.rview_minicart = Be.bind(n.minicartElement, {
                                cart: n.cart,
                              })),
                              (n.rview_dotCart = Be.bind(
                                document.querySelector("#cart-dot"),
                                { cart: n.cart }
                              )),
                              document.querySelector("#cart") &&
                              (n.rview_cart = Be.bind(n.cartElement, {
                                cart: n.cart,
                              }));
                          case 6:
                          case "end":
                            return e.stop();
                        }
                    }, e);
                  })
                );
                return function (t) {
                  return e.apply(this, arguments);
                };
              })()
            ),
            this.toggleListener();
        }
        var n, i, s, o, l, c, u, d;
        return (
          a(e, [
            {
              key: "toggle",
              value: function () {
                var e = new CustomEvent("minicart", { detail: this.opened });
                document.dispatchEvent(e);
              },
            },
            {
              key: "toggleListener",
              value: function () {
                var e = this;
                document.addEventListener(
                  "minicart",
                  function (t) {
                    var n = "right-0",
                      r = "-right-full";
                    t.detail
                      ? (e.minicartElement.classList.remove(n),
                        e.minicartElement.classList.add(r),
                        e.minicartElement.setAttribute("aria-hidden", "true"))
                      : (e.minicartElement.classList.add(n),
                        e.minicartElement.classList.remove(r),
                        e.minicartElement.setAttribute("aria-hidden", "false")),
                      window.overlay.toggle(),
                      document.querySelector("#dummy-chat-button-iframe") &&
                      document
                        .querySelector("#dummy-chat-button-iframe")
                        .classList.toggle("hidden"),
                      (e.opened = !e.opened);
                  },
                  { passive: !0 }
                ),
                  document
                    .querySelectorAll("[action-toggle-minicart]")
                    .forEach(function (t) {
                      t.addEventListener("click", e.toggle.bind(e), {
                        passive: !0,
                      });
                    });
              },
            },
            {
              key: "cartUpdate",
              value: function () {
                this.rview_minicart.update({ cart: this.cart }),
                  this.rview_dotCart.update({ cart: this.cart }),
                  document.querySelector("#cart") &&
                  this.rview_cart.update({ cart: this.cart });
                // ajout événement cart updated
                document.dispatchEvent(new CustomEvent('cart:updated', {
                  detail: this.cart
                }))
              },
            },
            {
              key: "addItem",
              value:
                ((d = t(
                  v().mark(function e(t, n) {
                    var r,
                      i = arguments;
                    return v().wrap(
                      function (e) {
                        for (; ;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              return (
                                (r =
                                  i.length > 2 && void 0 !== i[2] ? i[2] : {}),
                                document
                                  .querySelector("#minicart-loader")
                                  .classList.remove("hidden"),
                                (e.next = 4),
                                fetch("/cart/add.json", {
                                  method: "POST",
                                  headers: {
                                    "Content-Type": "application/json",
                                    Accept: "application/json",
                                  },
                                  body: JSON.stringify({
                                    id: t,
                                    quantity: n,
                                    properties: r,
                                  }),
                                })
                              );
                            case 4:
                              return (e.next = 6), this.getCart();
                            case 6:
                              (this.cart = e.sent),
                                this.cartUpdate(),
                                document
                                  .querySelector("#minicart-loader")
                                  .classList.add("hidden");
                            case 9:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      this
                    );
                  })
                )),
                  function (e, t) {
                    return d.apply(this, arguments);
                  }),
            },
            {
              key: "getCart",
              value:
                ((u = t(
                  v().mark(function e() {
                    var t;
                    return v().wrap(
                      function (e) {
                        for (; ;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              if ("fr" != this.locale) {
                                e.next = 6;
                                break;
                              }
                              return (e.next = 3), fetch("/cart.json");
                            case 3:
                              (e.t0 = e.sent), (e.next = 9);
                              break;
                            case 6:
                              return (
                                (e.next = 8),
                                fetch("/" + this.locale + "/cart.json")
                              );
                            case 8:
                              e.t0 = e.sent;
                            case 9:
                              if (200 !== (t = e.t0).status) {
                                e.next = 12;
                                break;
                              }
                              return e.abrupt("return", t.json());
                            case 12:
                              throw new Error(
                                "Failed to get request, Shopify returned "
                                  .concat(t.status, " ")
                                  .concat(t.statusText)
                              );
                            case 13:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      this
                    );
                  })
                )),
                  function () {
                    return u.apply(this, arguments);
                  }),
            },
            {
              key: "updateItem",
              value:
                ((c = t(
                  v().mark(function e(t) {
                    return v().wrap(
                      function (e) {
                        for (; ;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              return (
                                document
                                  .querySelector("#minicart-loader")
                                  .classList.remove("hidden"),
                                (e.next = 3),
                                fetch("/cart/change.json", {
                                  method: "POST",
                                  headers: {
                                    "Content-Type": "application/json",
                                    Accept: "application/json",
                                  },
                                  body: JSON.stringify(t),
                                })
                              );
                            case 3:
                              return (e.next = 5), this.getCart();
                            case 5:
                              (this.cart = e.sent),
                                this.cartUpdate(),
                                document
                                  .querySelector("#minicart-loader")
                                  .classList.add("hidden");
                            case 8:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      this
                    );
                  })
                )),
                  function (e) {
                    return c.apply(this, arguments);
                  }),
            },
            {
              key: "updateItemWithoutCallback",
              value:
                ((l = t(
                  v().mark(function e(t) {
                    return v().wrap(
                      function (e) {
                        for (; ;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              return (
                                (e.next = 2),
                                fetch("/cart/change.json", {
                                  method: "POST",
                                  headers: {
                                    "Content-Type": "application/json",
                                    Accept: "application/json",
                                  },
                                  body: JSON.stringify(t),
                                })
                              );
                            case 2:
                              return (e.next = 4), this.getCart();
                            case 4:
                              this.cart = e.sent;
                            case 5:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      this
                    );
                  })
                )),
                  function (e) {
                    return l.apply(this, arguments);
                  }),
            },
            {
              key: "updateItemById",
              value: function (e, t) {
                var n =
                  arguments.length > 2 && void 0 !== arguments[2]
                    ? arguments[2]
                    : {};
                return this.updateItem({ id: e, quantity: t, properties: n });
              },
            },
            {
              key: "updateItemByLine",
              value: function (e, t) {
                var n =
                  arguments.length > 2 && void 0 !== arguments[2]
                    ? arguments[2]
                    : {},
                  r =
                    !(arguments.length > 3 && void 0 !== arguments[3]) ||
                    arguments[3];
                return (
                  console.log("updateItemByLine in Cart"),
                  r
                    ? this.updateItem({ line: e, quantity: t, properties: n })
                    : this.updateItemWithoutCallback({
                      line: e,
                      quantity: t,
                      properties: n,
                    })
                );
              },
            },
            {
              key: "removeItem",
              value:
                ((o = t(
                  v().mark(function e(t) {
                    return v().wrap(
                      function (e) {
                        for (; ;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              return (
                                document
                                  .querySelector("#minicart-loader")
                                  .classList.remove("hidden"),
                                (e.next = 3),
                                fetch("/cart/change.json", {
                                  method: "POST",
                                  headers: {
                                    "Content-Type": "application/json",
                                    Accept: "application/json",
                                  },
                                  body: JSON.stringify(
                                    We(We({}, t), {}, { quantity: 0 })
                                  ),
                                })
                              );
                            case 3:
                              return (e.next = 5), this.getCart();
                            case 5:
                              (this.cart = e.sent),
                                this.cartUpdate(),
                                document
                                  .querySelector("#minicart-loader")
                                  .classList.add("hidden");
                            case 8:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      this
                    );
                  })
                )),
                  function (e) {
                    return o.apply(this, arguments);
                  }),
            },
            {
              key: "removeItemById",
              value: function (e) {
                return this.removeItem({ id: e });
              },
            },
            {
              key: "removeItemByLine",
              value: function (e) {
                return this.removeItem({ line: e });
              },
            },
            {
              key: "clearCart",
              value:
                ((s = t(
                  v().mark(function e() {
                    return v().wrap(
                      function (e) {
                        for (; ;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              return (
                                (e.next = 2),
                                fetch({
                                  method: "POST",
                                  headers: { Accept: "application/json" },
                                })
                              );
                            case 2:
                              return (e.next = 4), this.getCart();
                            case 4:
                              (this.cart = e.sent), this.cartUpdate();
                            case 6:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      this
                    );
                  })
                )),
                  function () {
                    return s.apply(this, arguments);
                  }),
            },
            {
              key: "setCartAttributes",
              value:
                ((i = t(
                  v().mark(function e() {
                    var t,
                      n = arguments;
                    return v().wrap(
                      function (e) {
                        for (; ;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              return (
                                (t =
                                  n.length > 0 && void 0 !== n[0] ? n[0] : {}),
                                (e.next = 3),
                                fetch("/cart/update.json", {
                                  method: "POST",
                                  headers: {
                                    "Content-Type": "application/json",
                                    Accept: "application/json",
                                  },
                                  body: JSON.stringify({ attributes: t }),
                                })
                              );
                            case 3:
                              return (e.next = 5), this.getCart();
                            case 5:
                              (this.cart = e.sent), this.cartUpdate();
                            case 7:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      this
                    );
                  })
                )),
                  function () {
                    return i.apply(this, arguments);
                  }),
            },
            {
              key: "setNote",
              value:
                ((n = t(
                  v().mark(function e(t) {
                    return v().wrap(
                      function (e) {
                        for (; ;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              return (
                                (e.next = 2),
                                fetch("/cart/update.json", {
                                  method: "POST",
                                  headers: {
                                    "Content-Type": "application/json",
                                    Accept: "application/json",
                                  },
                                  body: JSON.stringify({ note: t }),
                                })
                              );
                            case 2:
                              return (e.next = 4), this.getCart();
                            case 4:
                              (this.cart = e.sent), this.cartUpdate();
                            case 6:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      this
                    );
                  })
                )),
                  function (e) {
                    return n.apply(this, arguments);
                  }),
            },
          ]),
          e
        );
      })();
      window.KercambreCart = new Ye();
      var Ge = (function (e) {
        c(s, e);
        var n,
          i = Fe(s);
        function s() {
          var e;
          return (
            r(this, s),
            (e = i.call(this))
              .querySelector("[action-trigger")
              .addEventListener("click", e.removeLineItem.bind(u(e)), {
                passive: !0,
              }),
            e
          );
        }
        return (
          a(s, [
            {
              key: "removeLineItem",
              value:
                ((n = t(
                  v().mark(function e() {
                    var t, n, variantIdToRemove;
                    return v().wrap(
                      function (e) {
                        for (; ;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              return (
                                (t = parseInt(
                                  this.querySelector("span").textContent
                                )),
                                window.KercambreCart.cart.items[t].properties &&
                                1 ==
                                window.KercambreCart.cart.items[t]
                                  .properties._offered &&
                                ((n =
                                  window.KercambreCart.cart.items[t]
                                    .product_id),
                                  localStorage.setItem(
                                    "neveutpasducadeau",
                                    n.toString()
                                  )),
                                // Stocker le variant_id pour supprimer les personnalisations après
                                (variantIdToRemove = window.KercambreCart.cart.items[t].variant_id),
                                (e.next = 1),
                                window.KercambreCart.removeItemByLine(t + 1)
                              );
                            case 1:
                              // Supprimer les personnalisations liées
                              window.KercambreCart.cart.items.forEach(function (
                                item,
                                index
                              ) {
                                item.properties &&
                                  item.properties.linked_to === variantIdToRemove &&
                                  window.KercambreCart.removeItemByLine(
                                    index + 1
                                  );
                              }),
                                (e.next = 2);
                            case 2:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      this
                    );
                  })
                )),
                  function () {
                    return n.apply(this, arguments);
                  }),
            },
          ]),
          s
        );
      })(f(HTMLElement));
      customElements.define("removelineitem-kercambre", Ge);
      var Xe = (function (e) {
        c(s, e);
        var n,
          i = Fe(s);
        function s() {
          var e;
          return (
            r(this, s),
            (e = i.call(this))
              .querySelector("select")
              .addEventListener("change", e.updateLineItem.bind(u(e)), {
                passive: !0,
              }),
            e
          );
        }
        return (
          a(s, [
            {
              key: "updateLineItem",
              value:
                ((n = t(
                  v().mark(function e() {
                    var t, n, r, i, variantIdUpdated, customItemsToSync, syncPromises;
                    return v().wrap(
                      function (e) {
                        for (; ;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              return (
                                (t = parseInt(
                                  this.querySelector("span").textContent
                                )),
                                (n = window.KercambreCart.cart.items[t]),
                                (r = parseInt(
                                  this.querySelector("select").value
                                )),
                                (i = n.properties),
                                console.log("🔧 [DEBUG] Item index:", t),
                                console.log("🔧 [DEBUG] Item:", n),
                                console.log("🔧 [DEBUG] New quantity:", r),
                                // Stocker le variant_id pour synchroniser les personnalisations après
                                (variantIdUpdated = n.variant_id),
                                console.log("🔧 [DEBUG] Variant ID to sync:", variantIdUpdated),
                                // Collecter les articles personnalisés liés AVANT la mise à jour
                                (customItemsToSync = []),
                                window.KercambreCart.cart.items.forEach(function (
                                  item,
                                  index
                                ) {
                                  console.log("🔧 [DEBUG] Checking item", index, "linked_to:", item.properties ? item.properties.linked_to : "no properties");
                                  if (item.properties &&
                                    item.properties.linked_to === variantIdUpdated) {
                                    console.log("✅ [DEBUG] Found custom item to sync at index", index);
                                    customItemsToSync.push({
                                      lineNumber: index + 1,
                                      properties: item.properties
                                    });
                                  }
                                }),
                                console.log("🔧 [DEBUG] Custom items to sync:", customItemsToSync.length),
                                t++,
                                (e.next = 12),
                                window.KercambreCart.updateItemByLine(t, r, i)
                              );
                            case 12:
                              // Synchroniser les personnalisations liées
                              console.log("🔧 [DEBUG] Starting synchronization of", customItemsToSync.length, "items");
                              if (!(customItemsToSync.length > 0)) {
                                e.next = 18;
                                break;
                              }
                              // Créer un tableau de promesses pour toutes les mises à jour
                              syncPromises = customItemsToSync.map(function (customItem) {
                                console.log("🔧 [DEBUG] Syncing line", customItem.lineNumber, "to quantity", r);
                                // Mettre à jour la quantité sans callback pour éviter les boucles
                                return window.KercambreCart.updateItemByLine(
                                  customItem.lineNumber,
                                  r,
                                  customItem.properties,
                                  false
                                );
                              });

                              // Attendre que toutes les mises à jour soient terminées
                              console.log("🔧 [DEBUG] Waiting for all sync promises");
                              (e.next = 16);
                              return Promise.all(syncPromises);
                            case 16:
                              // Rafraîchir le panier manuellement après avoir synchronisé tous les articles
                              console.log("🔧 [DEBUG] Refreshing cart after sync");
                              (e.next = 18);
                              return window.KercambreCart.getCart();
                            case 18:
                              if (customItemsToSync.length > 0) {
                                window.KercambreCart.cart = e.sent;
                                window.KercambreCart.cartUpdate();
                                console.log("🔧 [DEBUG] Cart refreshed!");
                              }
                            case 19:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      this
                    );
                  })
                )),
                  function () {
                    return n.apply(this, arguments);
                  }),
            },
          ]),
          s
        );
      })(f(HTMLElement));
      customElements.define("updatelineitem-kercambre", Xe);
      var Ue = (function (e) {
        c(n, e);
        var t = Fe(n);
        function n() {
          return r(this, n), t.call(this);
        }
        return (
          a(n, [
            {
              key: "connectedCallback",
              value: function () {
                this.handler(this.dataset.amount);
              },
            },
            {
              key: "disconnectedCallback",
              value: function () {
                document.querySelector("[product-free-shipping]") &&
                  (document.querySelector("[product-free-shipping]").innerText =
                    document.querySelector(
                      "[product-free-shipping]"
                    ).dataset.text);
              },
            },
            {
              key: "setPageShipping",
              value: function (e) {
                document.querySelector("[product-free-shipping]").innerText = e;
              },
            },
            {
              key: "handler",
              value: function (e) {
                var t = this;
                Be.binders.class = function (n, r) {
                  var i = 0;
                  if (r && r.items) {
                    i = r.items.reduce(function (acc, item) {
                      return item.gift_card || item.product_type === "Carte cadeau" || item.product_type === "Gift Card" ? acc : acc + item.final_line_price;
                    }, 0) / 100;
                  } else {
                    i = parseInt(r) / 100;
                  }
                  var s = new Intl.NumberFormat("fr-FR", {
                    style: "currency",
                    currency: "EUR",
                    maximumFractionDigits: 0,
                  }).format(e - i),
                    o = ((i / e) * 100).toFixed(0),
                    l = i >= parseFloat(e);
                  (n.style.width = o + "%"),
                    t.toggleShippingDetails(l),
                    l
                      ? ((t.querySelector("p").innerText = t.freeShipping()),
                        document.querySelector("[product-free-shipping]") &&
                        t.setPageShipping(t.dataset.textValid))
                      : ((t.querySelector("p").innerText = t.noFreeShipping(s)),
                        document.querySelector("[product-free-shipping]") &&
                        t.setPageShipping(
                          document.querySelector("[product-free-shipping]")
                            .dataset.text
                        ));
                };
              },
            },
            {
              key: "toggleShippingDetails",
              value: function (e) {
                var t = this.querySelector("[fs-gauge]"),
                  n = (this.parentElement || document).querySelector(
                    "[estimated-shipping-row]"
                  );
                t && (t.style.display = e ? "none" : ""),
                  n && (n.style.display = e ? "none" : ""),
                  this.classList.toggle("fs-valid", e);
              },
            },
            {
              key: "freeShipping",
              value: function () {
                return (
                  document
                    .querySelector("#estimated-shipping-price #shippingSpan")
                    .classList.add("line-through", "text-warning"),
                  this.dataset.textValid
                );
              },
            },
            {
              key: "noFreeShipping",
              value: function (e) {
                return (
                  document
                    .querySelector("#estimated-shipping-price #shippingSpan")
                    .classList.remove("line-through", "text-warning"),
                  this.dataset.textUnvalid.replace("{value}", e)
                );
              },
            },
          ]),
          n
        );
      })(f(HTMLElement));
      customElements.define("progressbar-kercambre", Ue);
      var Ve = n(840),
        Ke = n.n(Ve);
      function Je(e, t) {
        var n =
          ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
          e["@@iterator"];
        if (!n) {
          if (
            Array.isArray(e) ||
            (n = (function (e, t) {
              if (!e) return;
              if ("string" == typeof e) return Qe(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              "Object" === n && e.constructor && (n = e.constructor.name);
              if ("Map" === n || "Set" === n) return Array.from(e);
              if (
                "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              )
                return Qe(e, t);
            })(e)) ||
            (t && e && "number" == typeof e.length)
          ) {
            n && (e = n);
            var r = 0,
              i = function () { };
            return {
              s: i,
              n: function () {
                return r >= e.length
                  ? { done: !0 }
                  : { done: !1, value: e[r++] };
              },
              e: function (e) {
                throw e;
              },
              f: i,
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        }
        var s,
          o = !0,
          a = !1;
        return {
          s: function () {
            n = n.call(e);
          },
          n: function () {
            var e = n.next();
            return (o = e.done), e;
          },
          e: function (e) {
            (a = !0), (s = e);
          },
          f: function () {
            try {
              o || null == n.return || n.return();
            } finally {
              if (a) throw s;
            }
          },
        };
      }
      function Qe(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function Ze(e) {
        var t = (function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Boolean.prototype.valueOf.call(
                Reflect.construct(Boolean, [], function () { })
              ),
              !0
            );
          } catch (e) {
            return !1;
          }
        })();
        return function () {
          var n,
            r = p(e);
          if (t) {
            var i = p(this).constructor;
            n = Reflect.construct(r, arguments, i);
          } else n = r.apply(this, arguments);
          return d(this, n);
        };
      }
      var et = (function (e) {
        c(o, e);
        var n,
          i,
          s = Ze(o);
        function o() {
          var e;
          return (
            r(this, o),
            ((e = s.call(this)).product = null),
            (e.image1 = null),
            (e.image2 = null),
            (e.offset = 0),
            (e.position = 0),
            e
          );
        }
        return (
          a(o, [
            {
              key: "connectedCallback",
              value: function () {
                var e = this;
                this.initCP();
                var t = new (Ke())(this, { touchAction: "auto" });
                t.get("pan").set({ direction: Ke().DIRECTION_ALL }),
                  t.on("panup pandown", function (e) { }),
                  t.on("panright", function (t) {
                    if (t.isFinal && t.isFinal && e.position > 0) {
                      var n = parseInt(
                        e.pastilles[e.position - 1].getAttribute("data-rank")
                      );
                      (e.position -= 1), e.selectBullet(n);
                    }
                  }),
                  t.on("panleft", function (t) {
                    if (t.isFinal && t.isFinal && e.position < e.max - 1) {
                      var n = parseInt(
                        e.pastilles[e.position + 1].getAttribute("data-rank")
                      );
                      (e.position += 1), e.selectBullet(n);
                    }
                  });
              },
            },
            {
              key: "findIndexOf",
              value: function (e) {
                for (
                  var t = e.parentNode.querySelectorAll("li[data-rank]"), n = 0;
                  n < t.length;
                  n++
                )
                  if (t[n] == e) return n;
              },
            },
            {
              key: "initCP",
              value: function () {
                var e = this;
                (this.pastilles =
                  this.querySelectorAll("li[data-rank]") || null),
                  (this.max = this.pastilles.length || 0),
                  this.max > 0 &&
                  (this.querySelectorAll("li").forEach(function (n) {
                    n.addEventListener(
                      "click",
                      t(
                        v().mark(function t() {
                          var r;
                          return v().wrap(function (t) {
                            for (; ;)
                              switch ((t.prev = t.next)) {
                                case 0:
                                  (r = parseInt(n.getAttribute("data-rank"))),
                                    (e.position = e.findIndexOf(n)),
                                    e.selectBullet(r);
                                case 3:
                                case "end":
                                  return t.stop();
                              }
                          }, t);
                        })
                      ),
                      { passive: !0 }
                    );
                  }),
                    this.querySelector("[action-next]").addEventListener(
                      "click",
                      function () {
                        if (e.position < e.max - 1) {
                          var t = parseInt(
                            e.pastilles[e.position + 1].getAttribute(
                              "data-rank"
                            )
                          );
                          (e.position += 1), e.selectBullet(t);
                        }
                      },
                      { passive: !0 }
                    ),
                    this.querySelector("[action-prev]").addEventListener(
                      "click",
                      function () {
                        if (e.position > 0) {
                          var t = parseInt(
                            e.pastilles[e.position - 1].getAttribute(
                              "data-rank"
                            )
                          );
                          (e.position -= 1), e.selectBullet(t);
                        }
                      },
                      { passive: !0 }
                    ));
                var n = 0,
                  r = new URL(window.location.href),
                  i = "",
                  s = "";
                if (r.searchParams.has("filter.v.option.coloris"))
                  (i = window.KercambreTheme.handleize(
                    r.searchParams.getAll("filter.v.option.coloris")[
                    r.searchParams.getAll("filter.v.option.coloris").length -
                    1
                    ]
                  )),
                    (i = this.getColorName(i)),
                    (n = this.findRankFromColorName(i));
                else if (
                  "fr" == Shopify.locale &&
                  this.dataset.productTags.includes("initialisationCouleur")
                )
                  (s = this.dataset.productTags
                    .split("initialisationCouleur:")[1]
                    .split("|")[0]),
                    (i = this.getColorName(s)),
                    (n = this.findRankFromColorName(i));
                else if (
                  "en" == Shopify.locale &&
                  this.dataset.productTags.includes("initColor")
                )
                  (s = this.dataset.productTags
                    .split("initColor:")[1]
                    .split("|")[0]),
                    (i = this.getColorName(s)),
                    (n = this.findRankFromColorName(i));
                else if (this.pastilles.length > 1) {
                  var o =
                    this.pastilles[
                    this.generateRandomIntegerInRange(1, this.max - 1)
                    ];
                  (n = parseInt(o.getAttribute("data-rank"))),
                    (this.position = this.findIndexOf(o));
                }
                this.selectBullet(n);
              },
            },
            {
              key: "getColorName",
              value: function (e) {
                for (
                  var t = 0,
                  n = [
                    "cuir",
                    "grained",
                    "colored",
                    "graine",
                    "couleur",
                    "standard",
                    "leather",
                    "color",
                  ];
                  t < n.length;
                  t++
                ) {
                  var r = n[t];
                  e = e.replace(new RegExp(r, "gi"), "");
                }
                return (
                  (e = e.replace(/^-+|-+$/g, "")),
                  console.log("STEP 1 : ", e),
                  console.log("VARIANT OPTION COLOR NAME", e),
                  e.trim()
                );
              },
            },
            {
              key: "generateRandomIntegerInRange",
              value: function (e, t) {
                return Math.floor(Math.random() * (t - e + 1)) + e;
              },
            },
            {
              key: "selectBullet",
              value:
                ((i = t(
                  v().mark(function e(t) {
                    var n, r;
                    return v().wrap(
                      function (e) {
                        for (; ;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              if (this.product) {
                                e.next = 7;
                                break;
                              }
                              return (
                                (n = (n =
                                  this.dataset.url.split("?")[0]).includes(
                                    ".js"
                                  )
                                  ? n
                                  : n + ".js"),
                                (e.next = 5),
                                w.get(n)
                              );
                            case 5:
                              (r = e.sent), (this.product = r.data);
                            case 7:
                              this.updateCollectionProductBasedOnSelectedBullet(
                                t
                              ),
                                this.product.variants.length > 1 &&
                                "true" == this.dataset.cuir &&
                                this.transformList(),
                                this.querySelectorAll("li").forEach(function (
                                  e
                                ) {
                                  e.classList.remove("active");
                                }),
                                this.product.variants.length > 1 &&
                                "true" == this.dataset.cuir &&
                                this.querySelector(
                                  'li[data-rank="'.concat(t, '"]')
                                ).classList.add("active");
                            case 11:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      this
                    );
                  })
                )),
                  function (e) {
                    var self = this;
                    // Si le fetch du .js échoue (réseau, throttling Shopify), on laisse
                    // en place le rendu Liquid plutôt que de bloquer la carte sur le loader.
                    return i.apply(this, arguments).catch(function (err) {
                      console.error(
                        "[collection-product] selectBullet failed for",
                        self.dataset.url,
                        err
                      );
                      self.classList.remove("loading");
                      var wheel = self.querySelector(".loader-wheel");
                      wheel && wheel.classList.add("hidden");
                      var img1 = self.querySelector(".image1");
                      img1 && img1.classList.remove("opacity-0");
                    });
                  }),
            },
            {
              key: "transformList",
              value: function () {
                this.querySelector("ul").style.transform =
                  "translateX(-".concat(30 * this.position - 30, "px)");
              },
            },
            {
              key: "updateCollectionProductBasedOnSelectedBullet",
              value: function (e) {
                var t, n, r;
                if (
                  (console.log(
                    "this product variants",
                    this.product.variants,
                    e
                  ),
                    this.product.variants.length > 1 &&
                    "true" == this.dataset.cuir)
                ) {
                  var i,
                    s = this.querySelector(
                      'li[data-rank="'.concat(e, '"]')
                    ).getAttribute("data-value"),
                    o = Je(this.product.variants);
                  try {
                    for (o.s(); !(i = o.n()).done;) {
                      var a = i.value;
                      if (a.title.includes(s) && a.available) {
                        t = a;
                        break;
                      }
                    }
                  } catch (e) {
                    o.e(e);
                  } finally {
                    o.f();
                  }
                  (!t || !t.available) &&
                    (t = this.product.variants.find(function (e) {
                      return e.available;
                    }));
                  (!t) &&
                    (t = this.product.variants.find(function (e) {
                      return e.title.includes(s);
                    }) || this.product.variants[0]);
                } else t = this.product.variants[0];
                console.log("match_variant", t, this.product);

                // Récupère la valeur de `data-color` depuis l'élément `[ker-v-title]`
                let titleElement = this.querySelector("[ker-v-title]");
                let filteredColor = titleElement ? titleElement.dataset.color : "";

                // Condition spécifique aux BRACELETS
                if (this.product.type === "BRACELET") {
                  titleElement.innerHTML = this.product.title.includes("-")
                    ? this.product.title.split("-")[1]
                    : this.product.title;
                }
                // Condition pour les produits avec une seule option "Taille"
                else if (
                  this.product.options.length === 1 &&
                  (this.product.options[0].name === "Taille" || this.product.options[0].name === "Size")
                ) {
                  titleElement.innerHTML = "";
                }
                // Condition pour les produits avec un seul variant par défaut
                else if (this.product.variants.length < 2 && t.title.includes("Default")) {
                  titleElement.innerHTML = "";
                }
                // Cas général : Affichage de filteredColor ou fallback sur option1
                else {
                  titleElement.innerHTML = filteredColor
                    ? filteredColor
                    : t.option1
                      .replace("Cuir", "")
                      .replace("Grained", "")
                      .replace("Colored", "")
                      .replace("Grainé", "")
                      .replace("Standard", "")
                      .replace("Couleur", "")
                      .replace("Color", "")
                      .replace("Leather", "");
                }

                // Mise à jour du prix
                let priceElement = this.querySelector("[ker-v-price]");
                if (priceElement) {
                  let n = t.price;
                  let r = window.Shopify.currency.active || "EUR";
                  priceElement.innerHTML = new Intl.NumberFormat("fr-FR", {
                    style: "currency",
                    currency: r,
                    maximumFractionDigits: 0
                  }).format(n / 100);
                }
                var l = this.querySelector("[product-url]"),
                  _u = new URL(l.getAttribute("href").split("?variant=")[0], window.location.origin);
                _u.searchParams.set("variant", t.id);
                var c = _u.href;
                if (
                  (l.setAttribute("href", c),
                    this.querySelector("[product-infos]").setAttribute("href", c),
                    t.featured_media)
                ) {
                  var u = t.featured_media.position,
                    d = this.product.media[u - 1],
                    p = this.product.media[u],
                    h = this.querySelector(".image1"),
                    f = this.querySelector(".image2");
                  if ((this.updateImage(h, d), p || this.updateImage(f, d), p))
                    this.product.variants.find(function (e) {
                      var t;
                      return (
                        (null === (t = e.featured_media) || void 0 === t
                          ? void 0
                          : t.id) == p.id
                      );
                    })
                      ? this.updateImage(f, d)
                      : this.updateImage(f, p);
                  h.classList.remove("opacity-0");
                } else {
                  var m = this.querySelector(".image1");
                  this.updateImage(m, this.product.media[0]),
                    m.classList.remove("opacity-0");
                }
                t.available
                  ? this.querySelector("[tag-not-available]").classList.add(
                    "hidden"
                  )
                  : this.querySelector("[tag-not-available]").classList.remove(
                    "hidden"
                  ),
                  this.classList.remove("loading");
              },
            },
            {
              key: "updateImage",
              value:
                ((n = t(
                  v().mark(function e(t, n) {
                    var r, i;
                    return v().wrap(
                      function (e) {
                        for (; ;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              // Rien à mettre à jour si l'image cible n'existe pas
                              // (ex. .image2 absente sur un produit mono-média) :
                              // on saute à l'état terminal au lieu de déréférencer null.
                              if (!t) {
                                e.next = 8;
                                break;
                              }
                              return (
                                this.querySelector(
                                  ".loader-wheel"
                                ).classList.remove("hidden"),
                                (t.style.visibility = "hidden"),
                                null != (null == n ? void 0 : n.alt) &&
                                t.setAttribute("alt", n.alt),
                                null != (null == n ? void 0 : n.src) &&
                                ((r = "".concat(n.src)),
                                  t.setAttribute("src", r),
                                  (i = ""
                                    .concat(n.src, "&width=240 240w, ")
                                    .concat(n.src, "&width=360 360w, ")
                                    .concat(n.src, "&width=480 480w, ")
                                    .concat(n.src, "&width=540 540w, ")
                                    .concat(n.src, "&width=600 600w, ")
                                    .concat(n.src, "&width=800 800w")),
                                  t.setAttribute("srcset", i)),
                                (e.next = 6),
                                new Promise(function (e) {
                                  t.onload = e;
                                })
                              );
                            case 6:
                              (t.style.visibility = "visible"),
                                this.querySelector(
                                  ".loader-wheel"
                                ).classList.add("hidden");
                            case 8:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      this
                    );
                  })
                )),
                  function (e, t) {
                    return n.apply(this, arguments);
                  }),
            },
            {
              key: "findRankFromColorName",
              value: function (e) {
                var t = this.querySelector(
                  "li [data-color-name$=".concat(e, "]")
                );
                return (
                  (this.position = this.findIndexOf(t)),
                  parseInt(t.getAttribute("data-rank"))
                );
              },
            },
          ]),
          o
        );
      })(f(HTMLElement));
      function tt(e) {
        var t = (function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Boolean.prototype.valueOf.call(
                Reflect.construct(Boolean, [], function () { })
              ),
              !0
            );
          } catch (e) {
            return !1;
          }
        })();
        return function () {
          var n,
            r = p(e);
          if (t) {
            var i = p(this).constructor;
            n = Reflect.construct(r, arguments, i);
          } else n = r.apply(this, arguments);
          return d(this, n);
        };
      }
      customElements.define("kercambre-collectionproduct", et),
        console.log("LAYOUT THEME JS");
      var nt = (function (e) {
        c(s, e);
        var n,
          i = tt(s);
        function s() {
          var e;
          return r(this, s), ((e = i.call(this)).properties = {}), e;
        }
        return (
          a(s, [
            {
              key: "connectedCallback",
              value: function () {
                var e = this;
                // Éviter d'ajouter plusieurs listeners si connectedCallback est appelé plusieurs fois
                if (this._listenerAdded) {
                  console.log("🔍 [DEBUG] Listener already added, skipping for variant:", this.dataset.variantId);
                  return;
                }
                this._listenerAdded = true;
                console.log("🔍 [DEBUG] quick-addtocart connectedCallback called for variant:", this.dataset.variantId);
                this.addEventListener("click", function () {
                  console.log("🔍 [DEBUG] quick-addtocart click event triggered for variant:", e.dataset.variantId);
                  e.addToCart();
                });
              },
            },
            {
              key: "addToCart",
              value:
                ((n = t(
                  v().mark(function e() {
                    return v().wrap(
                      function (e) {
                        for (; ;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              console.log("🔍 [DEBUG] addToCart called for variant:", this.dataset.variantId);
                              return (
                                (e.next = 3),
                                window.KercambreCart.addItem(
                                  this.dataset.variantId,
                                  1,
                                  this.properties
                                )
                              );
                            case 3:
                            case "end":
                              return e.stop();
                          }
                      },
                      e,
                      this
                    );
                  })
                )),
                  function () {
                    return n.apply(this, arguments);
                  }),
            },
          ]),
          s
        );
      })(f(HTMLElement));
      customElements.define("quick-addtocart-kercambre", nt);
    })();
})();

